import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from 'src/app/services/app.service';
import { Component, OnInit, ChangeDetectorRef, ViewChild, LOCALE_ID, ViewChildren, QueryList, ChangeDetectionStrategy, OnDestroy, EventEmitter } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CourrierDialog } from '../dialog-courrier/dialog-courrier.component';
import { CustomerService } from 'src/app/services/customer.service';
import { DialogCommonError } from '../dialogs-errors/dialog-common-error.component';
import { DialogCommonMessage } from '../dialogs-messages/dialog_common_message.component';
import { DialogCredits } from '../dialog-credits/dialog-credits.component';
import { DialogHTML } from '../dialogs-html/dialog-html.component';
import { DialogQuestionMessage } from '../dialogs-question/dialog-question-message.component';
// import { DialogSalRefDetail } from '../dialog-salref-detail/dialog-salref-detail.component';
import { DialogSalRefDetailDirect } from '../dialog-salref-detail-direct/dialog-salref-detail-direct.component';
import { DialogsErrorsComponent } from '../dialogs-errors/dialogs-errors.component';
import { DialogsLoadingComponent } from '../dialogs-loading/dialogs-loading.component';
import { EntrepriseInfoDialog } from '../dialog-entreprise/dialog-entreprise-info.component';
import { environment } from 'src/environments/environment';
import { first } from 'rxjs/operators';
import { formatDate } from '@angular/common';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { InstructionDialog } from '../dialogs-instruction/instruction-dialog.component';
import { LoaderService } from 'src/app/services/loader.service';
import { LoginComponent } from '../../partials/login/login.component';
import { MailService } from 'src/app/services/mail.service';
import { MAT_STEPPER_GLOBAL_OPTIONS } from '@angular/cdk/stepper';
import { MatDialog, MatStepper, MatStep } from '@angular/material';
import { MessConfirmAbandon } from '../dialogs-messages/mess_confirmabandon_dialog.component';
import { PayslipCollection } from 'src/app/classes/dossier/payslip-collection';
import { PayslipService } from 'src/app/services/Dossier/payslip.service';
import { RapportDialog } from '../dialogs-rapport/rapport-dialog.component';
import { ReadDocumentsComponent } from '../dossier/read-documents/read-documents.component';
import { resolve } from 'url';
import { ShowFileDialog } from '../dialogs-show-file/show-file-dialog.component';
import { ShowMultipleFilesDialog } from '../dialogs-show-file/show-multiple-files-dialog.component';
import { map, startWith, pairwise } from 'rxjs/operators';
import { StateService } from 'src/app/services/states.service';
import { Subject, Observable } from 'rxjs';
import { SvgToggleComponent } from '../svg-toggle/svg-toggle.component';
import { Title } from "@angular/platform-browser";
import * as _ from 'lodash';
import { DialogsInitPayslipComponent } from '../dialogs-init-payslip/dialogs-init-payslip.component';
import { DossierTabIdentityComponent } from 'src/app/partials/dossier-tab-identity/dossier-tab-identity.component';

@Component({
    selector: 'app-dossier-post',
    templateUrl: './dossier-post.component.html',
    styleUrls: ['./dossier-post.component.scss', '../rapports.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
        provide: MAT_STEPPER_GLOBAL_OPTIONS, useValue: { displayDefaultIndicatorType: false }
        }, 
    ],
})
export class DossierPostComponent implements OnInit, OnDestroy {
    
    @ViewChild('stepper', {static : true}) private myStepper: MatStepper;
    @ViewChildren('svgToggle') private svgToggles:QueryList<SvgToggleComponent>;
    @ViewChild("svgToggleAddBS", {static : false}) svgToggleAddBS: Component;
    @ViewChild(DossierTabIdentityComponent, {static: false}) tabIdentity: DossierTabIdentityComponent;
    user: any;
    disabled:boolean = false;
    credquantite: any;
    dossier: any;
    fragments: any;
	
    payslipCollection: PayslipCollection;
    payslipsMonthsLength: number;
    dateParamsForPayslips;
    dataSalFormGroup: FormGroup;
    dataEmpFormGroup: FormGroup;
    dataUpdateDossFormGroup : FormGroup;

    dataCTFormGroup: FormGroup;
    dataContratTravailBlock: {};
    listAvenant : Array<Object> = [];
    nbAvenant = 1;
    principeCalcul = 0;
    qualificationCTList;
    qualificationInput;
    inputTogglePOSTQualifSal;

    userHasUploadedFiles = false;
    paramsCT;
    contratTravailVisible = true;
    unitedata;
    listUniteTravail = [
        {
            "value" : "HS",
            "nom" : "Heures / Semaine",
            "selected" : false,
        },
        {
            "value" : "HA",
            "nom" : "Forfait Heures Annuel",
            "selected" : false,
        },
        {
            "value" : "JA",
            "nom" : "Forfait Jours Annuel",
            "selected" : false,
        },
    ];

    subscribe: any =[];
    diagnostic:any = false;
    simulation:any = false;
    dateStringSoldeToutCompte = "";

    fichiersBS: any;
    newBs: any = [];
    waiting: number =0;
    dataSalBlock:{};
    dataEmpBlock:{};
    dataCtBlock: {};
    // dataUpdateDossBlock: {};
    dataStep:number = 1;
    calcul: boolean = false;
    origin: any = window.location.origin;
    // currentCalcul: FormControl = new FormControl("");
    // fifthFormGroup: FormGroup;
    // iframeFormGroup: Array<FormGroup>;
    BOCC_URL: string = environment.BOCC_URL;
    tokencalc: string = environment.tokencalc;
    motifs: any;
    droitSpec: any;
    trancheEffectif: any;
    effectifTranches;
    trancheEffectifEtab: any;
    forfait: any;
    optionQualif: any = [];
    optionNiv: any = [];
    optionEch: any = [];
    optionQualite: any = [];
    erreurperiode: any;
    message: any;
    erreur: any;
    datefirstbsdebut: any;
    datelastbsfin: any;
    strICL: any = 0;
    strICLComp: any = 0;
    strContentieux: any = 0;
    areAllocNet:any = null;
    boolProcedure: boolean = false;
    isAREApplicable: boolean = false;
    salRefRuptPartiel: boolean = false;
    strAnciennete: string;
    saveRapportOk: boolean = false;
    rapportStep:number = 0;
    messageError: string = "";
    constantes: any;
    firstTime: number = 0;
    currentCalculette: any = {'code': null};
    required: any[];
    missingBS : any = [];
    salaireRefRuptureLegal;
    salaireRef : string;
    salaireRefNaN : boolean = false;
    sdcCumul : any;
    sdcCumulBS : any;
    isICCP: boolean = false;
    iccpMnTotal : any;
    iccpMnNbIccp : any;
    messageImprim: string;
    qualifSelect: any;
    echSelect: any;
    qualiteSelect: any;
    nivSelect: any;
    needInputs: any;
    nivEnable: any;
    echEnable: any;
    nbMoisBsOk: number;
    nbBsPrincipaux: number;
    nameRapport: string;
    nbEvent: any;
    promise: any = [];
    name: string;
    datedebperiode: Date;
    datefinperiode: Date;
    nbMoisPeriode: number = 0;
    libelleCC: String = "Application du droit du travail";
    idDossier: any;
    libellAndToolTip:any= [];
    /* COB-5637 : sources des libellés, conservées séparément (cf. applyLibelleCC) */
    libellDictionnaire:any = {};
    libelleCCparam:any = {};
    stringDateLeaving: string;

    imgs:any =  new Array();
    numberToUpload:number = 0;
    numberUploaded:number = 0;
    effect_etab_error: boolean;
    delaiCarenceARE: any = null;
    firTotal:any = {
        mnt_brut : 0,
        mnt_net_social : 0,
        mnt_net_fiscal : 0,
        mnt_emp : 0,
    }
    paramRupt: string;
    errorHandlingMessage:string = ''
    jsonCalculette: any;
    indem_min_txt: string = '';
    list_SECTEUR : Array<Object> = [];
    territoireMatch: string;
    getCCparamFinished : boolean = false;
    choice_cc: any;
    nb_displayed_synd_sign: number = 3;
    ccAsk_BOOL_DR_ANC_AUTRE_QUALIF: boolean = false;
    ccAsk_DR_PRES_SOC_CC: boolean = false;
    need_bool_adh_synd_signataire: boolean = false;
    need_cp_type_calc: boolean = false;
    cp_type_calc: any;
    echelonIsUsed: boolean = false;
    qualiteIsUsed: boolean = false;
    niveauIsUsed: boolean = false;
    coeffIsUsedCC: boolean = false;
    coeffIsUsedClassif: boolean = false;
    json_cc_data: any;
    disableLeave: boolean = false;
    directAccessToResultats: boolean = false;
    // nextStepButtonText = ""
    // nextStepIsResult: boolean = false;
    dialogLoading = null
    now = Date.now()
    rapports: any;
    // calculNames: Array<string> = [];
    // calcsAreDone = false;
    suivantUploadDisabled: boolean = false;
    //hideRapport: Array<string> = [];
    titreAdditionalButton: string = "";
    showAdditionalButton: boolean = false;
    callbackAdditionalButton: string = "";
    disabledAdditionalButton:boolean = false;
    rapportSelected: any = [];
    syntheseGeneree: any = null; // synthèse tout juste générée par createRapports : affichée une fois sans être redemandée au back
    rapportPrecharge: any = null;
    calculettesInStepper: Array<any> = [];
    stepResult: number = 2;
    actionStepTriggerManually: boolean = false;
    changedFields: any = {};
    // changedFieldsComplete: any = {};
    forceDisplayStep: any = false;
    forceDisplayStepFrom: any = false;
    maxStateSteps: any = {};
    helperOn: boolean = true;
    consumeToken: boolean = true;
    delegationToken: string;
    delegationTokenIsValid: boolean = false;
    toDelegate: boolean = false;
    isDelegationDone: boolean = false;
    canStartDelegation: boolean = false;
    delegationTokenExpirationDate: Date = null;
    company: string;
    clientName: string;
    fillDelegationForm: boolean = false;
    delegatedDossier: object;
    titles = {
        "maitre" : "Maître",
        "madame" : "Madame",
        "monsieur" : "Monsieur"
    };
    clientTitle: string;
    bggrey:boolean = true;
    abonnement:any ={'active_subscription': false};
    isCredConsume: string = 'credit';
    credits: any = [];
    codeCoupon:string = '';
    couponId:number = null;
    reloadDocuments: Subject<any> = new Subject<any>();
    submitToCobham = false;
    firstFormGroup: FormGroup;
    
    entrepriseInfo;
    contrats: any = [];
    dateErr: any = [];
    dateDebutBs;
    dateFinBs;
    allOptionsIDCC: any = [];
    optionsIDCC: any = [];
    filteredIDCC: Observable<any>;
    messageCoeffIncoherent: string = "";
    messageCoeffModified: string = "";
    typeCoeff: string = "text";

    tokenauth = "";

    motifRuptureEntete = {
        "LicPers" : false,
        "LicEco" : false,
        "RC" : false,
        "DR" : false,
    };

    isPauseCobham = false;
    buttonsPauseCobham = false;
    courriers = [];
    courriersShown = [];
    
    eventDossierComparateur: Subject<any> = new Subject<any>();
    eventUpdateDossierComparateur: Subject<any> = new Subject<any>();
    mailLinkCC = "";
    errorCpEmp: boolean = false;
    errorTerritoireCC = null;
    sendOtherLink: any = false;
    displayCodePostal: boolean = false;
    dateNaissAgeErr: boolean = false;
    errorSelectCC: boolean = false;
    lastBsIDCC: any = '';
    messageCoeffInfo: string = '';


    constructor(
        private activatedRoute: ActivatedRoute,
        private appService: AppService,
        private cdf: ChangeDetectorRef,
        private cookies: CookieService,
        private customerService: CustomerService,
        private formBuilder: FormBuilder,
        private httpClient: HttpClient,
        private loaderService: LoaderService,
        private mailService: MailService,
        private payslipService: PayslipService,
        private router: Router,
        private stateService: StateService,
        private titleService:Title,
        public dialog: MatDialog,
    ) {
        this.idDossier = this.activatedRoute.snapshot.params.displayID ? this.activatedRoute.snapshot.params.displayID.substring(5) : "";
        this.listenerIframeCalc = this.listenerIframeCalc.bind(this);
        let extras = this.router.getCurrentNavigation().extras;
        this.directAccessToResultats = extras.hasOwnProperty('state') && extras.state.hasOwnProperty('resultats') ? extras.state.resultats : false;
        this.fillDelegationForm =  extras.hasOwnProperty('state') && extras.state.hasOwnProperty('fillDelegationForm') ? extras.state.fillDelegationForm : false;
        this.delegationToken = this.activatedRoute.snapshot.params.token;
    }

    errorHandling(response){
        if(response.error){
            this.errorHandlingMessage = response.error
            
            if(response.code == 401){
                let dialogRef = this.dialog.open(LoginComponent, {
                height: '55%',
                width: '25%',
                panelClass:'dialog-login'
                })
            }
        }
    }

    ngOnInit() {
        this.pload("assets/image/cobham-horloge-opti.gif")

        if (!this.stateService.user.getValue()) {
            this.appService.getEnv().subscribe((env) => {
                this.BOCC_URL = env.result.BOCC_URL;
            });
            environment.tokenauth = this.cookies.get("Tokenauth");
            if (environment.tokenauth) {
                this.appService.getUserByToken(this.tokenauth).subscribe((res) => {
                    if(res.result.user){
                        environment.tokencalc = res.result.token_calc;
                        res.result.user.identity.ID = res.result.user.ID;
                        res.result.user.identity.email = res.result.user.connection.email;
                        this.stateService.updateUser(res.result.user.identity);
                        this.user = res.result.user.identity;
                        this.fetchData();
                    } else {
                        this.router.navigateByUrl("/homepage");
                    }
                });
            }
        } else if (this.stateService.user.getValue() && !this.stateService.user.getValue().abonnement.active_subscription) {
            this.appService.refreshUser().subscribe((res) => {
                if(res.result){
                    res.result.identity.ID = res.result.ID;
                    res.result.identity.email = res.result.connection.email;
                    this.stateService.updateUser(res.result.identity);
                    this.user = res.result.identity;
                    this.fetchData();
                } else {
                    this.router.navigateByUrl("/homepage");
                }
            });
        } else if (this.stateService.user.getValue() && this.stateService.user.getValue().abonnement.active_subscription) {
            this.user = this.stateService.user.getValue();
            this.fetchData();
        }
    }

    fetchData() {
        if(this.user){
            this.setMailLinkCC();
        }
        // récupération des data user
        if(this.user && !this.delegationToken){
            this.abonnement = this.user.abonnement;
            this.customerService.getCredits().subscribe(res=>{
                if (res.result) {
                    this.credits = res.result;
                    if (!this.credits || !this.credits['next_valid_credit']) {
                        this.isCredConsume = "buy-credits";
                    }
                }
            });
            this.payslipCollection = new PayslipCollection([]);
            if(this.user.credits && this.user.credits.length > 0){
                this.user.credits.forEach(element => {
                    this.credquantite += element.quantite;
                });
            }
            this.afterOnInit()
        } else if (this.delegationToken) {
            this.appService.getDossierFromDelegationToken(this.delegationToken).subscribe( (response) => {
                if (response.result.dossier && response.result.token) {
                    let result = response.result;
                    this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
                    environment.tokenauth = result.token;
                    environment.tokenDelegation = this.delegationToken;
                    this.delegatedDossier = result.dossier;
                    this.dossier = result.dossier;
                    this.clientName = result.clientName;
                    this.company = result.company; 
                    this.delegationTokenIsValid = true;
        
                    let currentTitle = "";
                    for(const label in this.titles) {
                        if (result.clientTitle === label) {
                            currentTitle = this.titles[label];
                        }
                    }
                    this.clientTitle = currentTitle;
                    
                    this.appService.getTokenCalcForDelegation().subscribe( (response) => {
                        if (response.result.token_calc) {
                            environment.tokencalc = response.result.token_calc;
                        }
                    })
                    this.forceReloadDocuments(this.dossier.id);
                    this.afterOnInit()
                } else if (response.result.isDelegationDone) {
                    this.myStepper.selectedIndex = 3;
                    this.clientName = response.result.clientName;
                    this.company = response.result.company; 
                    this.submitToCobham = true;
                    this.helperOn = false;
                } else {
                    this.delegationTokenExpirationDate = new Date(response.result.expirationDate);
                    this.cdf.detectChanges();
                }
            })
        } else {
            this.router.navigateByUrl("/dossier");
        }
    }

    afterOnInit(){
        if(this.subscribe && this.subscribe['tooltips']){
            this.subscribe['tooltips'].unsubscribe();
        }
        this.subscribe['tooltips'] = this.appService.getLibelleTooltip().subscribe((res)=>{
            console.log('INFOS DE PARAMETRAGE: libelle/tooltip')
            if(res && res.result){
                this.libellDictionnaire = res.result
            }
            for(let element in this.libellDictionnaire){
                if(this.libellDictionnaire[element].parameters) {
                    this.libellDictionnaire[element].parameters = JSON.parse(this.libellDictionnaire[element].parameters).ListValues
                }
            }
            this.applyLibelleCC();
        })
        if(this.subscribe && this.subscribe['json0']){
            this.subscribe['json0'].unsubscribe();
        }
        if(this.subscribe && this.subscribe['json1']){
            this.subscribe['json1'].unsubscribe();
        }
        this.subscribe['json1'] = this.httpClient.get('assets/content-sirene.json?v=' + window['cobham_version']).subscribe((res) => {
            console.log('INFOS DE PARAMETRAGE: siren',res)
            this.effectifTranches = res;
        })
        if(this.subscribe && this.subscribe['json2']){
            this.subscribe['json2'].unsubscribe();
        }
        this.subscribe['json2'] = this.appService.getParameterPossibleValues(["MOTIF_SORTIE","PROF_SPEC","EFFECT_EMP","EFFECT_ETAB","NAT_CONT","CP_TYPE_CALC"]).subscribe((res) => {
            console.log('INFOS DE PARAMETRAGE: choix possible des champs à selection')
            this.motifs = res["result"]["MOTIF_SORTIE"];
            this.droitSpec = res["result"]["PROF_SPEC"];
            this.trancheEffectif = res["result"]["EFFECT_EMP"];
            this.trancheEffectifEtab = res["result"]["EFFECT_ETAB"];
            this.contrats = res["result"]["NAT_CONT"];
            this.cp_type_calc = res["result"]["CP_TYPE_CALC"];
        })
        if(this.subscribe && this.subscribe['idcc']){
            this.subscribe['idcc'].unsubscribe();
        }
        this.subscribe['idcc'] = this.appService.getIdccListe().subscribe((res) => {
            this.allOptionsIDCC = res.result.hasOwnProperty('result') ? [] : res.result;
            this.filterIDCCByDates();
            this.findBsIDCCLibelle();
            if (this.dataEmpFormGroup) {
                const idccValue = this.dataEmpFormGroup.get('IDCC_CC').value;
                if (idccValue) {
                    const match = this.optionsIDCC.find(idcc => idcc.Value == idccValue);
                    if (match) {
                        this.dataEmpFormGroup.get('IDCC_CC_autocomplete').setValue(match);
                        this.filterIDCCByDates();
                    }
                }
            }
        })
        if(this.subscribe && this.subscribe['json3']){
            this.subscribe['json3'].unsubscribe();
        }
        this.subscribe['json3'] = this.httpClient.get('assets/calcul-matrix.json?v='+window['cobham_version']).subscribe((res) => {
            console.log('INFOS DE PARAMETRAGE: calcul-matrix')
            this.rapports = res["rapports"];
            this.courriers = res["courriers"];
        })
        if(this.subscribe && this.subscribe['calculettes']){
            this.subscribe['calculettes'].unsubscribe();
        }
        this.firstFormGroup = this.formBuilder.group({
            pseudoSalarie: new FormControl(""),
            pseudoEntreprise: new FormControl(""),
            isAnonyme: new FormControl("FALSE"),

            civiliteSala: new FormControl(""),
            firstnameSala: new FormControl(""),
            nameSala: new FormControl(""),
            siret: new FormControl(""),
            nameEntSala: new FormControl(""),
            typeSala: new FormControl(""),
            dateContSala: new FormControl(""),

            postSala: new FormControl("TRUE"),
            contRompu: new FormControl("FALSE"),
            boolRupt: new FormControl("FALSE"),
            dateContSortieSala: new FormControl(""),
            motifSala: new FormControl(""),
            nomDateRupt: new FormControl(""),
            dateRupt: new FormControl(""),
            maladieSala: new FormControl("FALSE"),
            dateMaladieSala: new FormControl(""),
        })
        this.origin = window.location.origin;
        window.addEventListener('message',this.listenerIframeCalc,false); // Ecoute des calculettes

        // récupération des data dossiers
        if (!this.idDossier) {
            this.subscribe['calculettes'] = this.appService.filter_calculettes_condition(0).subscribe((res) => {
                if (res && res.result) {
                    this.calculettesInStepper = res.result.filter(calc => calc.displayed);
                    this.stepResult = 2 + this.calculettesInStepper.length;
                    this.cdf.detectChanges();
                }
                this.positionOnCDF()
            })
        } else if (this.idDossier) {
            this.appService.getDossierById(this.idDossier).subscribe((data)=>{
                if(data.result.error && data.result.code){
                    this.errorHandling(data.result)
                }else if(data && data.result && data.result.datas && data.result.datas[0]){
                    this.dossier = data.result.datas[0]
                    this.processLastBsEntete();
                    this.stateService.updateDossier(this.dossier);
                    this.titleService.setTitle("Rupture by Cobham - dossier "+this.dossier.displayID+ " - "+this.dossier.prenom+" "+this.dossier.nom);
                    window['tryga']('send', 'event', 'mettre_a_jour_dossier', '', '', ''); // #691 
                    this.cdf.detectChanges();
                    this.tokencalc = environment.tokencalc;
                    
                    this.helperOn = false;
                    this.consumeToken = false;
                    if (this.dossier.etatvalidation == -1) {// dossier créé après achat de crédit mais pas encore initialisé
                        this.consumeToken = true;
                    }
                    
                    this.subscribe['calculettes'] = this.appService.filter_calculettes_condition(this.dossier.id).subscribe((res) => {
                        if (res && res.result) {
                            this.calculettesInStepper = res.result.filter(calc => calc.displayed);
                            this.stepResult = 2 + this.calculettesInStepper.length;
                            this.cdf.detectChanges();
                        }
                        this.positionOnCDF()
                    })
                    this.checkValidationDossier()
                    this.afterViewInit()
                }
            })
        }
        
        // this.promise['json2'] = this.appService.getParameterPossibleValues(["MOTIF_SORTIE","PROF_SPEC","EFFECT_EMP","EFFECT_ETAB","NAT_CONT","CP_TYPE_CALC"]).toPromise().then((res) => {
        //     console.log('INFOS DE PARAMETRAGE: choix possible des champs à selection')
        // });
        // Promise.all([this.promise['json2']]).then(() => {
        //     console.log('TOUTES LES INFOS DE PARAMETRAGE ONT ETE CHARGEES');
        // })
    }
    
    forceReloadDocuments(dossierId) {
        this.reloadDocuments.next(dossierId);
    }

        // tentative de préchargement du gif 'horloge'
    pload(...args: any[]):void{
        for (var i = 0; i < args.length; i++) {
        this.imgs[i] = new Image();
        this.imgs[i].src = args[i];
        // console.log('loaded: ' + args[i]);
        }
    }
    afterViewInit(){
        this.required = [];
        if(this.subscribe && this.subscribe['getDossierEntete']){
            this.subscribe['getDossierEntete'].unsubscribe();
        } 
        this.subscribe['getDossierEntete'] = this.appService.getDossierEntete(this.dossier.id).subscribe((res)=>{
            
            if( res.result && res.result.entete){
                this.dossier.entete = res.result.entete
                // this.datedebperiode = this.dossier.entete.filter(ent => ent.parametre && ent.parametre.code && ent.parametre.code == "DT_DEBUT_PERIODE_BS")
                // this.datefinperiode = this.dossier.entete.filter(ent => ent.parametre && ent.parametre.code && ent.parametre.code == "DT_FIN_PERIODE_BS")
                // this.nbMoisPeriode = this.dossier.entete.filter(ent => ent.parametre && ent.parametre.code && ent.parametre.code == "NB_MOIS_PERIODE_BS")
                // if(this.datedebperiode){this.datedebperiode = this.datedebperiode[0].valuedate}
                // if(this.datefinperiode){this.datefinperiode = this.datefinperiode[0].valuedate}
                // if(this.nbMoisPeriode){this.nbMoisPeriode = this.nbMoisPeriode[0].valueint}
                let libelleCC =  this.dossier.entete.filter(ent => ent.parametre && ent.parametre.code && ent.parametre.code == "LIB_CC")
                if (libelleCC && libelleCC.length > 0) {
                    this.libelleCC = libelleCC[0].value
                }
                
                this.computeStrCalculResult();
                // this.setupAvenant(this.dossier.id, res.result.entete);
                this.setupDataBlock();
                // this.getSalaireRef();
                // this.getSdcCumul();
                // this.getIccpMntNb();
                this.updateCCparam();
            }
        })
        if(this.subscribe && this.subscribe['getDossierRapport']){
            this.subscribe['getDossierRapport'].unsubscribe();
        } 
        this.subscribe['getDossierRapport'] = this.appService.getDossierRapport(this.dossier.id).subscribe((res)=>{
            if( res.result && res.result.rapport){
                this.dossier.rapport = res.result.rapport
                this.fragments = []
                this.dossier.rapport.forEach((rapport) => {
                    this.fragments[rapport.calcul] = rapport.fragments
                })
                this.screenRapportPrepare();
            }
        })
        
        this.appService.getCourriers(this.dossier.id).subscribe((res) => {
            if (res.result) {
                this.dossier.courriers = res.result;
                this.screenCourrierPrepare();
            }
        })
            
    }
    listenerIframeCalc(e) {
        let data = e.data;
        if (data.hasOwnProperty('action') && e.origin === this.BOCC_URL) {
            if (data.action === 'heightHasChanged') {
                if(data.height < 750 ){ data.height = 750}
                // (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe')).style.height = data.height+20 + 'px';
                (<HTMLElement> document.querySelector('#iframe_container iframe')).style.height = data.height+20 + 'px';
            } else if (data.action === 'cancel') {
                this.calcul = false;
                this.disabled = false;
            } else if (data.action === 'needInputs'){
                this.disabledAdditionalButton = false;
                this.needInputs = []
                if(data.inputs && data.inputs.length !==0){
                    //if(data.inputs[0] == 'HAND_SAL'){ /// TODO : A SUPPRIMER QUAND PB HAND_SAL SUPPRIMER DANS LBP
                    //    this.disabled = false
                    //}else{
                        this.disabled = true
                        if (!data.debug || data.debug != 0) {
                            this.needInputs = data.inputs
                        }
                    //}
                }else{
                    this.disabled = false
                }
                this.cdf.markForCheck()
            } else if (data.action === 'save') {
                if (this.dossier) {
                    this.appService.saveCalculData(data.dossierid, data.data).subscribe((res) => {
                        this.disabled = false
                        this.disabledAdditionalButton = false;
                        
                        if (res.result) {
                            this.checkIfDossierHasDoublon();
                            this.calcul = false;
                            this.showAdditionalButton = false;
                            this.titreAdditionalButton = "";
                            this.callbackAdditionalButton = "";

                            this.dossier.entete = res.result.entete;
                            if (Object.keys(this.changedFields).length) {
                                this.changedFields = {};
                                this.setDossierComplete(0);
                                console.log ('reset this.maxStateSteps [',this.maxStateSteps, '] pour mettre les étape après myStepper.selectedIndex [',this.myStepper.selectedIndex,'] à 0')
                            }
                            this.cdf.markForCheck();
                            this.goToStep(this.myStepper);
                        }
                    });
                } 
            } else if (data.action === 'partial-save') {
                if (this.dossier) {
                    this.appService.saveCalculData(data.dossierid, data.data).subscribe((res) => {
                        if (data.no_exit) {
                            this.calcul = false;
                            this.saveRapportOk = true;
                            this.disabled = false;
                            this.disabledAdditionalButton = false;
                            this.iframeHTML(null);
                            this.cdf.markForCheck()
                            this.goToStep(this.myStepper);
                        } else {
                            this.router.navigate(['/dossier']);
                        }
                    });
                }             
            } else if (data.action === "disableLeave") {
                this.disabled = true;
                this.cdf.markForCheck()
            } else if (data.action === "enableLeave") {
                this.disabled = false;
                this.cdf.markForCheck()
            } else if (data.action === 'iframeReady') {
                this.disabled = false
                this.disabledAdditionalButton = false;
                this.cdf.markForCheck()
            } else if (data.action === 'openRapport') {
                this.seeRapport(data.rapport)
            } else if (data.action === 'changeSalRefApproche') {
                this.appService.changeSalRefApproche(this.dossier.id, data.value).subscribe(result_response => {
                    // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
                    let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
                    frame['contentWindow'].postMessage({action: 'result-changeSalRefApproche', values: (result_response.result ? result_response.result : []) }, this.BOCC_URL);
                });
            } else if (data.action === 'openSalaireReferenceDetail') {
                let paramsSalaireDetailHtml = data.params;
                paramsSalaireDetailHtml['dossier_id'] = this.dossier.id;
                // this.appService.getSalaireDetailHtml(paramsSalaireDetailHtml).subscribe((result) => {
                //     if ('result' in result && 'result' in result.result && 'content' in result.result.result) {
                //         let html = result.result.result.content;
                //         const dialogRef = this.dialog.open(DialogSalRefDetail, {
                //             data: html,
                //         });
                //     }
                // });
                const dialogSalRefDetail = this.dialog.open(DialogSalRefDetailDirect, {
                    data: paramsSalaireDetailHtml,
                    height: '97%',
                    width: '65%',
                    panelClass:'hide-scrollbar',
                    disableClose: true,
                    maxWidth: "",
                    autoFocus: false,
                });
                
                // dialogSalRefDetail.afterClosed().subscribe(data => {
                dialogSalRefDetail.beforeClosed().subscribe(data => {
                    if (data && data.option == 'save') {
                        this.disabled = true;
                        this.cdf.markForCheck()
                        this.appService.salRefDetailSave(data.values).subscribe(data_save => {
                            // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
                            let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
                            frame['contentWindow'].postMessage({action: 'trigger-salref-save', values: (data_save.result ? data_save.result : data.values) }, this.BOCC_URL);
                            this.appService.updateSalRefCalc(this.dossier.id).subscribe(sal_ref_calc_response => {
                                frame['contentWindow'].postMessage({action: 'trigger-salref-calc', values: (sal_ref_calc_response.result ? sal_ref_calc_response.result : 0) }, this.BOCC_URL);
                            });
                        });
                    } else if (data && data.option == 'delete') {
                        // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
                        let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
                        frame['contentWindow'].postMessage({action: 'trigger-salref-delete', values: data.values }, this.BOCC_URL);
                        this.disabled = true;
                        this.cdf.markForCheck()
                        this.appService.salRefDetailDelete(data.values).subscribe(data_save => {
                            this.disabled = true;
                            this.cdf.markForCheck()
                            this.appService.updateSalRefCalc(this.dossier.id).subscribe(sal_ref_calc_response => {
                                // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
                                let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
                                frame['contentWindow'].postMessage({action: 'trigger-salref-calc', values: (sal_ref_calc_response.result ? sal_ref_calc_response.result : 0) }, this.BOCC_URL);
                            });
                        });
                    }
                });
            } else if (data.action === 'showAdditionalButton') {
                this.showAdditionalButton = true;
                this.titreAdditionalButton = data.titreAdditionalButton;
                this.callbackAdditionalButton = data.callbackAdditionalButton;
                this.cdf.markForCheck();
            } else if (data.action === 'hideAdditionalButton') {
                this.showAdditionalButton = false;
                this.titreAdditionalButton = "";
                this.callbackAdditionalButton = "";
                this.cdf.markForCheck();
            } else if (data.action === 'iframeChangedFields') {
                data.changes.forEach(change => {
                    console.log('from iframe',change.fieldName,':', change.prev,'→', change.next);
                    this.updatechangedFields(this.changedFields, change.fieldName, change.prev, change.next);
                });
                // console.log(this.changedFields);
                this.cdf.markForCheck();
            }
        }
    }
    clickAdditionalButton() {
        if (this.showAdditionalButton && this.callbackAdditionalButton && this.calcul) {
            // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
            let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
            frame['contentWindow'].postMessage({'action': 'callbackAdditionalButton', 'callbackAdditionalButton': this.callbackAdditionalButton },this.BOCC_URL);
        }
    }
    positionOnCDF(){
        console.log('*** positionOnCDF')    
        if (this.dossier) {
            let indexStepper = 0;
            if(!this.dossier.poste){ //Salarié Sorti
                this.diagnostic = true
                this.simulation = false
            }else{ // Salarié tjrs en poste
                this.diagnostic = false
                this.simulation = true
            }
            this.filterIDCCByDates();
            this.dataStep = 3;
            this.helperOn = false;
            this.consumeToken = false;
        
            if (this.directAccessToResultats || (this.dossier && this.dossier.complete) ) {
                indexStepper = this.stepResult;
                this.dataStep = 1;
            }else{
                console.log("dossier etatvalidation", this.dossier.etatvalidation)
                switch (this.dossier.etatvalidation) {
                    case 6: 
                        indexStepper = 1;
                        break;
                    case 7:
                        indexStepper = this.stepResult;
                        this.dataStep = 1;
                        break;
                    case 8:
                        indexStepper = this.stepResult;
                        this.dataStep = 2;
                        break;
                    default:
                        break;
                }
            }
            if (indexStepper > 1) {
                this.bggrey = true;
            }
            this.myStepper.steps.toArray().map((step, idx) => step.completed = (idx <= indexStepper));
            this.myStepper.selectedIndex = indexStepper;
            this.enterStep(this.myStepper.selectedIndex);

            if(this.dossier.etatvalidation >= 7){
                this.setDossierComplete(1);
            }
        }
    }

    addTerritoire() {
        if (this.getCCparamFinished && this.dataEmpBlock && this.territoireMatch) {
            let index = this.libellAndToolTip && this.libellAndToolTip['CC_TERRITOIRE'] && this.libellAndToolTip['CC_TERRITOIRE']['libelle'] ? this.libellAndToolTip['CC_TERRITOIRE']['libelle'] : "Territoire d'appartenance de l'Entreprise";
            this.dataEmpBlock[index] = this.territoireMatch;
            this.dataEmpFormGroup.get("CC_TERRITOIRE").setValue(this.territoireMatch);
        }
    }

    exitFolderSavePartialCalc() {
        window['tryga']('send', 'event', 'telecommande', 'sortir_dossier', '', '');
        if (this.calcul) {
            // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
            let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
            frame['contentWindow'].postMessage({'action': 'trigger-partial-save', 'dossierid': this.dossier.id},this.BOCC_URL);
        } else {
            if (this.sendDataForm()) {
                this.router.navigate(['/dossier']);
            }
        }
    }
   
    quitCalcul(action) {
        if (this.calcul) {
            // let frame = <HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe');
            let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
            frame['contentWindow'].postMessage({'action': 'trigger-save', 'dossierid': this.dossier.id},this.BOCC_URL);
        } else {
            this.saveRapportOk = true;
            this.disabled = false;
            this.disabledAdditionalButton = false;
            ////// console.log("DISABLED", this.disabled)
            this.iframeHTML(null);
            this.cdf.markForCheck()
            this.goToStep(this.myStepper, action);
        }
    }
    computeStrCalculResult() {  
        
        // if (this.subscribe['isAREApplicable'])
        //     this.subscribe['isAREApplicable'].unsubscribe()
        // this.subscribe['isAREApplicable'] = this.appService.isAREApplicable(this.dossier.id).subscribe((res)=>{
        //     this.isAREApplicable = res && res['result'];
        // })
        this.appService.isAREApplicable(this.dossier.id).subscribe((res)=>{
            this.isAREApplicable = res && res['result'];
        })
        // this.motifRuptureEntete = {
        //     "LicPers" : false,
        //     "LicEco" : false,
        //     "RC" : false,
        //     "DR" : false,
        // };
        // this.strICL = 0;
        // let year = false, month = false, day = false;
        // let iclCompRC = 0;
        // console.log("computeStrCalculResult",this.dossier.entete)
        // let ind_retraite = 0;
        // let ind_rupt = 0;
        // let ind_spec_rc_min = 0;
        // let ind_leg_rupt; // fix #1458
        // let ind_cc_rupt; // fix #1458
        // let mnt_transac = 0;
        // let mnt_ind_pse = 0;
        this.dossier.entete.forEach(entete => {
            // if (entete.parametre && entete.parametre.code == 'DR_ANC_LEGAL' && entete.indexIndice === 0) {
            //     year = entete.valueint;
            // } else if (entete.parametre && entete.parametre.code == 'DR_ANC_LEGAL' && entete.indexIndice === 1) {
            //     month = entete.valueint;
            // } else if (entete.parametre && entete.parametre.code == 'DR_ANC_LEGAL' && entete.indexIndice === 2) {
            //     day = entete.valueint;
            // } else if (entete.parametre && entete.parametre.code == 'IND_CC_RUPT') {
            //     ind_cc_rupt = entete.value;
            // } else if (entete.parametre && entete.parametre.code == 'IND_LEG_RUPT') {
            //     ind_leg_rupt = entete.value;
            // } else if (entete.parametre && entete.parametre.code == 'IND_RETRAITE') {
            //     ind_retraite = entete.value;
            // }
            
            // if (entete.parametre && entete.parametre.code == 'SAL_REF_RUPT_PARTIEL') {
            //     this.salRefRuptPartiel = entete.value == "TRUE"
            // }

            // if (entete.parametre && entete.parametre.code == 'MNT_TRANSAC') {
            //     mnt_transac = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? parseFloat(entete.value) : 0)
            // }
            
            // if (entete.parametre && entete.parametre.code == 'MNT_IND_PSE') {
            //     mnt_ind_pse = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? parseFloat(entete.value) : 0)
            // }
            
            // if (entete.parametre && entete.parametre.code == 'MNT_CONTENTIEUX') {
            //     this.strContentieux = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
            
            // if (entete.parametre && entete.parametre.code == 'MOTIF_SORTIE' && entete.value == "RC") {
            //     this.motifRuptureEntete["RC"] = true;
            // } else if (entete.parametre && entete.parametre.code == 'MOTIF_SORTIE' && entete.value == "LICENCIEMENT PERS") {
            //     this.motifRuptureEntete["LicPers"] = true;
            // } else if (entete.parametre && entete.parametre.code == 'MOTIF_SORTIE' && entete.value == "LICENCIEMENT ECO") {
            //     this.motifRuptureEntete["LicEco"] = true;
            // } else if (entete.parametre && entete.parametre.code == 'MOTIF_SORTIE' && entete.value == "DR") {
            //     this.motifRuptureEntete["DR"] = true;
            // }

            // // if ((entete.parametre && entete.parametre.code == 'IND_CC_RUPT' && !entete.parametre.parent)
            // //     || (entete.parametre && entete.parametre.code == 'IND_LEG_RUPT' && !entete.parametre.parent)) 
            // // {
            // //     if (this.strICL) {
            // //         let otherValue = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0);
            // //         if (otherValue > this.strICL) {
            // //             this.strICL = otherValue;
            // //         }
            // //     } else {
            // //         this.strICL = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0);
            // //     }
            // // }
            // if (this.doesEnteteMatchCode(entete, "IND_RUPT")) {
            //     ind_rupt = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
            // if (this.doesEnteteMatchCode(entete, "IND_SPEC_RC_MIN")) {
            //     ind_spec_rc_min = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }

            // if (entete.parametre && entete.parametre.code == 'IND_SPEC_RC') {
            //     iclCompRC = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? parseFloat(entete.value) : 0)
            // }
            if (entete.parametre && entete.parametre.code == 'BOOL_CHECK_PROCEDURE') {
                if (entete.value && entete.value == "TRUE"){
                    this.boolProcedure = true;
                } else {
                    this.boolProcedure = false;
                }
            }

            // if (entete.parametre && entete.parametre.code == 'ARE_ALLOC_NET'
            //     && entete.parametre.parent && entete.parametre.parent.code == "ARE_INDEM_TX_PLEIN") 
            // {
            //     this.areAllocNet = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? parseFloat(entete.value) : 0)
            // }

            // if (!this.areAllocNet && 
            //     entete.parametre && entete.parametre.code == 'ARE_ASP'
            //     && entete.parametre.parent && entete.parametre.parent.code == "ARE_ALLOC_NET") 
            // {
            //     this.areAllocNet = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? parseFloat(entete.value) : 0)
            // }

            // if (entete.parametre && entete.parametre.code == 'ARE_DR_INDEM_TOT') { // avant : ARE_JR_CARENCE
            //     this.delaiCarenceARE = entete.value;
            // }
            // if (entete.parametre && entete.parametre.code == 'MNT_BRUT' 
            //     && entete.parametre.parent && entete.parametre.parent.code 
            //     && entete.parametre.parent.code == "FIR_TOTAL") {
            //     this.firTotal.mnt_brut = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
            // if (entete.parametre && entete.parametre.code == 'MNT_NET_FISCAL' 
            //     && entete.parametre.parent && entete.parametre.parent.code 
            //     && entete.parametre.parent.code == "FIR_TOTAL") {
            //     this.firTotal.mnt_net_fiscal = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
            // if (entete.parametre && entete.parametre.code == 'MNT_NET_SOCIAL'
            // && entete.parametre.parent && entete.parametre.parent.code 
            // && entete.parametre.parent.code == "FIR_TOTAL") {
            //     this.firTotal.mnt_net_social = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
            // if (entete.parametre && entete.parametre.code == 'MNT_EMP'
            // && entete.parametre.parent && entete.parametre.parent.code 
            // && entete.parametre.parent.code == "FIR_TOTAL") {
            //     this.firTotal.mnt_emp = entete.valueint ? entete.valueint :(parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
            // }
        });

        // if (ind_leg_rupt && ind_cc_rupt) {
        //     if (this.motifRuptureEntete["DR"])
        //         this.indem_min_txt = parseFloat(ind_cc_rupt) < parseFloat(ind_leg_rupt) ? "Indemnité légale de départ en retraite" : "Indemnité conventionnelle de départ en retraite";
        //     else
        //         this.indem_min_txt = parseFloat(ind_cc_rupt) < parseFloat(ind_leg_rupt) ? "Indemnité légale de licenciement" : "Indemnité conventionnelle de licenciement"; // fix #1458
        // }
        
        // if (this.motifRuptureEntete["LicPers"]) {
        //     this.strICL = ind_rupt;
        //     this.strICLComp = mnt_transac;
        // } else if (this.motifRuptureEntete["LicEco"]) {
        //     this.strICL = ind_rupt;
        //     this.strICLComp = mnt_transac + mnt_ind_pse;
        // } else if (this.motifRuptureEntete["RC"]) {
        //     this.strICL = ind_spec_rc_min;
        //     let indemniteRC = iclCompRC - this.strICL + mnt_transac;
        //     this.strICLComp = Math.max(indemniteRC, 0);
        // } else if (this.motifRuptureEntete["DR"]) {
        //     this.strICL = ind_rupt;
        //     this.strICLComp = ind_retraite - Math.max(ind_cc_rupt, ind_leg_rupt) + mnt_transac;
        // }

        // if (year !== false && month !== false && day !== false) {
        //     this.strAnciennete = (year !== 0 ? (year + ' an' + (year > 1 ? 's' : '')) : '') + (year !== 0 && month !== 0 ? ' et ' : '') + (month !== 0 ? month + ' mois' : '');
        // }
    }


    setupDataBlock(with_first_form = true){
        console.log('*** setupDataBlock')

        if (with_first_form) {
            this.firstFormGroup.get('pseudoSalarie').setValue(this.dossier.pseudoSalarie);
            this.firstFormGroup.get('pseudoEntreprise').setValue(this.dossier.pseudoEntreprise);
            this.firstFormGroup.get('isAnonyme').setValue(this.dossier.isAnonyme ? 'TRUE' : 'FALSE');
            this.firstFormGroup.get('civiliteSala').setValue(this.dossier.civilite);
            this.firstFormGroup.get('firstnameSala').setValue(this.dossier.prenom);
            this.firstFormGroup.get('nameSala').setValue(this.dossier.nom);
            this.firstFormGroup.get('siret').setValue(this.dossier.siret);
            this.firstFormGroup.get('nameEntSala').setValue(this.dossier.entreprise);
            this.firstFormGroup.get('typeSala').setValue(this.dossier.typecontrat);
            this.firstFormGroup.get('dateContSala').setValue(this.dossier.datedebut ? this.dossier.datedebut.toString().split('T')[0] : '');
        }

        let allDataForm = this.getDataForm(["DT_FIN_BS","QUALIF_CC","NIV_CC","ECH_CC","HAND_SAL","EN_POSTE","EXPA_SAL",
            "DT_S","MOTIF_SORTIE","PROF_SPEC","NOM_EMP","LIB_CC","ADR_EMP", "DT_ARRET_TRAV", "BOOL_MALADIE_LIC",
            "EFFECT_EMP","REG_ALS","Période d'emploi","TPS_TRAV","SAL_BRUT_COH","DT_DEBUT_BS","EFFECT_ETAB","DT_ENT_BS","DT_DEBUT_CONT","TPS_TRAV_UNIT","CP_APR_PER", 
            "PC_TRAV","DT_ENT_CT", 'DT_ANC', "BOOL_REP_ANC","TPS_TRAV_FORF",
            "DT_STAGE", "DT_STAGE_FIN", "DT_INTERIM", 
            "DT_INTERIM_FIN", "DT_CDD", "DT_CDD_FIN",
            "NAF", "LIB_APE", "IDCC_CC", "LIB_CC", "SIRET", "COM_EMP", "CP_EMP","TPS_PLEIN_TRAV","TPS_TRAV_FORF","TPS_TRAV_COLL","BOOL_ADH_SYND_SIGNATAIRE","VERIF_BOOL_ADH_SYND_SIGNATAIRE",
            "BOOL_CONT_ROMPU", "DATE_RUPT", "DT_LIC", "DT_LIC_PERS","DT_LIC_ECO","DT_LIC_RC","DT_DEM","DT_FIN_CONT","BOOL_RUPT", "COEFF_SAL","BOOL_DR_ANC_AUTRE_QUALIF","DR_PRES_SOC_CC",
            "AV_PARAM", "BOOL_CONST_QUALIF", "BOOL_CONST_TPS_TRAV","VERIF_BOOL_CONST_TPS_TRAV",
            "CC_SECTEUR","CC_TERRITOIRE",
            "DT_NAIS",
            "NEED_CP_TYPE_CALC","CP_TYPE_CALC","CC_CLASSIF_RANG4"
        ]);

        // if (allDataForm) {
        //     let dossier = this.dossier;
        //     let startDate = dossier.datedebut ? formatDate(dossier.datedebut, "y-MM-dd", "en") : "";
        //     let endDate = "";
        //     if (dossier.datesortie) {
        //         endDate = formatDate(dossier.datesortie, "y-MM-dd", "en");
        //     } else if (allDataForm["DT_S"]) {
        //         endDate = allDataForm["DT_S"].toString().split('T')[0];
        //     }

        //     this.appService.getDatePeriode(
        //         startDate,
        //         (dossier.poste === 0) ? "FALSE" : "TRUE",
        //         endDate,
        //         dossier.motifsortie,
        //         allDataForm["DATE_RUPT"] ? formatDate(allDataForm["DATE_RUPT"], "y-MM-dd", "en"): "",
        //         allDataForm["BOOL_MALADIE_LIC"] ? allDataForm["BOOL_MALADIE_LIC"] : "",
        //         allDataForm["DT_ARRET_TRAV"] ? formatDate(allDataForm["DT_ARRET_TRAV"], "y-MM-dd", "en") : ""
        //     ).subscribe((res) => {
        //         let startDatePeriod;
        //         let endDatePeriod = new Date();
        //         if (res.result && res.result.datefin)
        //             endDatePeriod = new Date(res.result.datefin);
        //         if (res.result && res.result.datedeb) {
        //             startDatePeriod = new Date(res.result.datedeb);
        //             this.payslipsMonthsLength = startDatePeriod.getDifferenceInMonths(endDatePeriod) + 1;
        //         }

        //         this.dateParamsForPayslips = {
        //             startDatePeriod : startDatePeriod, 
        //             endDatePeriod : endDatePeriod
        //         };

        //         this.payslipsMonthsLength = startDatePeriod.getDifferenceInMonths(endDatePeriod) + 1;
        //         this.payslipCollection.setPayslips(this.dossier.bulletinSalaire, false);
        //     })
        // }

        this.need_cp_type_calc = allDataForm["NEED_CP_TYPE_CALC"] == 'TRUE';
        // let datedebutfirstbs = '' 
        // if(this.dossier.bulletinSalaire && this.dossier.bulletinSalaire.length){
        //     this.dossier.bulletinSalaire.sort(function(a, b) {
        //         return a['datedebutbs'] - b['datedebutbs'];
        //     })
        //     datedebutfirstbs = this.dossier.bulletinSalaire[0].datedebutbs

        // }
        // let dateDebP = new Date(this.dossier.datedebutperiode);
        let dateDeb = new Date(this.dossier.datedebut);
        let dateDebFormat = this.formatDate2(dateDeb);
        // let dateDebPFormat = this.formatDate2(dateDebP);
        // let dateSortie = allDataForm["DT_S"] ? allDataForm["DT_S"].toString().split('T')[0] : "";
        // if (allDataForm["DT_S"]) {
        //     dateSortie = new Date(dateSortie).toLocaleDateString(undefined, {year: 'numeric', month: 'long', day: 'numeric' });
        // }
        // this.nbBsPrincipaux = this.dossier.bulletinSalaire.filter(e => {return e.typepage == "P"}).length;
        
        // this.dataUpdateDossBlock = {
        //     "Mode" : allDataForm["EN_POSTE"] ? 
        //         ((allDataForm["EN_POSTE"] == "TRUE") ? "SIMULATION" : "DIAGNOSTIC") : (this.dossier.poste ? "SIMULATION" : "DIAGNOSTIC"),
        //     "Le salarié est-il toujours en poste" : 
        //         allDataForm["EN_POSTE"] ? ((allDataForm["EN_POSTE"] == "TRUE") ? "Oui" : "Non") :(this.dossier.poste ? "Oui" : "Non"),
        //     "Contrat de travail rompu" : 
        //         allDataForm["BOOL_RUPT"] ? ((allDataForm["BOOL_RUPT"] == "TRUE") ? "Oui" : "Non") : "Non",
        //     "Date de sortie" : dateSortie,
        //     "Nature de la rupture de contrat" : 
        //         allDataForm["MOTIF_SORTIE"] ? this.getLibelleByMotifValue(allDataForm["MOTIF_SORTIE"]) :"",
        // }

        // if (allDataForm && allDataForm["EN_POSTE"] == "TRUE") {
        //     this.dataUpdateDossBlock = {
        //         "Mode" : "SIMULATION"
        //     };
        // }
        
        // this.dateDebutBs = datedebutfirstbs;
        // this.dateFinBs = allDataForm["DT_LAST_BS"];

        //// console.log("DT_ARRET_TRAV==>", allDataForm['DT_ARRET_TRAV'])
        // this.paramRupt = allDataForm["DT_LIC_PERS"] ? "DT_LIC_PERS" :
        //                  allDataForm["DT_LIC_ECO"] ? "DT_LIC_ECO" :
        //                  allDataForm["DT_LIC_RC"] ? "DT_LIC_RC" :
        //                  allDataForm["DT_DEM"] ? "DT_DEM" :
        //                  allDataForm["DT_FIN_CONT"] ? "DT_FIN_CONT" : "";
        this.paramRupt = allDataForm["MOTIF_SORTIE"] == "LICENCIEMENT PERS" ? "DT_LIC_PERS" :
                         allDataForm["MOTIF_SORTIE"] == "LICENCIEMENT ECO" ? "DT_LIC_ECO" :
                         allDataForm["MOTIF_SORTIE"] == "RC" ? "DT_LIC_RC" :
                         allDataForm["MOTIF_SORTIE"] == "DEMISSION" ? "DT_DEM" : "DT_FIN_CONT";
        // this.dataUpdateDossFormGroup = this.formBuilder.group({
        //     EN_POSTE: new FormControl(allDataForm["EN_POSTE"] ? allDataForm["EN_POSTE"] :(this.dossier.poste ? "TRUE" : "FALSE")),
        //     // EN_POSTE: new FormControl(allDataForm["EN_POSTE"] ? allDataForm["EN_POSTE"] :(this.dossier.poste ? this.dossier.poste : "TRUE")),
        //     DT_S: new FormControl(allDataForm["DT_S"] ?allDataForm["DT_S"].toString().split('T')[0] :""),
        //     MOTIF_SORTIE: new FormControl(allDataForm["MOTIF_SORTIE"] ?allDataForm["MOTIF_SORTIE"] :""),
        //     BOOL_MALADIE_LIC: new FormControl(allDataForm["BOOL_MALADIE_LIC"] == "TRUE"? "TRUE" : "FALSE"),
        //     DT_ARRET_TRAV: new FormControl(allDataForm["DT_ARRET_TRAV"] ?allDataForm["DT_ARRET_TRAV"].toString().split('T')[0] :""),
        //     BOOL_CONT_ROMPU: new FormControl(allDataForm["BOOL_CONT_ROMPU"] ? allDataForm["BOOL_CONT_ROMPU"] : "FALSE"),
        //     DATE_RUPT: new FormControl(allDataForm["DATE_RUPT"] ? allDataForm["DATE_RUPT"].toString().split('T')[0] :""),
        //     DT_LIC: new FormControl(allDataForm["DT_LIC"] ? allDataForm["DT_LIC"].toString().split('T')[0] :""),
        //     DT_LIC_PERS: new FormControl(allDataForm["DT_LIC_PERS"] ? allDataForm["DT_LIC_PERS"].toString().split('T')[0] :""),
        //     DT_LIC_ECO: new FormControl(allDataForm["DT_LIC_ECO"] ? allDataForm["DT_LIC_ECO"].toString().split('T')[0] :""),
        //     DT_LIC_RC: new FormControl(allDataForm["DT_LIC_RC"] ? allDataForm["DT_LIC_RC"].toString().split('T')[0] :""),
        //     DT_DEM: new FormControl(allDataForm["DT_DEM"] ? allDataForm["DT_DEM"].toString().split('T')[0] :""),
        //     DT_FIN_CONT: new FormControl(allDataForm["DT_FIN_CONT"] ? allDataForm["DT_FIN_CONT"].toString().split('T')[0] :""),
        //     BOOL_RUPT: new FormControl(allDataForm["BOOL_RUPT"] ? allDataForm["BOOL_RUPT"] : "FALSE")
        // })
        if (with_first_form) {
            // this.firstFormGroup.get('postSala').setValue(this.dossier.poste);
            this.firstFormGroup.get('postSala').setValue(allDataForm["EN_POSTE"] ? allDataForm["EN_POSTE"] : (this.dossier.poste ? "TRUE" : "FALSE"));
            // this.firstFormGroup.get('dateContSortieSala').setValue(this.dossier.datesortie);
            this.firstFormGroup.get('dateContSortieSala').setValue(allDataForm["DT_S"] ? allDataForm["DT_S"].toString().split('T')[0] : this.dossier.datesortie);
            // this.firstFormGroup.get('motifSala').setValue(this.dossier.motifsortie);
            this.firstFormGroup.get('motifSala').setValue(allDataForm["MOTIF_SORTIE"] ? allDataForm["MOTIF_SORTIE"] : this.dossier.motifsortie);

            this.firstFormGroup.get('contRompu').setValue(allDataForm["BOOL_CONT_ROMPU"] ? allDataForm["BOOL_CONT_ROMPU"] : "FALSE");
            this.firstFormGroup.get('boolRupt').setValue(allDataForm["BOOL_RUPT"] ? allDataForm["BOOL_RUPT"] : "FALSE");
            this.firstFormGroup.get('dateRupt').setValue(allDataForm["DATE_RUPT"] ? allDataForm["DATE_RUPT"].toString().split('T')[0] : "");
            this.firstFormGroup.get('nomDateRupt').setValue(this.paramRupt);
            // this.affectDateRupt(this.paramRupt)
        }
        
        this.dataSalBlock = {
            "Nom" : this.dossier.nom,
            "Prénom" : this.dossier.prenom,
            "Date de début de contrat" : dateDebFormat,
            // "Date de début de période de BS" :dateDebPFormat,
            "Nature du contrat de travail" : this.dossier.typecontrat,
            "Numéro Convention collective" : allDataForm && allDataForm["IDCC_CC"] != 0 ? allDataForm["IDCC_CC"] : "",
            "Convention collective" : (allDataForm ?(allDataForm["LIB_CC"] && allDataForm["LIB_CC"] != "Légal" ?  allDataForm["LIB_CC"] : "A défaut de convention collective,\napplication du droit du travail"):"A défaut de convention collective,\napplication du droit du travail"),
            //"Le salarié a-t-il été suspendu pendant les 12 derniers mois": this.dossier.suspendu == 0 ? 'NON' : 'OUI'
        };
        
        if (!this.dataSalFormGroup)
            this.dataSalFormGroup = this.formBuilder.group({
                QUALIF_CC: new FormControl(this.qualifSelect?this.qualifSelect:(allDataForm["QUALIF_CC"] ?allDataForm["QUALIF_CC"] :"")),
                COEFF_SAL: new FormControl(allDataForm["COEFF_SAL"] ?allDataForm["COEFF_SAL"] :""),
                NIV_CC: new FormControl(this.nivSelect?this.nivSelect:(allDataForm["NIV_CC"] ?allDataForm["NIV_CC"] :"")),
                ECH_CC: new FormControl(this.echSelect?this.echSelect:(allDataForm["ECH_CC"] ?allDataForm["ECH_CC"] :"")),
                CC_CLASSIF_RANG4: new FormControl(this.qualiteSelect?this.qualiteSelect:(allDataForm["CC_CLASSIF_RANG4"] ?allDataForm["CC_CLASSIF_RANG4"] :"")),
                PROF_SPEC: new FormControl(allDataForm["PROF_SPEC"] ?allDataForm["PROF_SPEC"] :""), 
                EXPA_SAL: new FormControl(allDataForm["EXPA_SAL"] ?allDataForm["EXPA_SAL"] : "FALSE"),
                BOOL_DR_ANC_AUTRE_QUALIF: new FormControl(allDataForm["BOOL_DR_ANC_AUTRE_QUALIF"] ?allDataForm["BOOL_DR_ANC_AUTRE_QUALIF"] : "FALSE"),
                DT_NAIS: new FormControl(allDataForm["DT_NAIS"] ? allDataForm["DT_NAIS"].toString().split('T')[0] : ""),
                CP_TYPE_CALC: new FormControl(allDataForm && allDataForm["NEED_CP_TYPE_CALC"] ? (allDataForm["CP_TYPE_CALC"] ?allDataForm["CP_TYPE_CALC"] :"") : null),
            });
        //this.initSelect()
        this.dataEmpBlock = {
            "Nom" : (allDataForm ?(allDataForm["NOM_EMP"] ?  allDataForm["NOM_EMP"] : ""):""),
            "Adresse" : (allDataForm ?(allDataForm["ADR_EMP"] ?  allDataForm["ADR_EMP"] : ""):""),
            "Code postal" : (allDataForm ?(allDataForm["CP_EMP"] ?  allDataForm["CP_EMP"] : ""):""),
            "Commune" : (allDataForm ?(allDataForm["COM_EMP"] ?  allDataForm["COM_EMP"] : ""):""),
            "SIRET" : (allDataForm ?(allDataForm["SIRET"] ?  allDataForm["SIRET"] : ""):""),
            "Code APE/NAF" : (allDataForm ?(allDataForm["NAF"] ?  allDataForm["NAF"] : ""):""),
            // "Activité principale exercée" : (allDataForm ?(allDataForm["LIB_APE"] ?  allDataForm["LIB_APE"] : "inconnue"):"inconnue"),
        }

        this.dataCtBlock = {
            "Période d'emploi" :(allDataForm ?( allDataForm["Période d'emploi"] ?  allDataForm["Période d'emploi"] : ""):""),
            "Durée d'emloi" :(allDataForm ?( allDataForm["TPS_TRAV"] ? (Math.round(allDataForm["TPS_TRAV"]*100)/100)+ "h / mois" : ""):""),
            "Salaire mensuel" :(allDataForm ?( allDataForm["SAL_BRUT_COH"] ?  allDataForm["SAL_BRUT_COH"] + " €": ""):""),
        }
        this.displayCodePostal = allDataForm && allDataForm["SIRET"]? false: true;

        if (!this.dataEmpFormGroup) {
            const _idcc = allDataForm["IDCC_CC"];
            let init_IDCC_CC_autocomplete_options = this.optionsIDCC.filter(option =>
                _idcc != null && _idcc !== '' && String(option.Value) === String(_idcc)
            );
            console.log("___",allDataForm["IDCC_CC"],this.optionsIDCC);
            this.dataEmpFormGroup = this.formBuilder.group({
                IDCC_CC_autocomplete: new FormControl(init_IDCC_CC_autocomplete_options.length ? init_IDCC_CC_autocomplete_options[0] : undefined),
                IDCC_CC: new FormControl(allDataForm ?(allDataForm["IDCC_CC"] ?allDataForm["IDCC_CC"] :""):""),
                LIB_CC: new FormControl(""),
                CC_SECTEUR: new FormControl(allDataForm ?(allDataForm["CC_SECTEUR"] ?allDataForm["CC_SECTEUR"] :""):""),
                CC_TERRITOIRE: new FormControl(allDataForm ?(allDataForm["CC_TERRITOIRE"] ?allDataForm["CC_TERRITOIRE"] :""):""),
                EFFECT_EMP: new FormControl(allDataForm ?(allDataForm["EFFECT_EMP"] ?allDataForm["EFFECT_EMP"] :""):""),
                EFFECT_ETAB: new FormControl(allDataForm ?(allDataForm["EFFECT_ETAB"] ?allDataForm["EFFECT_ETAB"] :""):""),
                REG_ALS: new FormControl(allDataForm ?(allDataForm["REG_ALS"] ?allDataForm["REG_ALS"] :"FALSE"):"FALSE"),
                //DR_PRES_SOC_CC: new FormControl(allDataForm && allDataForm["DR_PRES_SOC_CC"] ? allDataForm["DR_PRES_SOC_CC"] :""),
                BOOL_ADH_SYND_SIGNATAIRE: new FormControl(allDataForm && allDataForm["BOOL_ADH_SYND_SIGNATAIRE"] ? allDataForm["BOOL_ADH_SYND_SIGNATAIRE"] :"FALSE"),
                VERIF_BOOL_ADH_SYND_SIGNATAIRE: new FormControl(allDataForm && allDataForm["VERIF_BOOL_ADH_SYND_SIGNATAIRE"] ? allDataForm["VERIF_BOOL_ADH_SYND_SIGNATAIRE"] :"FALSE"),
                CP_EMP: new FormControl(allDataForm ?(allDataForm["CP_EMP"] ?allDataForm["CP_EMP"] :""):"")
            });
            this.filteredIDCC = this.dataEmpFormGroup.get('IDCC_CC_autocomplete').valueChanges.pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.Libelle),
                map(Libelle => Libelle ? this._filterIDCC(Libelle) : this.optionsIDCC.slice())
            );
        }

        this.addTerritoire();

        // this.unitecode = (allDataForm ? (allDataForm["TPS_TRAV_UNIT"] ? allDataForm["TPS_TRAV_UNIT"] : "") : "");
        // this.unitedata = this.uniteTpsTrav.find(el => el.value == this.unitecode);

        let pressoc = this.getAllDataFromCode("DR_PRES_SOC_CC");
        if (!this.dataCTFormGroup)
            this.dataCTFormGroup = this.formBuilder.group({
                BOOL_CONST_TPS_TRAV : new FormControl(allDataForm ? (allDataForm["BOOL_CONST_TPS_TRAV"] ? allDataForm["BOOL_CONST_TPS_TRAV"] : "TRUE" ) : "TRUE"),
                VERIF_BOOL_CONST_TPS_TRAV : new FormControl(allDataForm && allDataForm["VERIF_BOOL_CONST_TPS_TRAV"] ? allDataForm["VERIF_BOOL_CONST_TPS_TRAV"] : "FALSE"),
                BOOL_CONST_QUALIF : new FormControl(allDataForm ? (allDataForm["BOOL_CONST_QUALIF"] ? allDataForm["BOOL_CONST_QUALIF"] : "TRUE" ) : "TRUE"),
                DR_PRES_SOC_CC_ANNEE: new FormControl(pressoc && pressoc.length > 1 ? pressoc[0] :""),
                DR_PRES_SOC_CC_MOIS: new FormControl(pressoc && pressoc.length > 1 ? pressoc[1] :""),
            });

        // if (this.principeCalcul != 1/* && !allDataForm["BOOL_CONST_QUALIF"]*/) {
        if (this.principeCalcul != 1 && !allDataForm["BOOL_CONST_QUALIF"]) {
            this.dataCTFormGroup.get("BOOL_CONST_QUALIF").setValue("TRUE");
        }

        let avenants = this.getAllDataFromCode("AV_PARAM");
        let contratTravail = this.getAllDataFromCode("CT_PARAM");
        
        if (contratTravail.length > 0) {
            if (!this.paramsCT)
                this.paramsCT = this.formBuilder.group({
                    qualification : contratTravail[0],
                    tempsTravail : contratTravail[1],
                    tempsTravailUnite : contratTravail[2],
                    tempsTravailCollectif : contratTravail[3],
                    tempsTravailType : contratTravail[4],
                });
        } else {
            if (!this.paramsCT)
                this.paramsCT = this.formBuilder.group({
                    qualification : (allDataForm && allDataForm["QUALIF_CC"] ? allDataForm["QUALIF_CC"] : ""),
                    tempsTravail : (allDataForm && allDataForm["TPS_TRAV"] ? (Math.round(allDataForm["TPS_TRAV"]*100)/100) : ""),
                    tempsTravailUnite : (allDataForm && allDataForm["TPS_TRAV_UNIT"] ? allDataForm["TPS_TRAV_UNIT"] : ""),
                    tempsTravailCollectif : (allDataForm && allDataForm["TPS_TRAV_COLL"] ? allDataForm["TPS_TRAV_COLL"] : ""),
                    tempsTravailType : (allDataForm && allDataForm["TPS_PLEIN_TRAV"] ? allDataForm["TPS_PLEIN_TRAV"] : ""),
                });
        }
        
        

        this.listAvenant = [];
        this.nbAvenant = 0;
        avenants.forEach((avenant) => {
            this.nbAvenant++;
            let newAvenant = {
                "dateSignature" : avenant[0],
                "qualification" : avenant[1],
                "tempsTravail" : avenant[2],
                "tempsTravailUnite" : avenant[3],
                "tempsTravailCollectif" : avenant[4],
                "tempsTravailType" : avenant[5],
                "id" : this.nbAvenant,
                "dateInterval" : {
                    "debut" : (allDataForm ? (allDataForm["DT_DEBUT_CONT"] ? formatDate(allDataForm["DT_DEBUT_CONT"], "y-MM-dd", "en") : formatDate(allDataForm["DT_ENT_CT"], "y-MM-dd", "en")): ""),
                    "fin" : (allDataForm ? (allDataForm["DT_S"] ? formatDate(allDataForm["DT_S"], "y-MM-dd", "en") : formatDate(new Date(), "y-MM-dd", "en")) : formatDate(new Date(), "y-MM-dd", "en"))
                },
                "visible" : true,
                "error" : []
            }
            this.listAvenant.push(newAvenant);
        })
        this.appService.getConstantes([["TPS_TRAV_LEGAL", null]]).subscribe((data) => {
            if(data.result){
                this.constantes = data.result;
                this.toggleChipUniteTravail(this.paramsCT.get("tempsTravailUnite").value, this.listUniteTravail);

                if (!this.paramsCT.get("tempsTravailCollectif").value)
                    this.paramsCT.get("tempsTravailCollectif").setValue(this.getConstanteValue("TPS_TRAV_LEGAL", this.getDateReferenceDossier()));
            }
        });
        this.dataContratTravailBlock = {
            "contratTravail" : "Contrat de travail", //(this.dossier.typecontrat == "CDI" ? "Contrat de travail" : this.dossier.typecontrat),
            "dateSignature" : dateDebFormat,
            // "tempsTravail" : (allDataForm ? (allDataForm["TPS_TRAV"] ? (Math.round(allDataForm["TPS_TRAV"]*100)/100) : "") : "") + (this.unitedata ? (uniteTemps ? " - " + uniteTemps : " - " + this.unitedata.id) + "\n" + tempsType : ""),
        }

        /* #1645 services aléatoirement actif/sélectionné...
        this.services.forEach(element => {
            this.toggleChipPost(element, false)
        });
        */

        this.cdf.detectChanges();
        this.addChangeListeners();
    }
    
    
    modifyValueToggle(event,formGroup, paramForm, isModifiable = true){
        console.log('*** modifyValueToggle',formGroup)
        if (isModifiable) {
            if(event && event.target && event.target.checked){
                formGroup.get(paramForm).setValue("TRUE")
            }else{
                formGroup.get(paramForm).setValue("FALSE")
            }
        }
    }
    
    toggleChipDroitSpec(chip) {
        let i = this.droitSpec.length;
        this.droitSpec.forEach(c => {
            chip.Value !== c.Value ? c.selected = false : (c.selected == true ? c.selected = false : c.selected = true);
            if(c.selected){
                this.dataSalFormGroup.get("PROF_SPEC").setValue(c.Value);
                this.changeInput('PROF_SPEC',this.dataSalFormGroup)

            }else{
                i--;
            }
        });
        if(i==0){
            this.dataSalFormGroup.get("PROF_SPEC").setValue("");
        }
        this.cdf.detectChanges();
    }
    toggleChipTrancheEffectif(chip) {
        let i = this.trancheEffectif.length;
        this.trancheEffectif.forEach(c => {
            chip.Value !== c.Value ? c.selected = false : (c.selected == true ? c.selected = false : c.selected = true);
            if(c.selected){
                this.dataEmpFormGroup.get("EFFECT_EMP").setValue(c.Value);
                this.changeInput('EFFECT_EMP',this.dataEmpFormGroup)

            }else{
                i--;
            }
        });
        if(i==0){
            this.dataEmpFormGroup.get("EFFECT_EMP").setValue("");
            this.required['EFFECT_EMP'] = true
        }
        this.checkTrancheEffect()
        this.cdf.detectChanges();
    }
    toggleChipTrancheEffectifEtab(chip) {
        let i = this.trancheEffectifEtab.length;
        this.trancheEffectifEtab.forEach(c => {
            chip.Value !== c.Value ? c.selected = false : (c.selected == true ? c.selected = false : c.selected = true);
            if(c.selected){
                this.dataEmpFormGroup.get("EFFECT_ETAB").setValue(c.Value);
                this.changeInput('EFFECT_ETAB',this.dataEmpFormGroup)

            }else{
                i--;
            }
        });
        if(i==0){
            this.dataEmpFormGroup.get("EFFECT_ETAB").setValue("");
            // this.required['EFFECT_ETAB'] = true
        }
        this.checkTrancheEffect()
        this.cdf.detectChanges();
    }

    checkTrancheEffect(){
        this.effect_etab_error = false
        // if(this.required['EFFECT_EMP'] || this.required['EFFECT_ETAB'] )
        //     return
        
        // if(this.dataEmpFormGroup.get("EFFECT_EMP").value == "1a10" &&  this.dataEmpFormGroup.get("EFFECT_ETAB").value != "1a10"){
        //     this.effect_etab_error = true
        // }else{
        //     this.effect_etab_error = false
        // }
    }
    toggleChipOptionQualif(chip) {
        let i = this.optionQualif.length;
        this.dataSalFormGroup.get("NIV_CC").setValue("");
        this.dataSalFormGroup.get("ECH_CC").setValue("");
        this.echEnable = []
        this.nivEnable = []
        this.optionQualif.forEach(c => {
            chip.value !== c.value ? c.selected = false : c.selected = true;
            if(c.selected){
                this.qualifSelect = this.optionQualif.filter(e => {
                    return e.value == c.value ? true : false
                });
                if(this.qualifSelect && this.qualifSelect[0] && this.qualifSelect[0].value)
                    this.qualifSelect = this.qualifSelect[0].value
                this.dataSalFormGroup.get("QUALIF_CC").setValue(c.value);
                this.changeInput('QUALIF_CC',this.dataSalFormGroup)
                if(c.niveau){
                    this.nivEnable = this.getAllIndexes(c.niveau)
                    this.nivSelect = null;
                    if (this.nivEnable.length == 1)
                        this.toggleChipOptionNiv(this.nivEnable[0]);
                    
                }
                this.processChangeQualifMain();
            }else{
                i--;
            }
        });
        if(i==0){
            this.dataSalFormGroup.get("QUALIF_CC").setValue("");
        }
        if (!this.niveauIsUsed)
            this.nivEnable = []
        if (!this.echelonIsUsed)
            this.echEnable = []
        this.cdf.detectChanges();
    }
    toggleChipOptionCpTypeCalc(chip) {
        let i = this.cp_type_calc.length;
        this.cp_type_calc.forEach(c => {
            chip.Value !== c.Value ? c.selected = false : c.selected = true;
            if(c.selected){
                this.dataSalFormGroup.get("CP_TYPE_CALC").setValue(c.Value);
            }else{
                i--;
            }
        });
        if(i==0){
            this.dataSalFormGroup.get("CP_TYPE_CALC").setValue(null);
        }
        this.cdf.detectChanges();
    }
    toggleChipOptionNiv(chip) {
        let i = this.nivEnable.length;
        this.echEnable = []
        this.nivEnable.forEach(c => {
            chip !== c ?  '' : (c == this.nivSelect ? this.nivSelect = false : this.nivSelect = c) ;
            if( this.nivSelect == chip){
                let qualif = this.optionQualif.filter(e => {
                    return e.value == this.qualifSelect ? true : false
                });
                if(qualif && qualif[0] &&  qualif[0]['niveau'] && qualif[0]['niveau'][chip]){
                    this.echEnable = qualif[0]['niveau'][chip]
                    this.echSelect = null;
                    if (this.echEnable.length == 1)
                        this.toggleChipOptionEch(this.echEnable[0]);
                }
                this.dataSalFormGroup.get("NIV_CC").setValue(chip);
                this.changeInput('NIV_CC',this.dataSalFormGroup)
                
            }else{
                i--;
            }
        });
        if(i==0){
            this.dataSalFormGroup.get("NIV_CC").setValue("");
        }
        if (!this.echelonIsUsed)
            this.echEnable = []
        this.cdf.detectChanges();
    }
    toggleChipOptionEch(chip) {
        let i = this.echEnable.length;
        this.echEnable.forEach(c => {
            chip !== c ?  '' : (c == this.echSelect ? this.echSelect = false : this.echSelect = c) ;
            if(c == this.echSelect ){
                this.dataSalFormGroup.get("ECH_CC").setValue(c);
                this.changeInput('ECH_CC',this.dataSalFormGroup)
                
            }else{
                i--;
            }
        });
        if(i==0){
            this.dataSalFormGroup.get("ECH_CC").setValue("");
        }
        this.cdf.detectChanges();
    }

    toggleChipOptionQualite(chip) {
        this.qualiteSelect = this.qualiteSelect === chip ? false : chip;

        if (this.qualiteSelect) {
            this.dataSalFormGroup.get("CC_CLASSIF_RANG4").setValue(this.qualiteSelect);
            this.changeInput('CC_CLASSIF_RANG4', this.dataSalFormGroup);
        } else {
            this.dataSalFormGroup.get("CC_CLASSIF_RANG4").setValue("");
        }
        this.cdf.detectChanges();
    }

    async checkDossierForm(){
        console.log('*** checkDossierForm')
        this.required = []
        if(this.myStepper.selectedIndex == 0){ // Mettre à jour le Dossier

            const valid = await this.tabIdentity.validate();
            const form = this.firstFormGroup.getRawValue();
            if(valid){
                this.simulation = form['postSala'] == "TRUE" ? true : false;
                this.diagnostic = form['postSala'] == 'FALSE' ? true: false;
                this.filterIDCCByDates();
                let result = Object.keys(this.dateErr).length == 0 ;
                return result;
            }
        }
        else if(this.dataStep == 1 && this.dataEmpFormGroup){ //Editer les données - l'employeur
            let form = this.dataEmpFormGroup.getRawValue();
            for (let nameInput in form) {
                let value = form[nameInput];
                if(!value || value == "" || value == 'null'){
                    nameInput == "IDCC_CC" && value != 0 ?  this.required[nameInput] = true :null;
                    nameInput == "EFFECT_EMP" ?  this.required[nameInput] = true :null;
                    nameInput == "CP_EMP" && this.displayCodePostal && !this.errorCpEmp ?  this.required[nameInput] = true :null;
                    // nameInput == "EFFECT_ETAB" ?  this.required[nameInput] = true :null;
                    if (this.list_SECTEUR) {
                        let secteurCanBeEmpty = true;
                        this.list_SECTEUR.map((secteur) => {
                            if (secteur != "") {
                                secteurCanBeEmpty = false;
                            }
                        })
                        if (!secteurCanBeEmpty) {
                            nameInput == "CC_SECTEUR" && this.list_SECTEUR ? this.required[nameInput] = true : null;
                        }
                    }
                }
                this.checkTrancheEffect()
            }
            if(form["IDCC_CC_autocomplete"].Value == null || form["IDCC_CC_autocomplete"].Value != form["IDCC_CC"]){
                this.errorSelectCC = true;
            }
            if((!this.required || Object.keys(this.required).length === 0) && !this.effect_etab_error && !this.errorTerritoireCC && !this.errorCpEmp && !this.errorSelectCC){
                return true;
            }
        
        }
        else if(this.dataStep == 2 && this.dataSalFormGroup ){ //Editer les données - le salarié
            let form = this.dataSalFormGroup.getRawValue();
            if(!form["QUALIF_CC"] || form["QUALIF_CC"] == "" ||  form["QUALIF_CC"] == "null" ){
                this.required["QUALIF_CC"] = true
            }
            if(this.niveauIsUsed && this.nivEnable.length && (!form["NIV_CC"] || form["NIV_CC"] == "" ||  form["NIV_CC"] == "null" )){
                this.required["NIV_CC"] = true
            }
            if(this.echelonIsUsed && this.echEnable.length && (!form["ECH_CC"] || form["ECH_CC"] == "" ||  form["ECH_CC"] == "null" )){
                this.required["ECH_CC"] = true
            }
            if (this.coeffIsUsedClassif && this.coeffIsUsedCC && (!form["COEFF_SAL"] || form["COEFF_SAL"] == "" ||  form["COEFF_SAL"] == "null" || this.messageCoeffIncoherent )) {
                this.required["COEFF_SAL"] = true
            }
            console.log("qualif - formulaire salarié : ", form["QUALIF_CC"])

            if(!form["DT_NAIS"] || form["DT_NAIS"] == "" ||  form["DT_NAIS"] == "null" || this.dateNaissAgeErr) {
                this.required["DT_NAIS"] = true
            }
            if(this.need_cp_type_calc && this.cp_type_calc.length && (!form["CP_TYPE_CALC"] || form["CP_TYPE_CALC"] == "" || form["CP_TYPE_CALC"] == "null" )){
                this.required["CP_TYPE_CALC"] = true
            }
            console.log("required formulaire salarié : ", this.required)
            if(!this.required || Object.keys(this.required).length === 0){
                return true;
            }
        }
        else if(this.dataStep == 3 && this.dataCTFormGroup ){ //Editer les données - le contrat de travail
            if(!this.required || Object.keys(this.required).length === 0){
                return true;
            }
        }
        return false;
    }

    changeInput(input, form){
        let formData = form.getRawValue()
        if(formData && formData[input] && this.required && this.required[input]){
            this.required[input] = null
        }
        if (input === "DT_NAIS") {
            this.dateNaissAgeErr = false;
            let dt_nais = (<HTMLFormElement>document.querySelector('input[formControlName="DT_NAIS"]'));
            const dateValue = form.get('DT_NAIS').value;
            if (dt_nais && dt_nais.validity.badInput)
                this.dateErr[dt_nais.getAttribute('formcontrolname')] = true
            else if(this.checkBirthDateValidity(dateValue)){
                this.dateNaissAgeErr = true;
            }
        }
    
        this.cdf.detectChanges()
    }

    // affectDateRupt(value){
    //     let dateRupt = this.dataUpdateDossFormGroup.get("DATE_RUPT").value
    //     this.dataUpdateDossFormGroup.get("DT_LIC").setValue("");
    //     this.dataUpdateDossFormGroup.get("DT_LIC_PERS").setValue("");
    //     this.dataUpdateDossFormGroup.get("DT_LIC_ECO").setValue("");
    //     this.dataUpdateDossFormGroup.get("DT_LIC_RC").setValue("");
    //     this.dataUpdateDossFormGroup.get("DT_DEM").setValue("");
    //     this.dataUpdateDossFormGroup.get("DT_FIN_CONT").setValue("");
    //     this.dataUpdateDossFormGroup.get(value).setValue(dateRupt)
    //     this.paramRupt = value
    //     if(value=="DT_LIC_PERS" || value=="DT_LIC_ECO") this.dataUpdateDossFormGroup.get("DT_LIC").setValue(dateRupt)
    //     else this.dataUpdateDossFormGroup.get("DT_LIC").setValue("")
    // }

    checkValidationDossier(gostep = false){
        
        let result = new Subject<any>();

        if(this.dossier.bulletinSalaire && this.dossier.bulletinSalaire.length >= 2){
            if(this.subscribe && this.subscribe['checkValidationDossier'])
                this.subscribe['checkValidationDossier'].unsubscribe()
            this.subscribe['checkValidationDossier'] = this.appService.checkValidationDossier(this.dossier, false).subscribe((data) => {    
                if(data.result && data.result.dossier && data.result.dossier.bulletinSalaire){
                    if(this.dossier.rapport){
                        let rapport = this.dossier.rapport
                        // let services = this.dossier.services // #1769 bouton éditier les données parfois manquant
                        this.dossier = data.result.dossier
                        this.dossier.rapport = rapport
                        this.screenRapportPrepare();
                        // this.dossier.services = services // #1769 bouton éditier les données parfois manquant
                    }else{
                        // let servicesTmp // #2099
                        // if (this.dossier.services) {
                        //     servicesTmp = this.dossier.services
                        // }
                        this.dossier = data.result.dossier;
                        // if (servicesTmp) { // #2099
                        //     this.dossier.services = servicesTmp
                        //     servicesTmp = null
                        // }
                    }
                    //this.searchServiceSelected() // #1645 déjà appelé au début et actualisé au changement d'état des services
                    let sortBS = data.result.dossier.bulletinSalaire;
                    sortBS.sort(function(a,b){
                        if(!a["datedebutbs"])
                            a["datedebutbs"] = null;
                        if(!b["datedebutbs"])
                            b["datedebutbs"] = null;
                        return a["datedebutbs"] - b["datedebutbs"];
                    })
                    for (let index = 0; index < sortBS.length; index++) {
                        const element = sortBS[index];
                        if( element['datedebutbs']){
                            this.datefirstbsdebut = element['datedebutbs']
                            break;
                        }
                    }
                    this.datelastbsfin = sortBS[sortBS.length - 1]['datefinbs'];
                }
                if(data.result.dossier.valide){
                    this.erreurperiode = null;
                    // this.continue = true;
                }
                // if(data.result.dossier.stop && gostep){
                //     this.continue = false;
                // }
                else{
                    if (gostep && this.userHasUploadedFiles) {
                        this.erreur = true;
                        this.message = data.result.dossier.erreur;
                    }
                    if(data.result.dossier.erreurperiode)
                    this.erreurperiode = data.result.dossier.erreurperiode;
                }
                //// console.log(this.message, this.erreurperiode)
                result.next("fini")
            });
        } else {
            if (this.userHasUploadedFiles) {
                this.erreur = true;
                this.message = ["Merci de télécharger les bulletins de salaire de votre client, avant de passer à l’étape suivante."];
            }
            result.next("fini");
        }
        return result.asObservable();
    }
    btnTelecommandeSortir() {
        window['tryga']('send', 'event', 'telecommande', 'sortir_dossier', '', '');
    }

    async enterStep(indexStep) {
        console.log('*** enterStep')
        window.scrollTo({top: 0, left:0, behavior: 'smooth'});
        this.changeEtatValidationDossier(indexStep);

        if (indexStep < 2 || indexStep >= this.stepResult) {
            this.currentCalculette = {'code': null};
            this.disabled = false;
        }

        if (indexStep !== false)
            this.bggrey = true;
        
        if (indexStep === 0) {//modalité de la rupture
            this.bggrey = false;
            this.dataStep = 3;
            this.helperOn = false;
            this.consumeToken = false;
        } else if (indexStep == 1) {// données salarié et employeur : contient 3 datastep
            this.dataStep = 1;
        } else if (indexStep > 1 && indexStep < this.stepResult) {//calculette iframe
            if (this.forceDisplayStep !== false) {
                await this.goDataStepCalcul('FORCE', this.calculettesInStepper[indexStep - 2].name);// pour attribuer 
            }
            if (indexStep == 2 && (!this.currentCalculette || !this.currentCalculette.code)) {
                await this.goDataStepCalcul('SUIV');// pour attribuer 
            }
            
            if (this.currentCalculette.hasOwnProperty('code')) {
                // this.cdf.markForCheck()
                // if (this.currentCalculette['is_finished']) {
                //     this.processApresDerniereCalculette().then(res => { stepper.next() });
                // } else {
                //     window['tryga']('send', 'event', 'completer_donnees', this.currentCalculette['code'], '', '');
                    this.saveRapportOk = false;
                    this.displayIframe(this.currentCalculette['code'], true);
                // }
            }

        } else if (indexStep === this.stepResult) {//resultat et rapport : contient 2 datastep
            this.dataStep = 1;
            this.displayRapport('synthese');
            this.setDossierComplete(1);
        }
        this.forceDisplayStep = false;
        this.forceDisplayStepFrom = false;
    }
    async leaveStep(indexStepper, action=null) {
        let allowLeavingStep = false;
        if (indexStepper === 0) {//modalité de la rupture
            this.disabled = true;
            if (this.dataStep == 1) {
                allowLeavingStep = await this.goDataStepBis(3, action, 'results');
                this.helperOn = false;
                this.bggrey = false;
                //window['tryga']('send', 'event', 'dossier', 'suivant_debut', '', '');
                // this.uploadBulletin = false
                if (this.toDelegate == true) {
                    this.fillDelegationForm = true;
                }
                this.consumeToken = false;
                window['tryga']('send', 'event', 'dossier', 'consommer_un_credit', '', '');
                if (!this.delegationToken) {
                    allowLeavingStep = await this.goDataStepBis(3, action, 'results');
                }
            } else if (this.dataStep == 2) {
                allowLeavingStep = await this.goDataStepBis(3, action, 'results');
                this.bggrey = true;
            } else if (this.dataStep == 3) {
                allowLeavingStep = await this.goDataStepBis(3, action, 'datas', 'firstFormGroup');
            }
            this.disabled = allowLeavingStep;
        } else if (indexStepper == 1) {// données salarié et employeur : contient 3 datastep
            allowLeavingStep = await this.goDataStepBis(3, action, 'datas');
            if (allowLeavingStep)
                this.disabled = true;
        } else if (indexStepper > 1 && indexStepper < this.stepResult) {//calculette iframe
            if (action == 'SUIV') {
                if (this.saveRapportOk == false){ 
                    this.disabled = true;
                    this.disabledAdditionalButton = true;
                    this.quitCalcul(action);
                } else {
                    if (this.currentCalculette && this.currentCalculette.hasOwnProperty('is_last_calculette_displayed') && this.currentCalculette['is_last_calculette_displayed']) {
                        this.dialogLoading = this.dialog.open(DialogsLoadingComponent, {
                            width: '100%',
                            panelClass:'message-dialog-supp',
                            disableClose: true,
                            data: {'message': 'Génération des rapports en cours.'}
                        });
                    }
                    this.saveRapportOk = false;
                    this.disabled = true
                    this.disabledAdditionalButton = true
                    await this.goDataStepCalcul(action);// get next displayed calc (or do final not displayed calc)

                    if (this.currentCalculette.hasOwnProperty('is_finished') && this.currentCalculette['is_finished'] && !this.currentCalculette['is_last_calculette_displayed']) {
                        await this.processApresDerniereCalculette().then(res => { 
                            allowLeavingStep = true;
                        });
                        console.log('ici');
                    } else {
                        allowLeavingStep = true;
                    }
                }
            } else if (action == 'PREC') {
                this.saveRapportOk = false;
                this.disabled = false;
                this.disabledAdditionalButton = true;
                this.iframeHTML(null);
                this.cdf.markForCheck()
                if (indexStepper > 2) {
                    this.disabled = true;
                    await this.goDataStepCalcul(action);// get next displayed calc (or do final not displayed calc)
                }
                allowLeavingStep = true;
            } else if (action === null) {
                if (this.calcul) {
                    let frame = <HTMLElement> document.querySelector('#iframe_container iframe');
                    frame['contentWindow'].postMessage({'action': 'trigger-partial-save-no-exit', 'dossierid': this.dossier.id},this.BOCC_URL);
                } else {
                    allowLeavingStep = true;
                }
            }
        } else if (indexStepper === this.stepResult) {//resultat et rapport : contient 2 datastep
            allowLeavingStep = await this.goDataStepBis(2, action, 'results');
            if (allowLeavingStep)
                this.rapportSelected = [];
        }
        return allowLeavingStep;
    }
    async goDataStepBis(dataStepMax, action, type, sendDataForm=null) {
        let allowLeavingStep = false;
        if (action == 'SUIV') {
            allowLeavingStep = type == 'results' ? true : (this.dossier && this.dossier.id ? await this.checkDossierForm() && await this.sendDataForm(sendDataForm) : await this.checkDossierForm() && await this.submitCreatDoss());
            if (allowLeavingStep && this.dataStep < dataStepMax) {
                window.scrollTo({top: 0, left:0, behavior: 'smooth'});
                this.dataStep++;
                this.cdf.detectChanges();
                allowLeavingStep = false;
            } else if (this.dataStep == dataStepMax && sendDataForm !== null) {
                this.disabled = true;
            } else if (allowLeavingStep && this.dataStep == dataStepMax && sendDataForm === null) {
                if (this.promise.hasOwnProperty('addDossierEntete')) {
                    this.disabled = true;
                    await Promise.all(this.promise['addDossierEntete']).then((value) => {});
                }
            }
        } else if (action == 'PREC') {
            if (this.dataStep == 1) {
                allowLeavingStep = true;
            } else if (this.dataStep > 1) {
                window.scrollTo({top: 0, left:0, behavior: 'smooth'});
                this.dataStep--;
            }
        } else if (action === null) {
            allowLeavingStep = true;
        }
        return allowLeavingStep;
    }
    async goToStep(stepper:MatStepper, action = 'SUIV') {
        let leavingStepIndex = stepper.selectedIndex;
        if (this.forceDisplayStep !== false) {
            action = null;
            leavingStepIndex = this.forceDisplayStepFrom;
        }
        if (await this.leaveStep(leavingStepIndex, action)) {
            this.actionStepTriggerManually = true;
            if (action == 'PREC') {
                stepper.previous();
            } else if (action == 'SUIV') {
                this.maxStateSteps[leavingStepIndex] = 1;
                stepper.selected.completed = true;
                stepper.next();
            } else if (this.forceDisplayStep !== false) {
                stepper.selectedIndex = this.forceDisplayStep;
                this.enterStep(this.forceDisplayStep);
            }
        }
    }
    jumpToStep(stepper:MatStepper, origineStep, destinationStep) {
        this.forceDisplayStepFrom = origineStep;
        this.forceDisplayStep = destinationStep;
        this.goToStep(stepper);
    }
    async stepperSelectionChange(event:any) {
        let enterSelectedStep = true;
        if (!this.actionStepTriggerManually) {
            this.forceDisplayStepFrom = event.previouslySelectedIndex;
            this.forceDisplayStep = event.selectedIndex;
            if (1 < this.forceDisplayStep && this.forceDisplayStep < this.stepResult)
                this.disabled = true;
            let allowLeavingStep = await this.leaveStep(event.previouslySelectedIndex);
            if (!allowLeavingStep) {
                enterSelectedStep = false;
            }
        }
        this.actionStepTriggerManually = false;
        if (enterSelectedStep)
            this.enterStep(event.selectedIndex);
    }

    async goStep(stepper:MatStepper, currentStep, nextStep, action = null){
        // this.stepIsComplete = true;
        stepper.selected.completed = true;
        /* #691 2022-11-28 GA USE */
        console.log('---------------------------------------------')
        console.log('currentStep')
        console.log(currentStep)
        console.log('--')
        console.log('nextStep')
        console.log(nextStep)
        console.log('this.dataStep')
        console.log(this.dataStep)
        console.log('---------------------------------------------')
        // if (currentStep == 0 && nextStep == 1) { // Ajouter les bulletins de salaire
        //     window['tryga']('send', 'event', 'ajouter_bulletins_salaire', '', '', '');
        // }
        // if (currentStep == 0 && nextStep == 2) { // Les services Rupture by Cobham
        //     window['tryga']('send', 'event', 'selectionner_services', '', '', '');
        // }
        // else 
        if (currentStep == 0 && nextStep == 1) { // L'employeur
            // let services = this.dossier.services.map((ser) => { return ser.code});
            // window['tryga']('send', 'event', 'selectionner_services', 'suivant', services.join(','), '');

            window['tryga']('send', 'event', 'completer_donnees', 'employeur', '', '');
        }
        else if (currentStep == 1 && nextStep == null) {
            /* SCREEN DEROULE */
            if (this.dataStep == 1) { // Le Salarié
                window['tryga']('send', 'event', 'completer_donnees', 'salarie', '', '');
            }
            else if (this.dataStep == 2) { // Le contrat de travail
                window['tryga']('send', 'event', 'completer_donnees', 'contrat_travail', '', '');
            }
            else if (this.dataStep > 2) { // calculette
                // déporté dans goDataStepCalcul()
            }
        }
        else if (currentStep == 3 && nextStep == 4) { // Les rapports
            window['tryga']('send', 'event', 'consulter_resultats', 'affichage_rapport', '', '');
        }
        else if (currentStep == 4 && nextStep == 4) { // Consulter les résultats
            window['tryga']('send', 'event', 'telecommande', 'consulter_resultats', '', '');
        }
        // else if (currentStep == 4 && nextStep == 2) { // Sélectionner les services
        //     window['tryga']('send', 'event', 'telecommande', 'selectionner_services', '', '');
        // }
        else if (currentStep == 3 && nextStep == 2) { // Compléter les données
            window['tryga']('send', 'event', 'telecommande', 'completer_donnees', '', '');
        }
        else if (currentStep == 1 && nextStep == 0) { // Mettre à jour son dossier
            window['tryga']('send', 'event', 'telecommande', 'mettre_jour_dossier', '', '');
        }
        /* #691 2022-11-28 GA USE */

        //// console.log("DISABLED", this.disabled)
        // console.log("current - next " + currentStep + " - "+ nextStep)
        let err = false
        if(currentStep === 0 && nextStep === 1){
            // console.log("current 0 - next 1 => erreur false")
            this.erreur = false
            this.sendDataForm("dataUpdateDossFormGroup");
        }
        //Si uploadBS -> checkup
        // if(currentStep == 1){
        //     if(this.newBs && this.newBs.length > 0){
        //         await new Promise(resolve => this.checkValidationDossier(true).subscribe((res) => {
        //             resolve(res);
        //             this.suivantUploadDisabled = false
        //             this.cdf.detectChanges();
        //         }))
        //         // this.checkValidationDossier(true);
        //     }
        //     // else if(this.missingBS.length > 0){
        //     //     console.log("no new bs")

        //     //     this.erreur = true
        //     // }
        //     if(this.erreur && this.erreurperiode){
        //         err = true;
        //     }
        // } 
        //Si diag /simul /rapport -> dossier.complete = true
        if( nextStep > 1 ){
            if(!this.dossier.complete){
                this.subscribe['setDossierComplete'] = this.appService.setDossierComplete(this.dossier.id, 1).subscribe((res)=>{
                    if(res && res["result"] && res["result"]["success"] && res["result"]["etatComplete"]){
                        console.log("change complete to 1")
                        this.dossier.complete = 1;
                        document.documentElement.style.setProperty('--stepper','#6016AA' )
                    }
                })
            }
        // } else if (nextStep == 1) {
        //     // this.updateServicesAvailable();
        }
        if(currentStep !== 1 && !err){ 
            // console.log("current != 3 et !err ")
            // this.changeEtatValidationDossier(currentStep, nextStep)
        }
        
        if(currentStep === 1 && this.dataStep < 3){
            this.disabled = false
            this.needInputs = []
            this.goDataStep(stepper, action);
        // } else if(currentStep === 1 && this.dataStep == 3){
        //     this.saveRapportOk = false;
        //     this.disabled = true;
        } else if(currentStep >= 1 && action == 'SUIV') {
            nextStep = nextStep ? nextStep : currentStep + 1;
            if (this.saveRapportOk == false){ 
                this.disabled = true;
                this.disabledAdditionalButton = true;
                this.quitCalcul('action après sortie calc');
            } else if (nextStep < this.stepResult) {
                stepper.selectedIndex = nextStep ? nextStep : currentStep + 1;
                this.saveRapportOk = false;
                this.disabled = true
                this.disabledAdditionalButton = true
                if (currentStep === 1) {
                    // premiere calculette : il faut attendre que les données de l'écran que l'on quitte soient bien enregister avant d'appeler this.displayCalcul
                    // car sinon, la calculette reçoit des datas pas encore mise à jour (=anciennes valeurs)
                    // Promise.all(this.promise['addDossierEntete']).then((value) => {
// this.goDataStepCalcul(stepper, action);
                    // });
                } else {
// this.goDataStepCalcul(stepper, action);
                }
            } else if (this.currentCalculette && this.currentCalculette.hasOwnProperty('is_last_calculette_displayed') && this.currentCalculette['is_last_calculette_displayed']) {
// this.goDataStepCalcul(stepper, action);
                this.dialogLoading = this.dialog.open(DialogsLoadingComponent, {
                    width: '100%',
                    panelClass:'message-dialog-supp',
                    disableClose: true,
                    data: {'message': 'Calculs en cours'}
                });
            // }
            } else if(nextStep === this.stepResult){
                // 1846 - point 32
                // (<HTMLElement> document.querySelector('#nextStepButton')).innerHTML = this.nextStepButtonText // reset
                // this.nextStepIsResult = false
                // this.pageIsResults = false
                
                // this.calcsAreDone = false;

                if(this.subscribe['setDossierComplete']){
                    this.subscribe['setDossierComplete'].unsubscribe();
                }
                this.subscribe['setDossierComplete'] = this.appService.setDossierComplete(this.dossier.id, 0).subscribe((res)=>{
                    // this.getCalculetteState();
                    if(res && res["result"] && res["result"]["success"]){
                        console.log('change dossier complete =>  0')
                        this.dossier.complete = 0;

                        this.dataStep = 1;
                        this.disabled = false
                        this.needInputs = []
                        // this.cdf.markForCheck()
                        stepper.selectedIndex = nextStep;
                    }
                })
            }
            else if(currentStep === this.stepResult){
                this.disabled = false;
                this.needInputs = [];
                this.goDataStepRapport(stepper, action);
            }
        } else if((currentStep > 1 && action == 'PREC')) {
            // TODO
        }else if(!(currentStep == 1 && this.erreur)){
            stepper.selectedIndex = nextStep;
        }
    }
    
    goDataStepRapport(stepper:MatStepper, action){
        window.scrollTo({top: 0, left:0, behavior: 'smooth'});
        if(action === "PREC"){
            this.disabled = false
            this.dataStep--;
            // this.cdf.detectChanges()
        }
        else if(action === "SUIV"){
            this.dataStep++;
            // this.cdf.detectChanges()
        }
    }

    // Mise en place de l'ordre des formulaires 
    //COB-235 
    goDataStep(stepper:MatStepper, action){
        window.scrollTo({top: 0, left:0, behavior: 'smooth'});
        if(action === "PREC"){

            // (<HTMLElement> document.querySelector('#nextStepButton')).innerHTML = this.nextStepButtonText // 1846 - point 32
            // this.nextStepIsResult = false

            this.disabled = false
            this.calcul = false;
            this.showAdditionalButton = false;
            this.titreAdditionalButton = "";
            this.callbackAdditionalButton = "";
            ////// console.log("DISABLED", this.disabled)
            if(this.dataStep <= 4){
                this.currentCalculette = {'code': null}
                this.dataStep--;
            // }else{
            //     if (this.currentCalculette && this.currentCalculette.hasOwnProperty('is_first_calculette_displayed') && this.currentCalculette['is_first_calculette_displayed']) {
            //         this.currentCalculette = {'code': null}
            //         this.dataStep = 3;
            //     } else {
            //         this.goDataStepCalcul(stepper, action);
            //     }
            }
        }
        else if(action === "SUIV"){
            let isValid = true;
            // if(this.dataStep <= 3 && this.saveRapportOk == false){
            //     isValid = this.sendDataForm();
            // }
            if (!isValid) 
                return;
            if(this.dataStep <= 2){
                this.dataStep++;
            }else{
                // if(this.dataStep >= 4 && this.saveRapportOk == false){ 
                //     this.disabled = true;
                //     this.disabledAdditionalButton = true;
                //     this.quitCalcul('action après sortie calc');
                // }else{
                    this.saveRapportOk = false;
                    // if (this.currentCalculette && this.currentCalculette.hasOwnProperty('is_last_calculette_displayed') && this.currentCalculette['is_last_calculette_displayed']) {
                    //     this.dialogLoading = this.dialog.open(DialogsLoadingComponent, {
                    //         width: '100%',
                    //         panelClass:'message-dialog-supp',
                    //         disableClose: true,
                    //         data: {'message': 'Calculs en cours'}
                    //     });
                    // }
                    this.disabled = true
                    this.disabledAdditionalButton = true
                    if (this.dataStep === 3) {
                        // stepper.next();
                        // premiere calculette : il faut attendre que les données de l'écran que l'on quitte soient bien enregister avant d'appeler this.displayCalcul
                        // car sinon, la calculette reçoit des datas pas encore mise à jour (=anciennes valeurs)
                        // Promise.all(this.promise['addDossierEntete']).then((value) => {
                        //     this.goDataStepCalcul(stepper, action);
                        // });
                    // } else {
                    //     this.goDataStepCalcul(stepper, action);
                    }
                // }
            }
        }
    }

    async goDataStepCalcul(action, forceCode=null) {
        let currentCalculetteCode = this.currentCalculette && this.currentCalculette.hasOwnProperty('code') ? this.currentCalculette['code'] : null;
        await new Promise(resolve => this.appService.getDisplayedCalculette(this.dossier.id, action, forceCode ? forceCode : currentCalculetteCode).subscribe((res)=>{
            if(res && res.result){
                if (res.result.filter_calculettes_condition) {
                    let calculettesInStepper = res.result.filter_calculettes_condition.filter(calc => calc.displayed);
                    if (this.stepResult != 2 + calculettesInStepper.length) {
                        this.stepResult = 2 + this.calculettesInStepper.length;
                        this.calculettesInStepper = calculettesInStepper;
                        this.cdf.detectChanges();
                    }
                }
                this.currentCalculette = res.result
                if (this.currentCalculette.hasOwnProperty('getDossierEntete')) {
                    this.dossier.entete = this.currentCalculette['getDossierEntete'].entete;
                    delete this.currentCalculette['getDossierEntete'];
                }
                if (this.currentCalculette.alerte_periode_etendue_salref) {
                    this.dialog.open(DialogQuestionMessage, {
                        width: '50%',
                        data: {
                            title: "Salaire de référence",
                            body: "La modification de la date de sortie du salarié a entraîné l'ajout de nouvelles "
                                + "périodes dans le calcul détaillé du salaire de référence. Veuillez vérifier les "
                                + "montants saisis pour ces nouvelles périodes avant de poursuivre.",
                            negativeButton: "Fermer",
                            positiveButton: "J'ai compris",
                        }
                    });
                }
                // if (this.currentCalculette.hasOwnProperty('json_data_entree') && this.currentCalculette.hasOwnProperty('code') && this.currentCalculette.hasOwnProperty('order') && this.currentCalculette.hasOwnProperty('is_finished')) {
                if (this.currentCalculette.hasOwnProperty('json_data_entree')) {
                    this.jsonCalculette = JSON.stringify(this.currentCalculette['json_data_entree']);
                    // this.cdf.markForCheck()
                    // if (this.currentCalculette['is_finished']) {
                    //     this.processApresDerniereCalculette().then(res => { stepper.next() });
                    // } else {
                    //     window['tryga']('send', 'event', 'completer_donnees', this.currentCalculette['code'], '', '');
                    //     this.displayIframe(this.currentCalculette['code'], true);
                    // }
                }
            }
            resolve(res);
        }))
    }

    async processApresDerniereCalculette() {
        await new Promise(resolve => this.createRapports().subscribe((res) => {
            resolve(res);
            if (res && res["allRapports"]) {
                this.syntheseGeneree = res["rapports"] && res["rapports"]["synthese"] || null;
                this.dossier.rapport = res["allRapports"];
                this.fragments = []
                this.dossier.rapport.forEach((rapport) => {
                    this.fragments[rapport.calcul] = rapport.fragments
                })
            }
        }))

        /*await new Promise(resolve => this.createCourriers().subscribe((res) => {
            resolve(res);
            if (res[0]) {
                this.dossier.courriers = res;
            }
        }))*/

        this.screenRapportPrepare();
        this.screenCourrierPrepare();
        this.checkIfDossierHasDoublon();
        
        this.setDossierComplete(1);
        this.changedFields = {};
        this.cdf.detectChanges();

        this.computeStrCalculResult();
        // this.getSalaireRef();
        // this.getSdcCumul();
        // this.getIccpMntNb();
        // this.changeEtatValidationDossier(3, 4);

        console.log('dossier à la fin des calculettes', this.dossier)

        if (this.dialogLoading != null) { // #1846 point 32 loading
            this.dialogLoading.close();
            this.dialogLoading = null;
            // (<HTMLElement> document.querySelector('#nextStepButton')).innerHTML = this.nextStepButtonText;
        }
    }

    dossier_post_sendDataForm(type = null){
        console.log('*** sendDataForm')
        let data;
        let triggerSaveJsonCCData = false;
        if(type){
            data = this.dataUpdateDossFormGroup.getRawValue()
            data['DT_FIN_PERIODE_BS'] = this.formatDate3(this.dateParamsForPayslips.endDatePeriod);
            data['DT_DEBUT_PERIODE_BS'] = this.formatDate3(this.dateParamsForPayslips.startDatePeriod);
            if (this.dossier.entete && this.getEnteteFromCode("MOTIF_SORTIE") != data['MOTIF_SORTIE'])
                data['MOTIF_SORTIE_CHANGED'] = 'TRUE';
        }else{

            switch (this.dataStep) {
                case 1:
                    data = this.dataEmpFormGroup.getRawValue()
                    triggerSaveJsonCCData = true;
                    break;
                case 2:
                    data = this.dataSalFormGroup.getRawValue()
                    break;
                case 3:
                    let dataToSave_av_param = "";
                    if ((this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE" || this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "FALSE") && this.listAvenant.length > 0) {
                        dataToSave_av_param = JSON.parse(JSON.stringify(this.listAvenant));// "JSON.parse(JSON.stringify" car sinon c'est l'objet this.listAvenant qui est modifié
                    }
                    Object.keys(dataToSave_av_param).map(function(index) {
                        dataToSave_av_param[index] = Object.values(dataToSave_av_param[index]).slice(0,6)
                    });
                    data = this.dataCTFormGroup.getRawValue();
                    data["CT_PARAM"] = Object.values(this.paramsCT.getRawValue());
                    data["AV_PARAM"] = dataToSave_av_param;
                    console.log("data", data);
                    let success = this.checkCTAV();
                    if (!success) {
                        console.log("____ Stop", this.paramsCT, this.listAvenant, "les autres : ", this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value, this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value)
                        return false;
                    }
                    
                    let pressoc = [];
                    pressoc.push(this.dataCTFormGroup.get("DR_PRES_SOC_CC_ANNEE").value);
                    pressoc.push(this.dataCTFormGroup.get("DR_PRES_SOC_CC_MOIS").value);
                    data["DR_PRES_SOC_CC"] = JSON.parse(JSON.stringify(pressoc));

                    delete data["DR_PRES_SOC_CC_MOIS"];
                    delete data["DR_PRES_SOC_CC_ANNEE"];
                    break;
                default:
                    break;
            }
        }
        if(data){
            if (this.dataStep == 3) {
                this.promise['addDossierEntete'] = [
                    this.appService.saveCalculData(this.dossier.id, data).toPromise().then((res) => {
                        // this.updateEtatComplete(res)
                        this.checkIfDossierHasDoublon();
                    })
                ];
            } else {
                if(this.subscribe['addDossierEntete']){
                    this.subscribe['addDossierEntete'].unsubscribe();
                }
                this.subscribe['addDossierEntete'] = this.appService.addDossierEntete(this.dossier.id, data).pipe(first()).subscribe((res)=>{
                    // this.appService.updateDossierLight(this.dossier.id,  {'motifsortie': this.dataUpdateDossFormGroup.get("MOTIF_SORTIE").value}).subscribe((res) => {
                    // });
                    if (triggerSaveJsonCCData)
                        this.appService.saveCalculData(this.dossier.id,  this.json_cc_data).subscribe((res) => {
                            this.checkIfDossierHasDoublon();
                        });
                    if(res && res.result && res.result.entete){
                        let newMotif = this.getEnteteFromCode("MOTIF_SORTIE", res.result.entete);
                        if (this.dossier.motifsortie != newMotif) {
                            this.appService.resetAllRisquesData(this.dossier.id).subscribe((res) => {
                                // en simulation lors du premier passage, on choisi le motif de sortie pour la première fois. Si on refait le parcours directement après l'écran résultat, il ne faut pas reset les risques : 
                                if (this.dossier.motifsortie == "")
                                    this.dossier.motifsortie = newMotif
                            })
                        }
                        this.dossier.entete = res.result.entete;
                        //this.stateService.updateDossier(this.dossier);

                        // if (this.myStepper.selectedIndex === 1) {
                        //     this.appService.getMissingBS(this.dossier, true).subscribe((missing)=>{
                        //         if(missing && missing.result && missing.result.missingBS){
                        //             this.missingBS = missing.result.missingBS
                        //             this.nbMoisBsOk = (missing.result.NB_MOIS_PERIODE_BS ? missing.result.NB_MOIS_PERIODE_BS : 18) - missing.result.missingBS.length
                        //             this.cdf.markForCheck()
                        //         }
                        //     })
                        // }
                    }
                    // this.updateEtatComplete(res)
                })
                // await new Promise(resolve => this.appService.addDossierEntete(this.dossier.id, data).pipe(first()).subscribe((res)=>{
                //     this.appService.updateDossierLight(this.dossier.id,  {'motifsortie': this.dataUpdateDossFormGroup.get("MOTIF_SORTIE").value}).subscribe((res) => {
                //     });
                //     if (triggerSaveJsonCCData)
                //         this.appService.saveCalculData(this.dossier.id,  this.json_cc_data).subscribe((res) => {
                //             this.checkIfDossierHasDoublon();
                //         });
                //     if(res && res.result && res.result.entete){
                //         let newMotif = this.getEnteteFromCode("MOTIF_SORTIE", res.result.entete);
                //         if (this.dossier.motifsortie != newMotif) {
                //             this.appService.resetAllRisquesData(this.dossier.id).subscribe((res) => {
                //                 // en simulation lors du premier passage, on choisi le motif de sortie pour la première fois. Si on refait le parcours directement après l'écran résultat, il ne faut pas reset les risques : 
                //                 if (this.dossier.motifsortie == "")
                //                     this.dossier.motifsortie = newMotif
                //             })
                //         }
                //         this.dossier.entete = res.result.entete;
                //         //this.stateService.updateDossier(this.dossier);

                //         // if (this.myStepper.selectedIndex === 1) {
                //         //     this.appService.getMissingBS(this.dossier, true).subscribe((missing)=>{
                //         //         if(missing && missing.result && missing.result.missingBS){
                //         //             this.missingBS = missing.result.missingBS
                //         //             this.nbMoisBsOk = (missing.result.NB_MOIS_PERIODE_BS ? missing.result.NB_MOIS_PERIODE_BS : 18) - missing.result.missingBS.length
                //         //             this.cdf.markForCheck()
                //         //         }
                //         //     })
                //         // }
                //     }
                //     this.updateEtatComplete(res)
                //     resolve(res);
                // })
                // );
            }   
        }
        
        return true;
    }
    async sendDataForm(type = null){
        console.log('*** sendDataForm')
        let savedDataStep = this.dataStep;
        let data;
        let triggerSaveJsonCCData = false;
        if(type){
            data = this.firstFormGroup.getRawValue();
            data = {...data, ...this.getDataEnteteEntreprise()};
            

                    
            // if (this.dossier_add_dataFromUploadedFile && Object.keys(this.dossier_add_dataFromUploadedFile).length > 0) {
            //     this.appService.processRecoResponse(this.dossier.id, this.dossier_add_dataFromUploadedFile).subscribe((res) => {
            //         this.dossier_add_forceReloadPayslips();
            //         this.dossier_add_fichiersCreation = [];
            //         this.dossier_add_dataFromUploadedFile = {};
            //         // this.myStepper.next()
            //         this.dossier_add_nextButtonIsDisabled = false;
            //     });
            // } else {
            //     // this.myStepper.next()
            //     this.dossier_add_nextButtonIsDisabled = false;
            // }
            delete Object.assign(data, data, {['PRE_SAL']: data['firstnameSala'] })['firstnameSala'];
            delete Object.assign(data, data, {['NOM_SAL']: data['nameSala'] })['nameSala'];
            delete Object.assign(data, data, {['NOM_EMP']: data['nameEntSala'] })['nameEntSala'];
            delete Object.assign(data, data, {['MOTIF_SORTIE']: data['motifSala'] })['motifSala'];
            delete Object.assign(data, data, {['DT_S']: data['dateContSortieSala'] })['dateContSortieSala'];
            delete Object.assign(data, data, {['DT_DEBUT_CONT']: data['dateContSala'] })['dateContSala'];
            delete Object.assign(data, data, {['EN_POSTE']: data['postSala'] })['postSala'];
            delete Object.assign(data, data, {['BOOL_MALADIE_LIC']: data['maladieSala'] })['maladieSala'];
            delete Object.assign(data, data, {['DT_ARRET_TRAV']: data['dateMaladieSala'] })['dateMaladieSala'];
            delete Object.assign(data, data, {['BOOL_CONT_ROMPU']: data['contRompu'] })['contRompu'];
            delete Object.assign(data, data, {['BOOL_RUPT']: data['boolRupt'] })['boolRupt'];
            delete Object.assign(data, data, {['NAT_CONT']: data['typeSala'] })['typeSala'];
            delete Object.assign(data, data, {['CIV_SAL']: data['civiliteSala'] })['civiliteSala'];
            delete Object.assign(data, data, {['SIRET']: data['siret'] })['siret'];
            delete Object.assign(data, data, {['DATE_RUPT']: data['dateRupt'] })['dateRupt'];
            data[data['nomDateRupt']] = data['DATE_RUPT'];
            if (['DT_LIC_ECO','DT_LIC_PERS','DT_LIC_RC'].includes(data['nomDateRupt']))
                data['DT_LIC'] = data['DATE_RUPT'];
            delete data['nomDateRupt'];

            // data['DT_FIN_PERIODE_BS'] = this.formatDate3(this.dateParamsForPayslips.endDatePeriod);
            // data['DT_DEBUT_PERIODE_BS'] = this.formatDate3(this.dateParamsForPayslips.startDatePeriod);
            if (this.dossier.entete && this.getEnteteFromCode("MOTIF_SORTIE") != data['MOTIF_SORTIE'])
                data['MOTIF_SORTIE_CHANGED'] = 'TRUE';
        }else{

            switch (this.dataStep) {
                case 1:
                    data = this.dataEmpFormGroup.getRawValue()
                    this.updateCCparam();
                    delete(data['IDCC_CC_autocomplete']);
                    triggerSaveJsonCCData = true;
                    break;
                case 2:
                    data = this.dataSalFormGroup.getRawValue()
                    break;
                case 3:
                    let dataToSave_av_param = "";
                    if ((this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE" || this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "FALSE") && this.listAvenant.length > 0) {
                        dataToSave_av_param = JSON.parse(JSON.stringify(this.listAvenant));// "JSON.parse(JSON.stringify" car sinon c'est l'objet this.listAvenant qui est modifié
                    }
                    Object.keys(dataToSave_av_param).map(function(index) {
                        dataToSave_av_param[index] = Object.values(dataToSave_av_param[index]).slice(0,6)
                    });
                    data = this.dataCTFormGroup.getRawValue();
                    data["CT_PARAM"] = Object.values(this.paramsCT.getRawValue());
                    data["AV_PARAM"] = dataToSave_av_param;
                    console.log("data", data);
                    let success = this.checkCTAV();
                    if (!success) {
                        console.log("____ Stop", this.paramsCT, this.listAvenant, "les autres : ", this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value, this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value)
                        return false;
                    }
                    
                    let pressoc = [];
                    pressoc.push(this.dataCTFormGroup.get("DR_PRES_SOC_CC_ANNEE").value);
                    pressoc.push(this.dataCTFormGroup.get("DR_PRES_SOC_CC_MOIS").value);
                    data["DR_PRES_SOC_CC"] = JSON.parse(JSON.stringify(pressoc));

                    delete data["DR_PRES_SOC_CC_MOIS"];
                    delete data["DR_PRES_SOC_CC_ANNEE"];
                    break;
                default:
                    break;
            }
        }
        if(data){
            if (this.dataStep == 3 && (!type || type != "firstFormGroup")) {
                this.promise['addDossierEntete'] = [
                    this.appService.saveCalculData(this.dossier.id, data).toPromise().then((res) => {
                        this.checkIfDossierHasDoublon();
                    })
                ];
            } else {
                if(this.subscribe['addDossierEntete']){
                    this.subscribe['addDossierEntete'].unsubscribe();
                }
                this.subscribe['addDossierEntete'] = this.appService.addDossierEntete(this.dossier.id, data).pipe(first()).subscribe((res)=>{
                    if (triggerSaveJsonCCData)
                        this.appService.saveCalculData(this.dossier.id,  this.json_cc_data).subscribe((res) => {
                            this.checkIfDossierHasDoublon();
                        });
                    if(res && res.result && res.result.entete){
                        let newMotif = this.getEnteteFromCode("MOTIF_SORTIE", res.result.entete);
                        if (this.dossier.motifsortie != newMotif) {
                            this.appService.resetAllRisquesData(this.dossier.id).subscribe((res) => {
                                // en simulation lors du premier passage, on choisi le motif de sortie pour la première fois. Si on refait le parcours directement après l'écran résultat, il ne faut pas reset les risques : 
                                if (this.dossier.motifsortie == "")
                                    this.dossier.motifsortie = newMotif
                            })
                        }
                        this.dossier.entete = res.result.entete;
                        if (type) {
                            if(type == "firstFormGroup"){
                                this.updateDossierData();
                            }
                            else{
                                this.setupDataBlock(false);
                            }
                            // this.dossier.datedebut = dossier.dateContSala;
                            // this.dossier.datesortie = dossier.dateContSortieSala;
                            // this.dossier.poste = dossier.postSala;
                            // this.dossier.motifsortie = dossier.motifSala;
                        } else if (savedDataStep == 1) {
                            // let entete_IDCC_CC = this.getEnteteFromCode("IDCC_CC");
                            // let entete_LIB_CC = this.getEnteteFromCode("LIB_CC");
                            // this.dataSalBlock["Numéro Convention collective"] = entete_IDCC_CC != "0" ? entete_IDCC_CC : "";
                            // this.dataSalBlock["Convention collective"] = entete_LIB_CC != "Légal" ? entete_LIB_CC : "A défaut de convention collective,\napplication du droit du travail";
                        }
                        //this.stateService.updateDossier(this.dossier);

                        // if (this.myStepper.selectedIndex === 1) {
                        //     this.appService.getMissingBS(this.dossier, true).subscribe((missing)=>{
                        //         if(missing && missing.result && missing.result.missingBS){
                        //             this.missingBS = missing.result.missingBS
                        //             this.nbMoisBsOk = (missing.result.NB_MOIS_PERIODE_BS ? missing.result.NB_MOIS_PERIODE_BS : 18) - missing.result.missingBS.length
                        //             this.cdf.markForCheck()
                        //         }
                        //     })
                        // }
                    }
                    // this.updateEtatComplete(res)
                });
                // await new Promise(resolve => this.appService.addDossierEntete(this.dossier.id, data).pipe(first()).subscribe((res)=>{
                //     this.appService.updateDossierLight(this.dossier.id,  {'motifsortie': this.dataUpdateDossFormGroup.get("MOTIF_SORTIE").value}).subscribe((res) => {
                //     });
                //     if (triggerSaveJsonCCData)
                //         this.appService.saveCalculData(this.dossier.id,  this.json_cc_data).subscribe((res) => {
                //             this.checkIfDossierHasDoublon();
                //         });
                //     if(res && res.result && res.result.entete){
                //         let newMotif = this.getEnteteFromCode("MOTIF_SORTIE", res.result.entete);
                //         if (this.dossier.motifsortie != newMotif) {
                //             this.appService.resetAllRisquesData(this.dossier.id).subscribe((res) => {
                //                 // en simulation lors du premier passage, on choisi le motif de sortie pour la première fois. Si on refait le parcours directement après l'écran résultat, il ne faut pas reset les risques : 
                //                 if (this.dossier.motifsortie == "")
                //                     this.dossier.motifsortie = newMotif
                //             })
                //         }
                //         this.dossier.entete = res.result.entete;
                //         //this.stateService.updateDossier(this.dossier);

                //         // if (this.myStepper.selectedIndex === 1) {
                //         //     this.appService.getMissingBS(this.dossier, true).subscribe((missing)=>{
                //         //         if(missing && missing.result && missing.result.missingBS){
                //         //             this.missingBS = missing.result.missingBS
                //         //             this.nbMoisBsOk = (missing.result.NB_MOIS_PERIODE_BS ? missing.result.NB_MOIS_PERIODE_BS : 18) - missing.result.missingBS.length
                //         //             this.cdf.markForCheck()
                //         //         }
                //         //     })
                //         // }
                //     }
                //     this.updateEtatComplete(res)
                //     resolve(res);
                // })
                // );
            }   
        }
        
        return true;
    }

    getDataEnteteEntreprise(){
        let data = {};
        let effectifUpload;
        let effectifEntete;
        let listEffectifs = [];
        if (this.entrepriseInfo && this.tabIdentity.siretIsValid) {
            for (const [key, value] of Object.entries(this.effectifTranches)) {
                if (key == this.entrepriseInfo.tranche_effectif) {
                    this.entrepriseInfo.tranche_effectif = value;
                }
            }
            this.trancheEffectif.forEach(effectif => {
                let parsedValues = effectif.Value.split("a");
                if (parsedValues.length > 1) {
                    let minMax = {
                        min : parsedValues[0],
                        max : parsedValues[1]
                    }
                    listEffectifs.push(minMax);
                } else {
                    if (effectif.Value.includes("plus")) {
                        parsedValues = effectif.Value.split("plus");
                        let min = {
                            min : parsedValues[0]
                        }
                        listEffectifs.push(min);
                    }
                }
            });
            
            effectifUpload = parseInt(this.entrepriseInfo.tranche_effectif);
            
            listEffectifs.forEach((effectif, index) => {
                if (effectif.max && effectif.min) {
                    if (effectifUpload >= effectif.min && effectifUpload <= effectif.max) {
                        effectifEntete = this.trancheEffectif[index];
                    }
                } else if (effectif.min) {
                    if (effectifUpload >= effectif.min) {
                        effectifEntete = this.trancheEffectif[index];
                    }
                }
            });
            if (effectifEntete) {
                data['EFFECT_EMP'] = effectifEntete.Value;
            }
            data["ADR_EMP"] = this.entrepriseInfo.siege.adresse_ligne_1;
            data["CP_EMP"] = this.entrepriseInfo.siege.code_postal;
            data["COM_EMP"] = this.entrepriseInfo.siege.ville;
            data["NAF"] = this.entrepriseInfo.siege.libelle_code_naf;
        }
        else if(this.dataEmpBlock && this.dataEmpBlock['SIRET']){
            //Cas ou en modif on supprime le siret #5471
            data["ADR_EMP"] = null;
            data["CP_EMP"] = null;
            data["COM_EMP"] = null;
            data["NAF"] = null;
        }
        return data;
    }


    changeEtatValidationDossier(enterStepIndex){
        let etatValid;
        switch (enterStepIndex) {
            case 0:
                etatValid = 5;
                break;
            case this.stepResult:
                etatValid = this.dataStep == 1 ? 7 : 8;
                break;
            default:
                etatValid = 6;
                break;
        }
        if(this.dossier && this.dossier.id && etatValid && etatValid !== this.dossier.etatvalidation){
            this.appService.changeEtatValidationDossier(this.dossier.id, etatValid).subscribe((res)=>{})
            this.dossier.etatvalidation = etatValid
            if(enterStepIndex >= this.stepResult){
                this.setDossierComplete(1);
            }
        }
    }

    addChangeListeners() {
        Object.keys(this.firstFormGroup.controls).forEach((fieldName) => {
            this.firstFormGroup.get(fieldName)
                .valueChanges
                .pipe(startWith(this.firstFormGroup.get(fieldName).value), pairwise())
                .subscribe(([prev, next]: [any, any]) => {
                    // console.log(fieldName,':',prev,'→',next)
                    // console.log(this.changedFields)
                    this.updatechangedFields(this.changedFields, fieldName, prev, next)
                    // console.log(this.changedFields)
                    // console.log('---------------------')
                });
        });
        Object.keys(this.dataSalFormGroup.controls).forEach((fieldName) => {
            this.dataSalFormGroup.get(fieldName)
                .valueChanges
                .pipe(startWith(this.dataSalFormGroup.get(fieldName).value), pairwise())
                .subscribe(([prev, next]: [any, any]) => {
                    // console.log(fieldName,':',prev,'→',next)
                    // console.log(this.changedFields)
                    this.updatechangedFields(this.changedFields, fieldName, prev, next)
                    // console.log(this.changedFields)
                    // console.log('---------------------')
                });
        });
        Object.keys(this.dataEmpFormGroup.controls).forEach((fieldName) => {
            this.dataEmpFormGroup.get(fieldName)
                .valueChanges
                .pipe(startWith(this.dataEmpFormGroup.get(fieldName).value), pairwise())
                .subscribe(([prev, next]: [any, any]) => {
                    // console.log(fieldName,':',prev,'→',next)
                    // console.log(this.changedFields)
                    this.updatechangedFields(this.changedFields, fieldName, prev, next)
                    // console.log(this.changedFields)
                    // console.log('---------------------')
                });
        });
        Object.keys(this.dataCTFormGroup.controls).forEach((fieldName) => {
            this.dataCTFormGroup.get(fieldName)
                .valueChanges
                .pipe(startWith(this.dataCTFormGroup.get(fieldName).value), pairwise())
                .subscribe(([prev, next]: [any, any]) => {
                    // console.log(fieldName,':',prev,'→',next)
                    // console.log(this.changedFields)
                    this.updatechangedFields(this.changedFields, fieldName, prev, next)
                    // console.log(this.changedFields)
                    // console.log('---------------------')
                });
        });
        Object.keys(this.paramsCT.controls).forEach((fieldName) => {
            this.paramsCT.get(fieldName)
                .valueChanges
                .pipe(startWith(this.paramsCT.get(fieldName).value), pairwise())
                .subscribe(([prev, next]: [any, any]) => {
                    // console.log(fieldName,':',prev,'→',next)
                    // console.log(this.changedFields)
                    this.updatechangedFields(this.changedFields, fieldName, prev, next)
                    // console.log(this.changedFields)
                    // console.log('---------------------')
                    if ((fieldName === "tempsTravail" || fieldName === "tempsTravailCollectif") && prev !== next) {
                        this.updateCTTpsType();
                    }
                });
        });
        // TODO page des avenants
    }

    updatechangedFields(changedFields, fieldName, prev, next) {
        if (changedFields.hasOwnProperty(fieldName) && changedFields[fieldName] == next) {
            delete(changedFields[fieldName]);
        } else if (!changedFields.hasOwnProperty(fieldName) && prev != next && !(prev === 'null' && next === null) && !(prev === '' && next === null) && !(prev === null && next === '')) {
            changedFields[fieldName] = prev;
        }
    }
    
    // updateEtatComplete(response) {
    //     if(response && response.result && response.result.hasOwnProperty('etatComplete')) {
    //         if (response.result.etatComplete) {
    //             this.dossier.complete = 1;
    //             document.documentElement.style.setProperty('--stepper','#6016AA' )
    //         } else {
    //             this.dossier.complete = 0;
    //             document.documentElement.style.setProperty('--stepper','#6016AA69' )
    //             this.cdf.detectChanges()
    //         }
    //     }
    // }

    setDossierComplete(complete) {
        if (this.dossier.complete != complete) {
            if(this.subscribe['setDossierComplete']){
                this.subscribe['setDossierComplete'].unsubscribe();
            }
            this.subscribe['setDossierComplete'] = this.appService.setDossierComplete(this.dossier.id, complete).subscribe((res)=>{
                if(res && res["result"] && res["result"]["success"]) {
                    if (res["result"]["etatComplete"]){
                        this.dossier.complete = 1;
                        document.documentElement.style.setProperty('--stepper','#6016AA');
                    } else {
                        this.dossier.complete = 0;
                        document.documentElement.style.setProperty('--stepper','#6016AA69');
                    }
                }
            })
        }
    }

    uploadFile(event) {
        if (event) {
            this.suivantUploadDisabled = true // #2260
            this.userHasUploadedFiles = false;
            this.numberToUpload = 0;
            this.numberUploaded = 0;
            if(this.promise && this.promise['uploadfile2'] && this.promise['uploadfile2'].length > 0){
                return
            }
            this.nbEvent = event.length
            this.promise['uploadfile2'] = []
            let reco = []
            for(let i=0;i<event.length;i++){
                const element = event[i];
                    
                reco[i] = {
                    datereco : "",
                    // state: `Le fichier ${element.name} est en cours de téléchargement.`,
                    state: `En cours de téléchargement.`,
                    nom : element.name, // #2099
                    valide: -1,
                    failed: false,
                    url:""
                }
                this.fichiersBS.splice(0, 0, [reco[i]]);
                this.newBs.splice(0, 0, [reco[i]]);
                //// console.log(this.newBs)
                this.promise['uploadfile2'].push(
                    this.appService.uploadDocument(element, this.dossier.id, "TRUE").toPromise().then(res => {
                        this.userHasUploadedFiles = true;
                        //// console.log("res upload", res)
                        reco[i].url = res.url ? res.url : "";
                        reco[i].nom = res.filename ? res.filename : element.name;
                        reco[i].id = res.url ? res.url : "";
                        reco[i].state = "Téléchargement réussi, validation en cours 30%";
                        //// console.log("res reco : ", res)
                        if(res.error_reco){
                            reco[i].state = "Téléchargement échoué.";
                            reco[i].failed = true;
                        }
                        if(this.waiting != 0)
                            this.percentage(reco[i]);
                        this.numberUploaded++;
                    })
                )
            }
            this.numberToUpload = event.length;
            Promise.all(this.promise['uploadfile2']).then((value) => {
                this.suivantUploadDisabled = false // #2260
                this.subscribe['dossier'] = this.appService.getDossierById(this.dossier.id).subscribe((res) => {
                    if(res.result.error && res.result.code){
                        this.errorHandling(res.result)
                    }else {
                        this.afterDownloadFinished(reco, res.result);
                    }
                });
            }).catch((error)=>{
            // TODO
                this.suivantUploadDisabled = false // #2260
            })
        }
    }

    percentage(fichier){
        setTimeout(()=>{
          this.waiting -= 200;
          let perc = (((environment.waiting - this.waiting) / environment.waiting) * 70)+30;
          if(perc > 100){
            perc = 100;
          }
          if(fichier.failed == false){
            fichier.state = "Téléchargement réussi, validation en cours "+perc+"%";
          }
          this.percentage(fichier);
        }, 200);
    }

    afterDownloadFinished(fichiers, dossier){
        this.nbEvent--;
        // //// console.log("fichiers", fichiers)
        // //// console.log("dossier", dossier)
        fichiers.forEach(fichier => {
          if(fichier.failed == false){
              dossier.datas[0].bulletinSalaire.forEach((element, index) => {
                // //// console.log("FICHIER.ID, ELEMENT.URL",fichier.id, element.url)
                if(fichier.id === element.url){
                  fichier.state = "Lecture réussie 100%";
                  if(dossier.datas[0].bulletinSalaire[index] && dossier.datas[0].bulletinSalaire[index].erreur){
                    fichier.error =  dossier.datas[0].bulletinSalaire[index].erreur;
                    fichier.numInstruction = this.getTypeError(fichier.error);
                    fichier.instruction = false,
                    this.fichiersBS.splice(0, 0, fichier);
                    this.newBs.splice(0, 0, fichier)
                  }
                  
                  _.groupBy(dossier.datas[0].bulletinSalaire, "nom");
                  if(this.nbEvent <= 0){
                    this.triBulletin(dossier.datas[0]);
                  }
                  this.waiting = environment.waiting;
                }
              });
            }
        });
        // let servicesTmp // #2099
        // if (this.dossier && this.dossier.services) {
        //     servicesTmp = this.dossier.services
        // }
        this.dossier = dossier.datas[0]
        // if (servicesTmp) { // #2099
        //     this.dossier.services = servicesTmp
        //     servicesTmp = null
        // }
        this.nbBsPrincipaux = this.dossier.bulletinSalaire.filter(e => {return e.typepage == "P"}).length;
        /* #2260 */
        this.stateService.updateDossier(dossier.datas[0]);
        this.erreurperiode = dossier.datas[0].erreurperiode;
        this.promise['uploadfile2'] = []
        /* */
        this.cdf.detectChanges()
      }
    getOnlyNewBs(){
        if(this.fichiersBS){
            this.newBs = [];
            this.fichiersBS.forEach(fichier => {
                if(fichier[0]['new'] || fichier[1]['new']){
                    if(fichier[1].typepage == "S" && fichier[1].fusionne == 0 && fichier[1].erreur){
                        fichier[1].typepage = "P"
                    }
                    if(this.newBs){
                        this.newBs.push(fichier)
                    }else{
                        this.newBs = [fichier]
                    }
                }
            });
            //// console.log("NEW BS", this.newBs)
            this.cdf.detectChanges()
        }
    }
    getTypeError(error){
        let num = null;

        switch (error) {
            case "Oups, ce document est illisible ou ne correspond pas à un bulletin de salaire.":
            num=1;
            break;
        case "Oups, ce bulletin de salaire semble appartenir à une autre personne ou un autre contrat de travail.":
            num=2;
            break;
        case "Oups, ce bulletin de salaire ne correspond pas à la période demandée.":
            num=3;
            break;
        case "Ce bulletin n'a pas de période reconnue":
            num=3;
        break;
        case "Oups, ce document a déjà été chargé et se retrouve en double":
            num=5;
            break;
        case "Oups, la page principale de ce bulletin de salaire semble manquer.":
            num=6;
            break;
        default:
        num=null;
            break;
        }
        return num;
    }
    triBulletin(dossier:any){
        let bulletinTri = {};
        if(dossier.bulletinSalaire && dossier.bulletinSalaire.length > 0){
            if(dossier.erreurperiode){
                console.log("dossier tribulletin", dossier)
                this.erreurperiode = dossier.erreurperiode;
            }else{
                this.erreurperiode = null
            }

            let datecobham = dossier.datecobham ? new Date(dossier.datecobham) : Date.now()
            bulletinTri = dossier.bulletinSalaire.sort((a, b) => (a.typepage == "P" ? 1 : -1)).sort((a, b) => (a.datedebutbs > b.datedebutbs ? 1 : -1)).map((element) => { element.new = datecobham < new Date(element.datecreation); return [element]; });
            
            this.fichiersBS = bulletinTri;
            let i =0
            this.fichiersBS.forEach((element)=> {
                let numIns = null;
                if(element[0].erreur){
                    numIns = this.getTypeError(element[0].erreur);
                    if(element[0].erreur == "Oups, ce bulletin de salaire ne correspond pas à la période demandée." && element[element.length-1].datedebutbs ){
                        let datedebbs = element[element.length-1].datedebutbs.split('T')[0].split('-')
                        let annee = datedebbs[0]
                        let mois = datedebbs[1]
                        element[0].erreur =   "Oups, ce bulletin de salaire daté du "+mois+"/"+annee+" ne correspond pas à la période demandée."
                    }
                }
                let info = {
                    count : element.length,
                    nom : element[0].nom,
                    datecreation : element[0].datecreation,
                    dossierid: element[0].dossier_ID,
                    datedebutbs: element[0].datedebutbs ? element[0].datedebutbs : '',
                    datefinbs: element[0].datefinbs ? element[0].datefinbs : '',
                    incorrect : 0,
                    valide : 1,
                    url : element[0].url,
                    erreur : element[0].erreur,
                    instruction : false,
                    numInstruction : numIns
                }
                element.splice(0, 0, info);
                element.forEach((bs, index) => {
                if(bs.valide != 1 && index != 0){
                    element[0].incorrect++;
                    element[0].valide = 0;
                }
                });
                if(element[1].typepage && element[1].typepage === "S" && i !=0){
                    if(this.fichiersBS[i-1][0].datedebutbs = element[0].datedebutbs){
                        if(this.fichiersBS[i-1]['BsSecondaires'])
                            this.fichiersBS[i-1]['BsSecondaires'].push(element)
                        else
                            this.fichiersBS[i-1]['BsSecondaires'] = [element]
                    }else{
                        element[1].typepage ="P"
                    }
                }else if(element[1].typepage && element[1].typepage === "S" && i ==0){
                    element[1].typepage ="P"
                }
                i++
                if(!this.fichiersBS[i]){
                    this.getOnlyNewBs()
                }
            });
        }
    }

    showFile(file:string){
        
        let fileurl = ''
        if(file[1]['urlfront']){
            fileurl = file[1]['urlfront']
        }else{
            fileurl = file[0]['url']
        }
        let pdfOk = true;
        let pdfExt : RegExp = /\.pdf$/;
        //pdfExt.test(fileurl) ? pdfOk = true : pdfOk = false;
        pdfExt.test(file[0]['nom']) ? pdfOk = true : pdfOk = false;
        const dialogRef = this.dialog.open(ShowFileDialog, {
            width: '100%',
            panelClass:'viewpdf-dialog',
            data: {url: fileurl,
                pdf: pdfOk,
                name: file[0]['nom'],
                page : file[1]['page'] ? file[1]['page'] : 1

            }
        });
    }

    removeBulletin(fichier: any){
        let listIds = [];
        fichier.forEach((element, index)=> {
            if(index > 0){
                listIds.push(element.id);
            }
            
        });
        if(fichier.BsSecondaires){
            fichier.BsSecondaires.forEach((element) => {
                listIds.push(element[1].id)
            });
        }
        if(this.subscribe['removeBulletin']){
            this.subscribe['removeBulletin'].unsubscribe();
        }
        this.subscribe['removeBulletin'] = this.appService.removeBulletin(listIds, true).subscribe((res)=> {
            let idDel = "";
            this.newBs.forEach((element, index) => {
                if(element[0].datecreation == fichier[0].datecreation){
                    idDel = index;
                }
            });
            if(this.subscribe['getDossierById']){
                this.subscribe['getDossierById'].unsubscribe();
            }
            this.subscribe['getDossierById'] =  this.appService.getDossierById(this.dossier.id).subscribe((res) => {
                if(res.result.error && res.result.code){
                    this.errorHandling(res.result)
                }else {
                    this.newBs.splice(idDel, 1);
                    // let servicesTmp // #2099
                    // if (this.dossier.services) {
                    //     servicesTmp = this.dossier.services
                    // }
                    this.dossier = res.result.datas[0]
                    // if (servicesTmp) { // #2099
                    //     this.dossier.services = servicesTmp
                    //     servicesTmp = null
                    // }
                //this.stateService.updateDossier(res.result.datas[0]);
                // console.log(this.newBs)
                    this.cdf.detectChanges()
                }
            });
        });
    }

    screenRapportPrepare() {
        if (this.subscribe['getRapportApplicable'])
            this.subscribe['getRapportApplicable'].unsubscribe()
        this.subscribe['getRapportApplicable'] = this.appService.getRapportApplicable(this.dossier.id).subscribe((resRapportNames)=>{
            this.dossier.rapports = [];
            this.rapports.forEach((rapport1) => {
                let rapport = null
                if (this.dossier.rapport && resRapportNames && resRapportNames['result'] && resRapportNames['result'].indexOf(rapport1.rapportName) > -1)
                    this.dossier.rapport.forEach((rapport2) => {
                        if (rapport1.rapportName == rapport2.calcul) {
                            rapport = { ...rapport2, ...rapport1 }
                            rapport.available = true
                            rapport.selected = rapport.selected == 'true'
                        }
                    })
                if (!rapport) {
                    rapport = { ...rapport1 }
                    rapport.available = rapport.forceenabled == 'true'
                    rapport.selected = false
                }
                rapport.fragments = []
                if (rapport.calcul && Object.keys(this.fragments).indexOf(rapport.calcul) > -1) {
                    rapport.fragments = this.fragments[rapport.calcul]
                }
                    
                this.dossier.rapports.push(rapport)
            })
            this.cdf.detectChanges()
        })
    }

    iframeHTML(calculName)
    {
        // let iframe_container = (<HTMLFormElement>document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container'));
        let iframe_container = (<HTMLFormElement>document.querySelector('#iframe_container'));
        if (iframe_container)
            iframe_container.remove();
        if (calculName) {
            let testcontent = document.createElement('div')
            testcontent.id = 'iframe_container';
            testcontent.className = 'iframe-cont';
                let testcontent_form = document.createElement('form');
                testcontent_form.action = this.BOCC_URL + '/moteur/iframe';
                testcontent_form.target = 'iframe_calc';
                testcontent_form.method = 'post';
                testcontent_form.className = 'd-none';
                    let testcontent_form_inputcalcul = document.createElement('input');
                    testcontent_form_inputcalcul.type = 'text';
                    testcontent_form_inputcalcul.id = 'calcul';
                    testcontent_form_inputcalcul.name = 'calcul';
                    testcontent_form_inputcalcul.value = calculName;
                    testcontent_form.appendChild(testcontent_form_inputcalcul);
                    let testcontent_form_inputdestination = document.createElement('input');
                    testcontent_form_inputdestination.type = 'text';
                    testcontent_form_inputdestination.id = 'destination';
                    testcontent_form_inputdestination.name = 'destination';
                    testcontent_form_inputdestination.value = 'cobham';
                    testcontent_form.appendChild(testcontent_form_inputdestination);
                    let testcontent_form_inputtargetorigin = document.createElement('input');
                    testcontent_form_inputtargetorigin.type = 'text';
                    testcontent_form_inputtargetorigin.id = 'target-origin';
                    testcontent_form_inputtargetorigin.name = 'target-origin';
                    testcontent_form_inputtargetorigin.value = this.origin;
                    testcontent_form.appendChild(testcontent_form_inputtargetorigin);
                    let testcontent_form_inputdossierid = document.createElement('input');
                    testcontent_form_inputdossierid.type = 'text';
                    testcontent_form_inputdossierid.id = 'dossierid';
                    testcontent_form_inputdossierid.name = 'dossierid';
                    testcontent_form_inputdossierid.value = this.dossier.id;
                    testcontent_form.appendChild(testcontent_form_inputdossierid);
                    let testcontent_form_inputtoken = document.createElement('input');
                    testcontent_form_inputtoken.type = 'text';
                    testcontent_form_inputtoken.id = 'token';
                    testcontent_form_inputtoken.name = 'token';
                    testcontent_form_inputtoken.value = this.tokencalc;
                    testcontent_form.appendChild(testcontent_form_inputtoken);

                    let testcontent_entetecontainer = document.createElement('div');
                    testcontent_entetecontainer.id = 'dossier-entete-container';
                        let testcontent_form_inputentete = document.createElement('input');
                        testcontent_form_inputentete.type = 'text';
                        testcontent_form_inputentete.name = 'dataJSON';
                        testcontent_form_inputentete.value = this.jsonCalculette;
                        testcontent_entetecontainer.appendChild(testcontent_form_inputentete);
                    testcontent_form.appendChild(testcontent_entetecontainer);
                testcontent.appendChild(testcontent_form);

                let testcontent_iframe = document.createElement('iframe');
                testcontent_iframe.name = 'iframe_calc';
                testcontent_iframe.width = '100%';
                testcontent_iframe.frameBorder = '0';
                testcontent_iframe.src = '';
                testcontent_iframe.className = 'd-none';
                testcontent.appendChild(testcontent_iframe);

                let testcontent_erreur = document.createElement('div');
                testcontent_erreur.className = 'd-none';
                testcontent_erreur.id = 'message-oups-iframe';
                testcontent_erreur.innerHTML = `<h3 class="text-center" style="margin: 2rem 1rem 5rem 1rem;">Les services de calcul de Rupture by Cobham sont momentanément indisponibles.<br/>  
                    Nos équipes font le maximum pour rétablir les services de calcul au plus vite.<br/>
                    Avec toutes nos excuses pour la gêne occasionnée.<br/>
                    Le support client Rupture by Cobham.</h3>`;
                testcontent.appendChild(testcontent_erreur);

            (<HTMLFormElement>document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] .completeData div')).appendChild(testcontent);
        }
    }

    displayIframe(calculName, updateEntete = false) {
    // displayIframe(updateEntete = false) {
        this.calcul = true;
        // this.currentCalcul.setValue(calculName);
        //vérification que le webservice fonctionne
        //si oui envoi du form vers l'iframe
        // console.log("%c token", "color:blue;",this.tokencalc)
        fetch(
            this.BOCC_URL+'/moteur/iframe', 
            {
                method: 'POST',
            }
        ).then((res)=>{
            if(res.status !== 200){
                throw new Error('le BOCC ne fonctionne pas');
            }
            if (updateEntete && (<HTMLElement> document.querySelector('#dossier-entete-container')))
                this.cdf.markForCheck();
            
            this.iframeHTML(calculName);
            
            // (<HTMLFormElement>document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container form')).submit();
            // (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #message-oups-iframe')).classList.add('d-none') ;
            // (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe')).classList.remove('d-none') ;
            (<HTMLFormElement>document.querySelector('#iframe_container form')).submit();
            (<HTMLElement> document.querySelector('#message-oups-iframe')).classList.add('d-none') ;
            (<HTMLElement> document.querySelector('#iframe_container iframe')).classList.remove('d-none') ;
            //this.disabled = false
            //this.cdf.detectChanges()
            ////// console.log("DISABLED", this.disabled)
        }).catch((err)=>{
            //COB-257
            console.log(err);
            // if((<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #message-oups-iframe')) && (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe')) ){
            if((<HTMLElement> document.querySelector('#message-oups-iframe')) && (<HTMLElement> document.querySelector('#iframe_container iframe')) ){

                // (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #message-oups-iframe')).classList.remove('d-none') ;
                // (<HTMLElement> document.querySelector('.mat-horizontal-stepper-content[aria-expanded=true] #iframe_container iframe')).classList.add('d-none') ;
                (<HTMLElement> document.querySelector('#message-oups-iframe')).classList.remove('d-none') ;
                (<HTMLElement> document.querySelector('#iframe_container iframe')).classList.add('d-none') ;
            }
        });
    }

    // Pour le design du cdf 
    getState(stepper, stepIndex): any{
        let complete = this.getStepCompletedEditable(stepper, stepIndex);
        let result;
        if (stepIndex == this.stepResult) {
            result = complete ? "result-done" : "result-todo";
        } else if (stepIndex === stepper.selectedIndex) {
            result = 'edit';
        } else {
            result = complete ? 'done' : 'todo';
        }
        // let result = 'todo';
        // if (stepIndex == this.stepResult) {
        //     result = "result-todo";
        //     if (stepper.selectedIndex === stepIndex || (this.dossier && this.dossier.complete && Object.keys(this.changedFields).length === 0))
        //         result = "result-done";
        // } else if (stepIndex === stepper.selectedIndex) {
        //     return 'edit';
        // } else if (stepIndex < stepper.selectedIndex) {
        //     result = 'done';
        // } else if (Object.keys(this.changedFields).length > 0) {
        //     result = 'todo';
        // } else if (this.dossier && this.dossier.complete) {
        //     result = 'done';
        // } else {
        //     result = this.maxStateSteps.hasOwnProperty(stepIndex) && this.maxStateSteps[stepIndex] ? 'done' : 'todo';
        // }
        return result;
    }
    getStepCompletedEditable(stepper, stepIndex): any{
        let result = false;
        if (this.dossier && this.dossier.complete) {
            result = Object.keys(this.changedFields).length ? stepIndex < stepper.selectedIndex : true;
        } else if (stepIndex < stepper.selectedIndex) {
            result = true;
        } else {
            result = this.maxStateSteps.hasOwnProperty(stepIndex) && this.maxStateSteps[stepIndex] ? Object.keys(this.changedFields).length === 0 : false;
        }
        
        // if (stepIndex == this.stepResult) {
        //     result = false;
        //     if (stepper.selectedIndex === stepIndex || (this.dossier && this.dossier.complete && Object.keys(this.changedFields).length === 0))
        //         result = true;
        // } else if (stepIndex === stepper.selectedIndex) {
        //     return true;
        // } else if (stepIndex < stepper.selectedIndex) {
        //     result = true;
        // } else if (Object.keys(this.changedFields).length > 0) {
        //     result = false;
        // } else if (this.dossier && this.dossier.complete) {
        //     result = true;
        // } else {
        //     result = this.maxStateSteps.hasOwnProperty(stepIndex) && this.maxStateSteps[stepIndex];
        // }
        return result;
    }

    seeRapport(nameRapport) {
        if (nameRapport == 'dashboard') {
            window['tryga']('send', 'event', 'telecommande', 'tableau_bord', '', '');
        }
        let data = ""
        if (["anciennete", "procedure", "salaireRef", "dashboard", "fisc_indemnite", "indem_comp_cp", "sdc", "are", "icl", "synthese", "stc", "salref_legal", "salref_cc"].includes(nameRapport)) {
                
            window['tryga']('send', 'event', 'consulter_resultats', 'affichage_rapport', nameRapport, '');

            if(this.dossier && this.dossier.rapport){
                if(this.subscribe['rapport']){
                    this.subscribe['rapport'].unsubscribe()
                }    
                this.subscribe['rapport'] = this.appService.rapport(this.dossier.id, nameRapport).subscribe((res) => {
                    console.log("rapport => ", res)
                    if(res && res['result'] && res['result']['allRapports']){
                        // Pas de retour
                        this.dossier.rapport = res['result']['allRapports'];
                        console.log("rapports", this.dossier.rapport)
                        this.dossier.rapport.forEach(element => {
                            if(element.calcul == nameRapport){
                                data = element.rapport;
                                const dialogRef = this.dialog.open(RapportDialog, {
                                    width:'100%',
                                    panelClass:'viewrapport-dialog',
                                    data: {rapport:data, dossier:this.dossier, nameRapport:nameRapport, fragments:element.fragments},
                                    autoFocus: false, /* 1388 + bug auto scroll bottom popup */
                                });
                            }
                        })
                    }
                });                
            }
        }
    }

    originalOrder = (a, b): number => {
        return 0;
    }

    formatDate(date) {
        let result = ''
        date = new Date(date)
        if(date instanceof Date){
            // certaines date ont été enregistrées en mettant les heures 00:00:00; il ne faut pas modifier ces dates !!
            if (date.getHours() === 0 && date.getMinutes() === 0 && date.getSeconds() === 0) {
                result = date.toLocaleString('fr-FR').split(' ')[0];
            }
            result = date.toLocaleString('fr-FR', {timeZone:'UTC'}).split(' ')[0]
        }else{
            result = ''
        }
        return result.replace(/^(.*),$/, '$1') // #1474 suppression de virgule en fin si présente
    }

    formatDate2(date) { // #1753 -- format attendu : JJ/MM/AAAA ex : 31/12/1999
        let result = ''
        date = new Date(date)
        if(date instanceof Date) {
            let day   = date.getDate()
            let month = date.getMonth() + 1
            result += ((day < 10) ? '0' + day : day) + '/'
            result += ((month < 10) ? '0' + month : month) + '/'
            result += date.getFullYear()
        }
        return result
    }

    formatDate3(date) { // date js --> yyyy-mm-dd
        let result = ''
        if(date instanceof Date) {
            let day   = date.getDate()
            let month = date.getMonth() + 1
            result += date.getFullYear() + '-'
            result += ((month < 10) ? '0' + month : month) + '-'
            result += ((day < 10) ? '0' + day : day)
        }
        return result
    }

    exportRapport(type){
        this.messageError = "";
        let targets = document.querySelectorAll('.selectoprint');
        if(targets.length < 1){
            //this.messageError = "Veuillez sélectionner le(s) rapport(s) que vous souhaitez imprimer ou exporter."
            this.messageError = "Veuillez sélectionner le(s) rapport(s) que vous souhaitez exporter."
        } else {
            if(type == "PRINT"){
                let printableElements = document.getElementsByClassName("selectoprint");
                let ensembleToPrint = "";

                for (let i=0; i<printableElements.length; i++){
                    ensembleToPrint += printableElements[i].innerHTML;
                    ensembleToPrint += '<hr class="calcul-separator">';
                }
                const WindowPrt = window.open('', 'Rapports Cobham', 'left=0,top=0,width=900,height=700,toolbar=0,scrollbars=0,status=0');
                WindowPrt.document.write('<html><head><title>Rapports Cobham</title></head><body>');
                this.httpClient.get('assets/print-css.css', { responseType: 'text' as 'json'}).subscribe(data => {
                    WindowPrt.document.write('<style>'+data+'</style>');
                    WindowPrt.document.write('</head><body>');
                    WindowPrt.document.write(ensembleToPrint);
                    WindowPrt.document.write('</body></html>');
                    //WindowPrt.document.close();
                    WindowPrt.focus();
                    WindowPrt.print();
                    /* // #1402 FIX SAFARI
                    setTimeout(() => {
                        WindowPrt.close();
                    }, 30000);
                    */
                })
            } else {
                let calc = "";
                let calcs = new Array();
                targets.forEach(target => {
                    let calcul = target.id.substring(8);
                    calcs.push(calcul);
                    calc += (calc.length) ? "_" + calcul : calcul;
                });

                window['tryga']('send', 'event', 'rapports', 'export_' + type, calcs.join(','), '');

                // // console.log("Noms calcul :", calc);
                if(this.subscribe['downloadrapport']){
                    this.subscribe['downloadrapport'].unsubscribe();
                }
                let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})
                // this.name = this.dossier.nom+"_"+this.dossier.prenom+"_"+calc+"_"+dategeneration+'.'+type.toLowerCase();
                this.name = this.dossier.entreprise + "_" + this.dossier.nom + "_" 
                    + this.dossier.motifsortie + "_" + dategeneration + '.' + type.toLowerCase();
                this.name = this.name.split(' ').join('_');
                this.name = this.name.split(':').join('_');
                // // console.log("Nom Dossier :", this.name);
                this.subscribe['downloadrapport'] = this.appService.downloadrapport(this.dossier.id,calcs, type).subscribe((res)=>{
                    // // console.log("RES :",res);
                    if(res){
/* #1551 problème avec SAFARI
                        let blob;
                        // Deprecated and non-standard !!
                        // if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                        //     if(type == "PDF"){
                        //         blob = new Blob([res], { type: 'application/pdf' })
                        //     }else{
                        //         blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' })
                        //     }
                        //     window.navigator.msSaveOrOpenBlob(blob, this.name);
                        // } else {// other browsers
                            if(type == "PDF"){
                                blob = new File([res], this.name, {type: "application/pdf"});
                            }else{ 
                                blob = new File([res], this.name, {type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"});
                            }
                            let exportUrl = window.URL.createObjectURL(blob);
                            window.open(exportUrl);
                            URL.revokeObjectURL(exportUrl);
                        // }
*/
                        let aDownload = document.createElement('a')
                        aDownload.download = this.name
                        aDownload.href = URL.createObjectURL(res)
                        document.body.appendChild(aDownload)
                        aDownload.click()
                        document.body.removeChild(aDownload)
                    }else{
                        this.messageError = "Une erreur est survenue lors de l'export du rapport.";
                        setTimeout(()=>{this.messageError = ""}, 5000);
                    }
                    
                })
            }
        }
    }

    createRapports() {
        let result = new Subject<any>();
        // let uniqueNames = this.calculNames.sort().filter(function(item, pos, array) {
        //     return !pos || item != array[pos - 1];
        // });
        
        // if (uniqueNames.length === 0) {
        //     result.next("vide");
        //     return result.asObservable();
        // }

        // this.appService.createMultipleRapports(this.dossier.id, uniqueNames).subscribe((res) => {
        this.appService.createMultipleRapports(this.dossier.id).subscribe((res) => {
            if (res.result) {
                result.next(res.result);
            } else {
                result.next("erreur");
            }
        })

        return result.asObservable();
    }

    createCourriers() {
        let result = new Subject<any>();
        let courriersNames = this.getCourriersNames();
        
        if (courriersNames.length === 0) {
            setTimeout(() => result.next("vide"), 0);
            return result.asObservable();
        }
    
        this.appService.createMultipleCourriers(this.dossier.id, courriersNames).subscribe((res) => {
            if (res.result) {
                result.next(res.result);
            } else {
                result.next("erreur");
            }
        })
    
        return result.asObservable();
    }

    getCourriersNames() {
        let courriersNames = [];
        let parametersValues = [];
        let codes = [   
            "BOOL_RES", "BOOL_FAUTE_GRAVE", "BOOL_FAUTE_LOURDE", 
            "BOOL_MISE_A_PIED_CONSERV", "BOOL_SAL_PROTEGE",
            "BOOL_INAPT_PRO", "BOOL_INAPT_NON_PRO",
            "BOOL_LIC_ECO_INDIV", "BOOL_ADH_CONV_CHO_CSP", 
            "BOOL_RC_INDIV"
        ];
        
        codes.map((code) => {
            parametersValues[code] = this.getEnteteFromCode(code);
        })

        // Licenciement motif personnel
        if  (
                parametersValues["BOOL_RES"] === "TRUE"
                || parametersValues["BOOL_FAUTE_LOURDE"] === "TRUE"
                || parametersValues["BOOL_FAUTE_GRAVE"] === "TRUE"
            )
        {
            courriersNames.push("Lettre_convo_entre_lic");
            courriersNames.push("Lettre_notif_lic");
            if (parametersValues["BOOL_MISE_A_PIED_CONSERV"] === "TRUE")
                courriersNames.push("Lettre_mise_a_pied");
            if (parametersValues["BOOL_SAL_PROTEGE"] === "TRUE")
                courriersNames.push("Lettre_demand_autoris_inspec");
        }

        if  (
                parametersValues["BOOL_INAPT_PRO"] === "TRUE"
                || parametersValues["BOOL_INAPT_NON_PRO"] === "TRUE"
            )
        {
            courriersNames.push("Lettre_non_reclassement");
            courriersNames.push("Lettre_convo_entre_lic");
            courriersNames.push("Lettre_notif_lic");
            if (parametersValues["BOOL_SAL_PROTEGE"] === "TRUE")
                courriersNames.push("Lettre_demand_autoris_inspec");
        }
        
        // Licenciement motif économique
        if (parametersValues["BOOL_LIC_ECO_INDIV"] === "TRUE") {
            courriersNames.push("Lettre_convo_entre_lic");
            courriersNames.push("Lettre_notif_lic");
            if (parametersValues["BOOL_ADH_CONV_CHO_CSP"] === "TRUE")
                courriersNames.push("Lettre_info_DREETS");
            if (parametersValues["BOOL_SAL_PROTEGE"] === "TRUE")
                courriersNames.push("Lettre_demand_autoris_inspec");
        }

        // Rupture conventionnelle individuelle
        if (parametersValues["BOOL_RC_INDIV"] === "TRUE") {
            courriersNames.push("Lettre_convo_entre_rupt");
            courriersNames.push("Conv_rupt");
        }

        return courriersNames;
    }

    screenCourrierPrepare() {
        this.courriersShown = [];
        if (Array.isArray(this.dossier.courriers) && this.dossier.courriers.length > 0) {
            this.dossier.courriers.map( (dossierCourrier) => {
                this.courriers.forEach( (courrier, index) => {
                    if (dossierCourrier.name == courrier.name) {
                        this.courriers[index].exists = true;
                        this.courriersShown.push(this.courriers[index]);
                    }
                })
            })
        }
        this.cdf.detectChanges();
    }

    openCourrier(name) {
        if (this.courriersShown.length > 0) {
            this.appService.getCourrierHtml(this.dossier.id, name).subscribe((res) => {
                if (res && res.result) {
                    const dialogRef = this.dialog.open(CourrierDialog, {
                        width:'100%',
                        panelClass:'viewrapport-dialog',
                        data: {
                            html: res.result,
                            dossier: this.dossier,
                            type: "courrier",
                            fileTypeName: name
                        },
                        autoFocus: false,
                    });
                }
            });                
        }
    }
    
    exportCourrier(courrierName) {
        let type = "DOCX";
        this.messageError = "";

        let dategeneration = new Date().toLocaleDateString("fr-FR", {hour:"2-digit", minute:"2-digit", second:"2-digit"})
        this.name = this.dossier.entreprise + "_" + this.dossier.nom + "_" 
            + this.dossier.motifsortie + "_" + dategeneration + '.' + type.toLowerCase();
        this.name = this.name.split(' ').join('_');
        this.name = this.name.split(':').join('_');
        this.appService.downloadCourrier(this.dossier.id, courrierName, type).subscribe((res)=>{
            if (res) {
                let aDownload = document.createElement('a')
                aDownload.download = this.name
                aDownload.href = URL.createObjectURL(res)
                document.body.appendChild(aDownload)
                aDownload.click()
                document.body.removeChild(aDownload)
            } else {
                this.messageError = "Une erreur est survenue lors de l'export du courrier.";
                setTimeout(()=>{this.messageError = ""}, 5000);
            }
            
        })
    }

    checkAllForExport(){
        this.dossier.rapports.forEach((rapport) => {
            this.svgToggles.toArray().forEach((svgToggle) => {
                if (svgToggle.index == rapport.rapportName) {
                    svgToggle.toggleOn()
                    this.checkForExport(rapport.rapportName, true)
                }
            })
        })
    }
    unCheckAllForExport(){
        this.dossier.rapports.forEach((rapport) => {
            this.svgToggles.toArray().forEach((svgToggle) => {
                if (svgToggle.index == rapport.rapportName) {
                    svgToggle.toggleOff()
                    this.checkForExport(rapport.rapportName, false)
                }
            })
        })
    }
    checkForExport(id, isTrue = null){
        let cible = id
        // // console.log(cible);
        let rapportCible = document.querySelector('#rapport_'+cible);
        let labelCursor = document.querySelector('#span_'+cible);
        let inputCible = document.querySelector('#print_'+cible) as HTMLInputElement;
        if (!inputCible.disabled) {
            if (isTrue !== null) {
                inputCible.checked = isTrue
            }
            else {
                inputCible.checked = inputCible.checked ? false : true
            }
            if(inputCible.checked){
                rapportCible.classList.add("selectoprint");
                labelCursor.textContent = "Oui";
            }
            else {
                if (rapportCible.classList.contains("selectoprint")) {
                    rapportCible.classList.remove("selectoprint");
                }
                labelCursor.textContent = "Non";
            }
        }
    }

    /* COB-5637 : les libellés viennent de deux sources asynchrones, dont l'ordre d'arrivée
     * n'est pas garanti — le dictionnaire BOBS (getLibelleTooltip) et les libellés portés
     * par la convention collective (getCCparam). On les conserve séparément et on
     * recompose ici la map affichée, à chaque réception de l'une ou l'autre.
     * La recomposition repart systématiquement du dictionnaire et réaffecte une nouvelle
     * référence : sans ça, le ngOnChanges de app-label ne se déclenche pas et les libellés
     * déjà affichés restent ceux du dictionnaire (cas de l'ouverture d'un dossier existant).
     */
    applyLibelleCC() {
        let merged:any = {};
        for (let code in this.libellDictionnaire) {
            merged[code] = Object.assign({}, this.libellDictionnaire[code]);
        }
        for (let code in this.libelleCCparam) {
            let entry = Object.assign({}, merged[code] || {});
            for (let prop in this.libelleCCparam[code]) {
                // LBP ne renseigne que les libellés : ne pas écraser les tooltips du dictionnaire
                if (this.libelleCCparam[code][prop] !== null && this.libelleCCparam[code][prop] !== '') {
                    entry[prop] = this.libelleCCparam[code][prop];
                }
            }
            merged[code] = entry;
        }
        // le libellé de BOOL_CONST_QUALIF reprend celui du rang 1, qui dépend de la CC
        if (merged['BOOL_CONST_QUALIF'] && merged['QUALIF_CC'] && merged['QUALIF_CC']['libelle']) {
            if (merged['BOOL_CONST_QUALIF']['libelle']) {
                merged['BOOL_CONST_QUALIF']['libelle'] = merged['BOOL_CONST_QUALIF']['libelle'].replace('qualification', merged['QUALIF_CC']['libelle']);
            }
            if (merged['BOOL_CONST_QUALIF']['libelleSimu']) {
                merged['BOOL_CONST_QUALIF']['libelleSimu'] = merged['BOOL_CONST_QUALIF']['libelleSimu'].replace('qualification', merged['QUALIF_CC']['libelle']);
            }
        }
        this.libellAndToolTip = merged;
    }

    updateCCparam() {
        this.errorTerritoireCC = null;
        let idcc_cc = this.dataEmpFormGroup.get("IDCC_CC").value;
        let secteur = this.dataEmpFormGroup.get("CC_SECTEUR").value;
        let bool_adh_synd_sign = this.dataEmpFormGroup.get("BOOL_ADH_SYND_SIGNATAIRE").value;
        
        let entete_IDCC_CC = this.dataEmpFormGroup.get("IDCC_CC_autocomplete").value ? this.dataEmpFormGroup.get("IDCC_CC_autocomplete").value.Value : '';
        let entete_LIB_CC = this.dataEmpFormGroup.get("IDCC_CC_autocomplete").value ? this.dataEmpFormGroup.get("IDCC_CC_autocomplete").value.Libelle : '';
        this.dataSalBlock["Numéro Convention collective"] = entete_IDCC_CC != "0" ? entete_IDCC_CC : "";
        this.dataSalBlock["Convention collective"] = entete_LIB_CC != "Légal" ? entete_LIB_CC : "A défaut de convention collective,\napplication du droit du travail";
        var cp_emp_temp = this.dataEmpFormGroup.get('CP_EMP') && this.dataEmpFormGroup.get('CP_EMP').value ? this.dataEmpFormGroup.get('CP_EMP').value: false;
        
        if(this.subscribe && this.subscribe['getCCparam']){
            this.subscribe['getCCparam'].unsubscribe();
        } 
        this.subscribe['getCCparam'] = this.appService.getCCparam(this.dossier.id, idcc_cc, secteur, bool_adh_synd_sign, cp_emp_temp).subscribe((res)=>{
            if (res.result && res.result.result) {
                //COB-1327 : en attente d'information
                //this.ccAsk_BOOL_DR_ANC_AUTRE_QUALIF = res.result.result.analysAncAutreQualif;
                this.ccAsk_DR_PRES_SOC_CC = res.result.result.analysPresSoc;
                this.list_SECTEUR = res.result.result.list_SECTEUR ? res.result.result.list_SECTEUR.filter(function (value, index, array) {
                    return array.indexOf(value) === index;
                }) : null;
                if (this.list_SECTEUR && this.list_SECTEUR.length === 1) {
                    this.dataEmpFormGroup.get('CC_SECTEUR').setValue(this.list_SECTEUR[0]);
                }
                
                this.dataEmpFormGroup.get('LIB_CC').setValue(res.result.result.LIB_CC);
                this.territoireMatch = res.result.result.territoireMatch;
                this.principeCalcul = res.result.result.principeCalcul;
                this.need_bool_adh_synd_signataire = res.result.result.need_bool_adh_synd_signataire;
                this.niveauIsUsed = res.result.result.niveauIsUsed;
                this.echelonIsUsed = res.result.result.echelonIsUsed;
                this.qualiteIsUsed = res.result.result.qualiteIsUsed;
                this.coeffIsUsedCC = res.result.result.coeffIsUsed;
                this.typeCoeff = res.result.result.typeCoeff;
                this.choice_cc = res.result.result.choice_cc;
                this.json_cc_data = {'JSON_CC_DATA': res.result.result.JSON_CC_DATA};
                this.getCCparamFinished = true;
                this.addTerritoire();
                this.qualificationCTList = res.result.result.classification.qualification;
                this.optionQualif = res.result.result.classification.qualification;
                this.optionNiv = res.result.result.classification.niveau;
                this.optionEch = res.result.result.classification.echelon;
                this.optionQualite = res.result.result.qualite;
                // COB-5637 : recomposition des libellés (cf. applyLibelleCC)
                this.libelleCCparam = res.result.result.libelle || {};
                this.applyLibelleCC();
                if (!this.optionQualif.filter(e => { return e.id == this.dataSalFormGroup.get("QUALIF_CC").value}).length)
                    this.dataSalFormGroup.get("QUALIF_CC").setValue(null);
                if (!this.optionNiv.filter(e => { return e.id == this.dataSalFormGroup.get("NIV_CC").value}).length)
                    this.dataSalFormGroup.get("NIV_CC").setValue(null);
                if (!this.optionEch.filter(e => { return e.id == this.dataSalFormGroup.get("ECH_CC").value}).length)
                    this.dataSalFormGroup.get("ECH_CC").setValue(null);
                if (!this.optionQualite.filter(e => { return e.id == this.dataSalFormGroup.get("CC_CLASSIF_RANG4").value}).length)
                    this.dataSalFormGroup.get("CC_CLASSIF_RANG4").setValue(null);
                
                this.checkCoeffCoherence();
                this.initSelect()
                
                if(!(res.result.result && res.result.result.conventionFound)){
                    if(res.result.result && res.result.result.errorLogClient){
                        this.errorTerritoireCC = res.result.result.errorLogClient
                    }
                    else{
                        var error = true;
                        // Cas où aucune cc trouvée, mais qu'une liste de secteurs est dispo (recherche sans secteur spécifié)
                        if(!secteur && res.result.result && res.result.result.list_SECTEUR && res.result.result.list_SECTEUR.length>0)
                            error = false;
                        if(error)
                            this.errorTerritoireCC = "Erreur lors de la sélection de la convention collective";
                    }
                }
            }
            this.cdf.detectChanges()
        });
    }

    checkCoeffCoherence() {
        this.messageCoeffIncoherent = "";
        this.messageCoeffModified = "";
        this.messageCoeffInfo = "";
        this.coeffIsUsedClassif = false;

        if (this.typeCoeff == 'number') {
            let coeffmin = this.optionQualif.filter(e => e.id == this.dataSalFormGroup.get("QUALIF_CC").value).length
                ? this.optionQualif.filter(e => e.id == this.dataSalFormGroup.get("QUALIF_CC").value)[0]['coeffmin']
                : { "": "" };
            let coeffminKeys = Object.keys(coeffmin);
            this.coeffIsUsedClassif = coeffminKeys.length > 0 && !(coeffminKeys.length === 1 && coeffminKeys[0] === "");

            if (this.coeffIsUsedClassif && (!this.niveauIsUsed || this.dataSalFormGroup.get("NIV_CC").value || this.nivEnable.length === 0) && (!this.echelonIsUsed || this.dataSalFormGroup.get("ECH_CC").value || this.echEnable.length === 0)) {
                let intervalles = coeffminKeys.reduce((accumulator, min) => {
                    if ((!('niveau' in coeffmin[min][0]) || coeffmin[min][0]['niveau'] == this.dataSalFormGroup.get("NIV_CC").value) && (!('echelon' in coeffmin[min][0]) || coeffmin[min][0]['echelon'] == this.dataSalFormGroup.get("ECH_CC").value))
                        accumulator.push([parseInt(min), coeffmin[min][0]['coeffmax'] - 1]);
                    return accumulator;
                }, []);
                if (!intervalles.length) {
                    this.coeffIsUsedClassif = false;
                } else {
                    intervalles[0].sort((a, b) => a - b);
                    let intervallesStr = [];
                    let intervallesUnique = [];
                    intervalles.forEach(i => {
                        if (i[0] == i[1]) {
                            intervallesUnique.push(i[0]);
                        } else {
                            intervallesStr.push(i.join(" et "));
                        }
                    });

                    let messageInfo = "La valeur du coefficient doit ";
                    if (intervallesUnique.length > 0) {
                        messageInfo += "correspondre à " + intervallesUnique.join(' ou ');
                        if (intervallesStr.length > 0) {
                            messageInfo += " ou ";
                        }
                    }
                    if (intervallesStr.length > 0) {
                        messageInfo += "être comprise entre " + intervallesStr.join(', ') + ".";
                    }
                    this.messageCoeffInfo = messageInfo;

                    let coeffSal = this.dataSalFormGroup.get("COEFF_SAL").value;
                    if (coeffSal) {
                        let isInIntervalle = false;
                        intervalles.forEach(i => {
                            if (i[0] <= coeffSal && coeffSal <= i[1])
                                isInIntervalle = true;
                        });

                        if (!isInIntervalle) {
                            let message = "La valeur du coefficient saisie ne correspond pas à la plage de valeur attendue pour les critères de classification saisies (" + this.dataSalFormGroup.get("QUALIF_CC").value;
                            message += this.niveauIsUsed && this.nivEnable.length > 0 ? (" - " + this.dataSalFormGroup.get("NIV_CC").value) : "";
                            message += this.echelonIsUsed && this.echEnable.length > 0 ? (" - " + this.dataSalFormGroup.get("ECH_CC").value) : "";
                            message += ").";

                            if (intervallesUnique.length === 1 && intervallesStr.length === 0) {
                                this.messageCoeffModified = message;
                                this.dataSalFormGroup.get("COEFF_SAL").setValue(intervalles[0][0]);
                            } else {
                                this.messageCoeffIncoherent = message;
                            }
                        }
                    }
                    else if(!coeffSal && intervallesUnique.length === 1 && intervallesStr.length === 0){
                        this.dataSalFormGroup.get("COEFF_SAL").setValue(intervalles[0][0]);
                    }
                }
            }
        } else if (this.typeCoeff == 'text') {
            let coeffunique = this.optionQualif.filter(e => e.id == this.dataSalFormGroup.get("QUALIF_CC").value).length
                ? this.optionQualif.filter(e => e.id == this.dataSalFormGroup.get("QUALIF_CC").value)[0]['coeffunique']
                : { "": "" };
            let coeffuniqueKeys = Object.keys(coeffunique);
            this.coeffIsUsedClassif = coeffuniqueKeys.length > 0 && !(coeffuniqueKeys.length === 1 && coeffuniqueKeys[0] === "");

            if (this.coeffIsUsedClassif && (!this.niveauIsUsed || this.dataSalFormGroup.get("NIV_CC").value || this.nivEnable.length === 0) && (!this.echelonIsUsed || this.dataSalFormGroup.get("ECH_CC").value || this.echEnable.length === 0)) {
                let coeffSal = this.dataSalFormGroup.get("COEFF_SAL").value;
                let coeffPossible = coeffuniqueKeys.reduce((acc, val) => {
                    if ((!('niveau' in coeffunique[val][0]) || coeffunique[val][0]['niveau'] == this.dataSalFormGroup.get("NIV_CC").value) && (!('echelon' in coeffunique[val][0]) || coeffunique[val][0]['echelon'] == this.dataSalFormGroup.get("ECH_CC").value))
                        acc.push(val);
                    return acc;
                }, []);

                if (!coeffPossible.length) {
                    this.coeffIsUsedClassif = false;
                } else {
                    this.messageCoeffInfo = "La valeur du coefficient doit correspondre à " + coeffPossible.join(' ou ') + ".";

                    if (coeffPossible.length === 1) {
                        this.dataSalFormGroup.get("COEFF_SAL").setValue(coeffPossible[0]);
                    } else if (coeffSal && !coeffPossible.includes(coeffSal)) {
                        let message = "La valeur du coefficient saisie ne correspond pas à la plage de valeur attendue pour les critères de classification saisies (" + this.dataSalFormGroup.get("QUALIF_CC").value;
                        message += this.niveauIsUsed && this.nivEnable.length > 0 ? (" - " + this.dataSalFormGroup.get("NIV_CC").value) : "";
                        message += this.echelonIsUsed && this.echEnable.length > 0 ? (" - " + this.dataSalFormGroup.get("ECH_CC").value) : "";
                        message += ").";
                        this.messageCoeffIncoherent = message;
                    }
                }
            }
        }

        if (!this.coeffIsUsedClassif)
            this.dataSalFormGroup.get("COEFF_SAL").setValue(null);
        this.cdf.detectChanges();
    }

    getAllIndexes(arr) {
        var indexes = []
        for( const niv in arr){
            indexes.push(niv)
        }
        return indexes;
    }

    initSelect(){
        let qualifSelect = false
        this.nivEnable = []
        this.echEnable = []
        if(this.optionQualif && this.dataSalFormGroup){
            qualifSelect = this.optionQualif.filter(e => {
                return e.id == this.dataSalFormGroup.get("QUALIF_CC").value
            });
            if(qualifSelect && qualifSelect[0] && qualifSelect[0].value){
                this.qualifSelect = qualifSelect[0].value
                if(qualifSelect[0].niveau ) {
                    this.nivEnable = this.getAllIndexes(qualifSelect[0].niveau)
                    this.nivEnable.forEach(niveau => {
                        if(niveau == this.dataSalFormGroup.get("NIV_CC").value)
                            this.nivSelect = niveau;
                    });
                }
                if(this.nivSelect && qualifSelect[0]['niveau'][this.nivSelect])
                    this.echEnable = qualifSelect[0]['niveau'][this.nivSelect]
                
                this.processChangeQualifMain();
            }
        }
        if(this.dossier && this.dossier.entete && this.optionEch && this.optionNiv){
            let nivCC = this.dossier.entete.filter(e => {
                return e.parametre && e.parametre.code == "NIV_SAL" ? true : false
            });
            if(nivCC && nivCC[0] && nivCC[0].value && this.nivEnable){
                this.nivSelect = this.nivEnable.find(el => el == nivCC[0].value) 
                if(this.nivSelect && this.dataSalFormGroup){
                    this.dataSalFormGroup.get("NIV_CC").setValue(this.nivSelect);
                }
                
                if(this.nivSelect && qualifSelect[0]['niveau'][this.nivSelect])
                    this.echEnable = qualifSelect[0]['niveau'][this.nivSelect]
            }
            let echCC = this.dossier.entete.filter(e => {
                return e.parametre &&  e.parametre.code == "ECH_SAL" ? true : false
            });
            if(echCC && echCC[0] && echCC[0].value && this.echEnable){
                this.echSelect = this.echEnable.find(el => el == echCC[0].value)
                if(this.echSelect && this.dataSalFormGroup){
                    this.dataSalFormGroup.get("ECH_CC").setValue(this.echSelect);
                }
            }
        }
        if(this.dossier && this.dossier.entete && this.optionQualite){
            let qualiteCC = this.dossier.entete.filter(e => {
                return e.parametre &&  e.parametre.code == "CC_CLASSIF_RANG4" ? true : false
            });
            if(qualiteCC && qualiteCC[0] && qualiteCC[0].value){
                this.qualiteSelect = this.optionQualite.find(el => el == qualiteCC[0].value)
                if(this.qualiteSelect && this.dataSalFormGroup){
                    this.dataSalFormGroup.get("CC_CLASSIF_RANG4").setValue(this.qualiteSelect);
                }
            }
        }
        if (!this.niveauIsUsed)
            this.nivEnable = []
        if (!this.echelonIsUsed)
            this.echEnable = []
        if (!this.qualiteIsUsed)
            this.optionQualite = []

    }

    // getSdcCumul(){
    //     this.sdcCumul = null
    //     this.sdcCumulBS = null

    //     let indemniteRupture = 0;
    //     let indemniteSpecRC = 0;
    //     let indemniteRetraite = 0;
    //     let montantTransac = 0;
    //     let montantContentieux = 0;
    //     let montantPSE = 0;

    //     let indemnitesVerseesTotal: string|number = 0;
    //     let indemnitePreavis = 0;

    //     this.dossier.entete.forEach(entete => {
    //         // if (entete.parametre && entete.parametre.code == 'MNT_BRUT'
    //         // && entete.parametre.parent && entete.parametre.parent.code 
    //         // && entete.parametre.parent.code == "FIR_IND_RUPT") {
    //         //     this.sdcCumul = entete.valueint ? entete.valueint :(parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         // }
    //         // if (entete.parametre && entete.parametre.code == 'MNT_EMP'
    //         // && entete.parametre.parent && entete.parametre.parent.code 
    //         // && entete.parametre.parent.code == "FIR_IND_RUPT") {
    //         //     this.sdcCumulBS = entete.valueint ? entete.valueint :(parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         // }
    //         if (this.doesEnteteMatchCode(entete, "IND_RUPT")) {
    //             indemniteRupture = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (this.doesEnteteMatchCode(entete, "IND_SPEC_RC")) {
    //             indemniteSpecRC = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (this.doesEnteteMatchCode(entete, "IND_RETRAITE")) {
    //             indemniteRetraite = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (this.doesEnteteMatchCode(entete, "MNT_TRANSAC")) {
    //             montantTransac = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (this.doesEnteteMatchCode(entete, "MNT_CONTENTIEUX")) {
    //             montantContentieux = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (this.doesEnteteMatchCode(entete, "MNT_IND_PSE")) {
    //             montantPSE = entete.valueint ? entete.valueint : (parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0)
    //         }
    //         if (entete.parametre && entete.parametre.code == 'ICCP_SYNTHESE') {
    //             let json = JSON.parse(entete.value)
    //             if (json && json.INDEMNITES_VERSEES) {
    //                 indemnitesVerseesTotal = json.INDEMNITES_VERSEES ? parseFloat(json.INDEMNITES_VERSEES.MNT_TOTAL).toFixed(3) : 0;
    //             }
    //         }
    //         if (this.doesEnteteMatchCode(entete, "IND_PREAVIS")) {
    //             indemnitePreavis = entete.valueint ? entete.valueint :(parseFloat(entete.value) ? Math.floor(parseFloat(entete.value)) : 0);
    //         }
    //     });

    //     switch (this.getResultMotifRupture()) {
    //         case "LicPers" :
    //             this.sdcCumul = indemniteRupture + montantTransac + montantContentieux;
    //             break;
    //         case "LicEco" :
    //             this.sdcCumul = indemniteRupture + montantTransac + montantContentieux + montantPSE;
    //             break;
    //         case "RC" :
    //             this.sdcCumul = indemniteSpecRC + montantTransac + montantContentieux;
    //             break;
    //         case "DR" :
    //             this.sdcCumul = indemniteRetraite + montantTransac + montantContentieux;
    //             break;
    //         default:
    //             break;
    //     }
    //     this.sdcCumulBS = indemnitesVerseesTotal;

    // }

    // getIccpMntNb(){
    //     this.iccpMnTotal = 0
    //     this.iccpMnNbIccp = 0

    //     this.dossier.entete.forEach(entete => {
    //         if (entete.parametre && entete.parametre.code == 'ICCP_SYNTHESE') {
    //             let json = JSON.parse(entete.value)
    //             if (json && json.INDEMNITES_CALCULEES) {
    //                 this.iccpMnNbIccp = json.INDEMNITES_CALCULEES ? parseFloat(json.INDEMNITES_CALCULEES.NB_ICCP).toFixed(0) : 0
    //                 this.iccpMnTotal = json.INDEMNITES_CALCULEES ? parseFloat(json.INDEMNITES_CALCULEES.MNT_ICCP).toFixed(3) : 0
    //             }
    //         }
    //         // if (entete.parametre && entete.parametre.code == 'ICCP_PERIODE_N') {
    //         //     let json = JSON.parse(entete.value)
    //         //     if (json && json.NB_JOURS_CALENDAIRES) {
    //         //         this.iccpMnNbIccp = parseFloat(json.NB_JOURS_CALENDAIRES).toFixed(0);
    //         //     }
    //         // }
    //         if (entete.parametre && entete.parametre.code == 'ICCP_STATUT') {
    //             if (entete.value === "OK") {
    //                 this.isICCP = true;
    //             }
    //         }
    //     });
    // }

    // getSalaireRef(){
        
    //     let salRef = this.dossier.entete ? this.dossier.entete.filter(e => {
    //         return e.parametre && ["SAL_REF_RUPTURE_CC", "MOIS_12_SAL_REF"].includes(e.parametre.code);
    //     }) : null;
    //     let salRefValue = salRef.map(e => parseFloat(e.value));
    //     if (salRefValue.length > 0) {
    //         this.salaireRef = Math.max.apply(null,salRefValue);
    //         this.salaireRefNaN = false;
    //     } else {
    //         this.salaireRef = 'non calculé';
    //         this.salaireRefNaN = true;
    //     }
    //     let salRefRuptureLegal = this.dossier.entete ? this.dossier.entete.filter(e => {
    //         return e.parametre && ["SAL_REF_RUPTURE_LEGAL"].includes(e.parametre.code);
    //     }) : null;
    //     let salRefRuptureLegalValue = salRefRuptureLegal.map(e => parseFloat(e.value));
    //     this.salaireRefRuptureLegal = salRefRuptureLegalValue[0];
    // }


    //Pour les rapports => pliage / dépliage
    folding(e){
        let balise = e.target.tagName
        if(balise == "H1"){
            let ok = true
            let ok2 = true
            let ok3 = true
            if((<HTMLElement>e.target.parentElement).classList.contains("plie")){
                (<HTMLElement>e.target.parentElement).classList.remove("plie")
                let target = e.target.parentElement
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName == "DIV" && (<HTMLElement>target.nextElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target.nextElementSibling).classList.add("plie")
                        target = target.nextElementSibling
                    }else{
                        ok = false
                    }
                }
                let target3 = e.target.parentElement
                while(ok3){
                    if((<HTMLElement>target3.previousElementSibling) && target3.previousElementSibling.tagName == "DIV" && (<HTMLElement>target.previousElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target3.previousElementSibling).classList.add("plie")
                        target3 = target3.previousElementSibling
                    }else{
                        ok3 = false
                    }
                }
                let target2 = e.target
                while(ok2){
                    if((<HTMLElement>target2.nextElementSibling) && target2.nextElementSibling.tagName !== balise && target2.nextElementSibling.tagName !== "DIV" && target2.nextElementSibling.tagName !== "APP-FOOTER" ){
                        (<HTMLElement>target2.nextElementSibling).classList.remove("plie")
                        if ((<HTMLElement>target2).hasChildNodes()) {
                            let children = (<HTMLElement>target2).childNodes;
                            for (var i = 0; i < children.length; i++) {
                                if((<HTMLElement>target2.nextElementSibling).classList.contains("plie")){
                                    (<HTMLElement>target2.nextElementSibling).classList.remove("plie")
                                }
                            }
                        }
                        target2 = target2.nextElementSibling
                    }else{
                        ok2 = false
                    }
                }
                let offset = e.target.parentElement.offsetTop;
                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                })
            }else{
                (<HTMLElement>e.target.parentElement).classList.add("plie")
                let oktarget = true
                let target = e.target
                while(oktarget){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName == "DIV" && (<HTMLElement>target.nextElementSibling).classList.contains("rapport-display") ){
                        (<HTMLElement>target.nextElementSibling).classList.add("plie")
                        target = target.nextElementSibling
                    }else{
                        oktarget = false
                    }
                }
            }
        }else if(balise == "H2" || balise == "H3"){
            let ok = true
            if((<HTMLElement>e.target).classList.contains("plie")){
                (<HTMLElement>e.target).classList.remove("plie")
                let target = e.target
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName !== balise && target.nextElementSibling.tagName !== "DIV" && target.nextElementSibling.tagName !== "APP-FOOTER" ){
                        (<HTMLElement>target.nextElementSibling).classList.remove("plie")
                        target = target.nextElementSibling
                    }else{
                        ok = false
                    }
                }
            }else{
                (<HTMLElement>e.target).classList.add("plie")
                let target = e.target
                while(ok){
                    if((<HTMLElement>target.nextElementSibling) && target.nextElementSibling.tagName !== balise && target.nextElementSibling.tagName !== "DIV" && target.nextElementSibling.tagName !== "APP-FOOTER" ){
                        if(balise == "H3" && target.nextElementSibling.tagName == "H2" ){
                            ok = false
                        }else{
                            (<HTMLElement>target.nextElementSibling).classList.add("plie")
                            target = target.nextElementSibling
                        }
                    }else{
                        ok = false
                    }
                }
            }
        }
    }
    unfoldAll(){
        let elements = document.querySelectorAll('.plie')
        elements.forEach(element => {
            (<HTMLElement>element).classList.remove("plie")
                
        });
    }
    foldAll(){
        let targets = document.querySelectorAll('.container-rapport .rapport-integrated > *');
        let targetsParents = document.querySelectorAll('.container-rapport .rapport-integrated');
        targets.forEach(target=>{
            (<HTMLElement>target).classList.add("plie");
        }) 
        targetsParents.forEach(target=>{
            (<HTMLElement>target).classList.add("plie");
        })
    }

    ngOnDestroy(){
        this.titleService.setTitle("Rupture by Cobham");
        window.removeEventListener('message',this.listenerIframeCalc);
        this.cdf.detach()
        for(let element in this.subscribe){
            this.subscribe[element].unsubscribe();
            this.subscribe[element] = null;
        }
    }
    
    seeInstruction(instruction){
        const dialogRef = this.dialog.open(InstructionDialog, {
        width: '100%',
        panelClass: instruction.numInstruction == 5 ? 'instruction5-dialog' : 'instruction-dialog',
        data: {numInstruction: instruction.numInstruction,
            datesortie : this.datefinperiode,
            datecreation : this.dossier.datecreation,
            datedebperiode : this.datedebperiode
        }
        });
    }

    seeError(){
        const dialogRef = this.dialog.open(DialogsErrorsComponent, {
            width: '100%',
            panelClass: 'instruction-dialog',
            data: {
                erreurperiode : this.erreurperiode
            }
        })
        dialogRef.beforeClosed().subscribe(res => {
            if(res && res.parcourir){
                let inputUpload = document.getElementById("input-upload-doc")
                inputUpload.click()
            }
        })
    }

    trackById(index:number, entity:any):string{
        return entity.id
    }

    checkMotifSortie(motif){
        if(this.dossier && this.dossier.entete){
            let value = this.dossier.entete.filter(ent => ent.parametre && ent.parametre.code == 'MOTIF_SORTIE' && ent.value && ent.value == motif)
            return value.length >0 ? true : false
        }
        return false
    }

    
    computeInputWithUnitFocus(event) {
        if (event.type == 'blur') {
            event.target.parentNode.className = 'input-with-unit';
        } else if (event.type == 'focus') {
            event.target.parentNode.className = 'input-with-unit focus';
        }
    }

    processChangeQualifMain() {
        if (this.dataCTFormGroup && this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "TRUE") {
            if (this.qualifSelect != this.paramsCT.get("qualification").value)
                this.paramsCT.get("qualification").setValue(this.qualifSelect);


            if (this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE") {
                this.listAvenant.forEach(avenant => {
                    if (this.qualifSelect != avenant['qualification'])
                        avenant['qualification'] = this.qualifSelect;
                });
            } else if (this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "TRUE") {
                this.listAvenant = [];
            }
        }
    }

    addAvenant(visible = true) {
        let allDataForm = this.getDataForm(["TPS_TRAV","TPS_TRAV_UNIT","TPS_TRAV_COLL","TPS_PLEIN_TRAV","DT_DEBUT_CONT","DT_S","DT_ENT_CT"]);
        this.nbAvenant++;
        let avenant = {
            "dateSignature" : null,
            "qualification" : this.qualifSelect,
            "tempsTravail" : allDataForm ? (allDataForm["TPS_TRAV"] ? Math.round(allDataForm["TPS_TRAV"]*100)/100 : null) : null,
            "tempsTravailUnite" : allDataForm && allDataForm["TPS_TRAV_UNIT"] ? allDataForm["TPS_TRAV_UNIT"] : "",
            "tempsTravailCollectif" : allDataForm && allDataForm["TPS_TRAV_COLL"] ? allDataForm["TPS_TRAV_COLL"] : this.getConstanteValue("TPS_TRAV_LEGAL", this.getDateReferenceDossier()),
            "tempsTravailType" : allDataForm && allDataForm["TPS_PLEIN_TRAV"] ? allDataForm["TPS_PLEIN_TRAV"] : "",
            "id" : this.nbAvenant,
            "dateInterval" : {
                "debut" : (allDataForm ? (allDataForm["DT_DEBUT_CONT"] ? formatDate(allDataForm["DT_DEBUT_CONT"], "y-MM-dd", "en") : formatDate(allDataForm["DT_ENT_CT"], "y-MM-dd", "en")): ""),
                "fin" : (allDataForm ? (allDataForm["DT_S"] ? formatDate(allDataForm["DT_S"], "y-MM-dd", "en") : formatDate(new Date(), "y-MM-dd", "en")) : formatDate(new Date(), "y-MM-dd", "en"))
            },
            "visible" : visible,
            "error" : []
        }
        this.listAvenant.push(avenant);
    }

    updateAvenant(avenant : any) {
        if (avenant.tempsTravailUnite == "HS") {
            let roundTpsTrav = Math.round(avenant.tempsTravail * 10) / 10;
            if (roundTpsTrav != avenant.tempsTravail) {
                avenant.tempsTravail = roundTpsTrav;
            }
        }
        if (avenant.tempsTravailUnite != "HS" || avenant.tempsTravailCollectif == "") {
            avenant.tempsTravailCollectif = this.getConstanteValue("TPS_TRAV_LEGAL",avenant.dateSignature);
        }

        let travailType = this.getTempsTravailType(avenant.dateSignature, avenant.tempsTravail, avenant.tempsTravailUnite, avenant.tempsTravailCollectif);
        avenant.tempsTravailType = travailType;

        // Pour trier chronologiquement
        this.listAvenant = this.listAvenant.sort((a,b) =>  {
            if (b["dateSignature"]) {
                return Date.parse(a["dateSignature"]) - Date.parse(b["dateSignature"]) 
            }
            return -Date.parse(a["dateSignature"]);
        });
        console.log(this.listAvenant);
        this.cdf.detectChanges();
    }

    removeAvenant(avenant : any) {
        let index = this.listAvenant.indexOf(avenant);
        if (index > -1) {
            this.listAvenant.splice(index, 1);
        }
        this.nbAvenant--;
    }

    removeAllAvenants() {
        this.listAvenant = [];
    }

    toggleChipUniteTravail(chip, list) {
        if (!chip.value) {
            chip = {
                value : chip
            };
        }
        list.forEach(c => {
            if (chip.value == c.value) {
                c.selected = true;
                this.paramsCT.get("tempsTravailUnite").setValue(chip.value);
                if (chip.value != "HS") {
                    this.paramsCT.get("tempsTravailCollectif").setValue(this.getConstanteValue("TPS_TRAV_LEGAL",this.getDateReferenceDossier()));
                }
                this.updateCTTpsType();
            } else {
                c.selected = false;
            }
        });
    }

    toggleChipCTQualification(chip : any, list) {
        list.forEach(c => {
            if (chip.id == c.id) {
                c.selected = true;
                this.qualificationInput = chip.id;
                this.paramsCT.get("qualification").setValue(chip.id);
            } else {
                c.selected = false;
            }
        });
    }

    getAllDataFromCode(code) {
        let result = [];
        if (this.dossier.entete) {
            this.dossier.entete.forEach(entete => {
                if (entete.parametre.code === code) {
                    if (entete.indexRepeatability != undefined) {
                        if (result[entete.indexRepeatability] !== undefined) {
                            result[entete.indexRepeatability][entete.indexIndice] = entete.valueint !== undefined ? entete.valueint : entete.value;
                        } else {
                            result[entete.indexRepeatability] = [];
                            result[entete.indexRepeatability][entete.indexIndice] = entete.valueint !== undefined ? entete.valueint : entete.value;
                        }
                    } else {
                        result[entete.indexIndice] = entete.valueint !== undefined ? entete.valueint : entete.value;
                    }
                }
            })
        }
        return result;
    }

    checkCTAV() {
        let success = true;
        let message = [];
        this.required = [];
        this.listAvenant.forEach(avenant => { avenant['error'] = []; });

        //Blocage #5404
        if(this.paramsCT.get("tempsTravail").value && !this.paramsCT.get("tempsTravailCollectif").value && this.paramsCT.get("tempsTravailUnite").value != "HS"){
            this.paramsCT.get("tempsTravailCollectif").setValue(this.paramsCT.get("tempsTravail").value);
        }
        //champ manquant paramsCT
        if (!this.paramsCT.get("tempsTravail").value || !this.paramsCT.get("tempsTravailUnite").value || !this.paramsCT.get("tempsTravailCollectif").value || !this.paramsCT.get("tempsTravailType").value) {
            this.required["TEMPS_CT"] = true;
            success = false;
            message.push("ct tps missing");
        }   
        if (!this.paramsCT.get("qualification").value) {
            this.required["QUALIF_CT"] = true;
            success = false;
            message.push("ct qualif missing");
        }
        
        if (this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "TRUE" && this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "TRUE" && this.qualifSelect != this.paramsCT.get("qualification").value) {
            message.push("ct qualif correspond pas a qualif écran salarié");
            this.required["QUALIF_CT"] = true;
            success = false;
        }
        
        //coche chgmt travail ou qualif + pas avenant
        if ((this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE" || this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "FALSE") && this.listAvenant.length === 0) {
            this.required["MISSING_AV"] = true;
            success = false;
            message.push("avenant missing");
        }

        if ((this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE" || this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "FALSE") && this.listAvenant.length > 0) {
            this.listAvenant.forEach(avenant => {
                //champ manquant date avenant
                let currentDate = new Date(avenant["dateSignature"]).getTime();
                if (currentDate == 0 || new Date(avenant["dateInterval"]["debut"]).getTime() > currentDate || new Date(avenant["dateInterval"]["fin"]).getTime() < currentDate || currentDate == undefined) {
                    success = false;
                    avenant["error"]["date"] = true;
                    message.push("av date missing");
                }

                //coche chgmt travail + champ tps trav / unite / coll non rempli
                if (this.dataCTFormGroup.get("BOOL_CONST_TPS_TRAV").value == "FALSE") {
                    if (!avenant["tempsTravail"] || !avenant["tempsTravailUnite"] || !avenant["tempsTravailCollectif"] || !avenant["tempsTravailType"]) {
                        success = false;
                        avenant["error"]["tempsTravail"] = true;
                        message.push("av tps missing");
                    }
                }
    
                //coche cghmt qualif + champ qualif non rempli
                if (this.dataCTFormGroup.get("BOOL_CONST_QUALIF").value == "FALSE") {
                    if (!avenant["qualification"]) {
                        success = false;
                        avenant["error"]["qualification"] = true;
                        message.push("av qualif missing");
                    }
                }
            });

            // dernier avenant doit avoir this.qualifSelect #5386 suppression verif
            /*if (this.listAvenant[this.listAvenant.length -1]['qualification'] != this.qualifSelect) {
                
                success = false;
                message.push("last av qualif correspond pas a qualif écran salarié");
                this.listAvenant[this.listAvenant.length -1]["error"]["qualification"] = true;
                this.listAvenant[this.listAvenant.length -1]["error"]["text"] = 
                "En absence d’autres avenants à saisir, la qualification du dernier avenant doit correspondre à la qualification trouvée sur le dernier Bulletin de Salaire, soit : " + this.qualifSelect + ".";
            }*/

            // dernier aveant doit avoir TPS_TRAV
            // if (this.listAvenant[this.listAvenant.length -1]['tempsTravail'] != this.getEnteteFromCode("TPS_TRAV") || this.listAvenant[this.listAvenant.length -1]['tempsTravailUnite'] != this.getEnteteFromCode("TPS_TRAV_UNIT")) {
            //     success = false;
            //     message.push("last av tps correspond pas a tps bs");
            //     this.listAvenant[this.listAvenant.length -1]["error"]["tempsTravail"] = true;
            // }
        }

        console.log(message);
        return success;
    }

    resetContratTravail(checked, type) {
        let allDataForm = this.getDataForm(["TPS_TRAV","TPS_TRAV_UNIT","TPS_TRAV_COLL","TPS_PLEIN_TRAV"]);
        if (checked == "TRUE") {
            switch(type) {
                case "qualification":
                    this.listAvenant.forEach(avenant => {
                        avenant["qualification"] = this.qualifSelect;
                    })
                    this.paramsCT.get("qualification").setValue(this.qualifSelect);
                    break;
                case "temps":
                    let resetValue = {
                        "tempsTravail" : allDataForm ? (allDataForm["TPS_TRAV"] ? Math.round(allDataForm["TPS_TRAV"]*100)/100 : null) : null,
                        "tempsTravailUnite" : allDataForm && allDataForm["TPS_TRAV_UNIT"] ? allDataForm["TPS_TRAV_UNIT"] : "",
                        "tempsTravailCollectif" : allDataForm && allDataForm["TPS_TRAV_COLL"] ? allDataForm["TPS_TRAV_COLL"] : this.getConstanteValue("TPS_TRAV_LEGAL",this.getDateReferenceDossier()),
                        "tempsTravailType" : allDataForm && allDataForm["TPS_PLEIN_TRAV"] ? allDataForm["TPS_PLEIN_TRAV"] : "",
                    }
                    this.listAvenant.forEach(avenant => {
                        avenant["tempsTravail"] = resetValue['tempsTravail'];
                        avenant["tempsTravailUnite"] = resetValue['tempsTravailUnite'];
                        avenant["tempsTravailCollectif"] = resetValue['tempsTravailCollectif'];
                        avenant["tempsTravailType"] = resetValue['tempsTravailType'];
                        avenant["dateSignature"] = "";
                    })
                    /*this.paramsCT.get("tempsTravail").setValue(resetValue['tempsTravail']);
                    this.paramsCT.get("tempsTravailUnite").setValue(resetValue['tempsTravailUnite']);
                    this.paramsCT.get("tempsTravailCollectif").setValue(resetValue['tempsTravailCollectif']);
                    this.paramsCT.get("tempsTravailType").setValue(resetValue['tempsTravailType']);

                    this.toggleChipUniteTravail(resetValue['tempsTravailUnite'], this.listUniteTravail)*/
                    this.required["MISSING_AV"] = false;
                    break;
            }
        }
    }

    getTempsTravailType(date, tempsTravail, tempsTravailUnite, tempsTravailCollectif) {
        if (!date)
            date = this.getDateReferenceDossier()
        tempsTravailCollectif = tempsTravailCollectif ? tempsTravailCollectif : 0;
        let tempsTravailLegal = this.getConstanteValue("TPS_TRAV_LEGAL",date);
        if (tempsTravailUnite == "HS" && tempsTravail < tempsTravailLegal) {
            if (tempsTravailCollectif < tempsTravailLegal) {
                if (tempsTravail < tempsTravailCollectif) {
                    return "Partiel";
                } else {
                    return "Plein";
                }
            } else {
                return "Partiel";
            }
        } else if (tempsTravailUnite == "HS" && tempsTravail >= tempsTravailLegal) {
            return "Plein";
        } else {
            return "Plein";
        }
    }

    roundTpsTrav() {
        if (this.paramsCT.get("tempsTravailUnite").value == "HS") {
            let roundTpsTrav = Math.round(this.paramsCT.get("tempsTravail").value * 10) / 10;
            if (roundTpsTrav != this.paramsCT.get("tempsTravail").value) {
                this.paramsCT.get("tempsTravail").value = roundTpsTrav;
                this.updateCTTpsType();
            }
        }
    }

    updateCTTpsType() {

        this.paramsCT.get("tempsTravailType")
            .setValue(this.getTempsTravailType(
                this.getDateReferenceDossier(), 
                this.paramsCT.get("tempsTravail").value, 
                this.paramsCT.get("tempsTravailUnite").value, 
                this.paramsCT.get("tempsTravailCollectif").value
            ));
    }

    getDateReferenceDossier(){
        const dateDuJour = new Date();
        const dateFormatee = dateDuJour.toISOString().split('T')[0] + 'T00:00:00';
        const dtS = this.getEnteteFromCode("DT_S");
        return dtS || dateFormatee;
    }
    

    getConstanteValue(code, date = null) {
        if (this.constantes.hasOwnProperty(code) && this.constantes[code] !== null && date !== null) {
            if (date.length > 10)
                date = date.substring(0,10)
            if (Array.isArray(this.constantes[code])) {
                let result = null;
                let refDate = new Date(date);
                this.constantes[code].forEach(constante => {
                    let compareDate = constante["dateFin"] ? new Date(constante["dateFin"]) : null;
                    let resultDate = result && result["dateFin"] !== undefined ? new Date(result["dateFin"]) : null;
                    if (compareDate !== null && refDate < compareDate && (result === null || resultDate === null || compareDate < resultDate)) {
                        result = constante;
                    } else if (compareDate === null && result === null) {
                        result = constante;
                    }
                });
                return result && result['value'] !== undefined ? result['value'] : "";
            } else {
                return this.constantes[code];
            }
        }
        return "";
    }

    setSvgToggle(formGroup, param) {

        console.log("set svgtoggle param : ", param)
        console.log("set svgtoggle formgroup : ", formGroup)
        if (formGroup.get(param).value == "TRUE") {
            if (this.svgToggleAddBS) {
                this.svgToggleAddBS["positionStart"] = "TRUE";
                this.svgToggleAddBS["positionCxButton"] = "37";
                this.svgToggleAddBS["fillColorButton"] = "#FBEB00";
                this.svgToggleAddBS["fillColorBack"] = "#6016AA";
            }
        } else {
            if (this.svgToggleAddBS) {
                this.svgToggleAddBS["positionStart"] = "FALSE";
                this.svgToggleAddBS["positionCxButton"] = "14";
                this.svgToggleAddBS["fillColorButton"] = "#6016AA";
                this.svgToggleAddBS["fillColorBack"] = "#FFF";
            }
        }
    }

    showAllSynd_Sign() {
        // this.nb_displayed_synd_sign = this.choice_cc['avenant_synd_signataire'].length;
        this.dialog.open(DialogCommonMessage, {
            width: '100%',
            panelClass:'message-dialog-supp',
            data: {
                "title" : "Syndicats / Organisations",
                "array" : this.choice_cc['avenant_synd_signataire']
            }
        });
    }

    formatDateToString(date: Date) {
        const offset = date.getTimezoneOffset(); 
        date = new Date(date.getTime() + (offset*60*1000)); 
        date.toISOString().split('T')[0];
    }

    getDifferenceInMonths(dateA: Date, dateB: Date) {
        let months: number;
        months = (dateB.getFullYear() - dateA.getFullYear()) * 12;
        months -= dateA.getMonth();
        months += dateB.getMonth();
        return months <= 0 ? 0 : months;
    }

    setErrorHandlingMessage(error) {
        this.errorHandlingMessage = error;
    }

    openPayslipsDialog() {
        let data = [];
        let payslips = this.payslipCollection.payslips;

        payslips.forEach(payslip => {
            if (payslip.data && payslip.data["datedebutbs"]) {
                data.push(payslip);
            }
        });

        this.payslipService.showMultiplePayslips(data);
    }

    updatePeriodAfterInput() {
        let startDate = this.dossier.datedebut ? formatDate(this.dossier.datedebut, "y-MM-dd", "en") : "";
        let breachDate = this.dataUpdateDossFormGroup.get("DATE_RUPT").value ? 
            formatDate(this.dataUpdateDossFormGroup.get("DATE_RUPT").value, "y-MM-dd", "en") : "";
        let dateSickness = this.dataUpdateDossFormGroup.get("DT_ARRET_TRAV").value ? 
            formatDate(this.dataUpdateDossFormGroup.get("DT_ARRET_TRAV").value, "y-MM-dd", "en") : "";
        let endDate = this.dataUpdateDossFormGroup.get("DT_S").value ? 
            formatDate(this.dataUpdateDossFormGroup.get("DT_S").value, "y-MM-dd", "en") : "";
        
        this.appService.getDatePeriode(
            startDate,
            this.checkEndDate() ? this.dataUpdateDossFormGroup.get("EN_POSTE").value : this.dossier.poste,
            this.checkEndDate() ? endDate : "",
            this.dataUpdateDossFormGroup.get("MOTIF_SORTIE").value,
            this.checkBreachDate() ? breachDate : "",
            this.checkSicknessDate() ? this.dataUpdateDossFormGroup.get("BOOL_MALADIE_LIC").value : "", 
            this.checkSicknessDate() ? dateSickness : "",
        ).subscribe(res => {
            if (res.result && !res.result.error) {
                let difference
                let startDatePeriod;
                let endDatePeriod= new Date();

                if (res.result && res.result.datefin)
                    endDatePeriod = new Date(res.result.datefin);
                if (res.result && res.result.datedeb) {
                    startDatePeriod = new Date(res.result.datedeb);
                    difference = startDatePeriod.getDifferenceInMonths(endDatePeriod) + 1;
                    if (difference >= 12) {
                        this.payslipsMonthsLength = difference;
                    }
                }

                if (difference >= 12) {
                    this.dateParamsForPayslips = {
                        startDatePeriod : startDatePeriod,
                        endDatePeriod : endDatePeriod,
                    }
                    this.updateMissingBS(startDatePeriod, endDatePeriod);
                    this.hasSoldeToutCompteInDate(endDatePeriod);
                }
            }
        })
    }

    updateMissingBS(startDatePeriod, endDatePeriod) {
        if (!startDatePeriod || !endDatePeriod) {
            return;
        }
        this.appService.getMissingBsFromPeriod(this.dossier.id, startDatePeriod, endDatePeriod)
            .subscribe(res => {
                if (res && res.result && res.result.missingBS) {
                    this.missingBS = res.result.missingBS
                    this.nbMoisBsOk = (res.result.NB_MOIS_PERIODE_BS ? res.result.NB_MOIS_PERIODE_BS : 18) - res.result.missingBS.length
                    this.cdf.markForCheck()
                } else if (res && res.result) {
                    this.missingBS = res.result.missingBS
                    this.nbMoisBsOk = (res.result.NB_MOIS_PERIODE_BS ? res.result.NB_MOIS_PERIODE_BS : 18) - res.result.missingBS.length
                    this.cdf.markForCheck()
                }
            });
    }

    checkEndDate() {
        if (this.dataUpdateDossFormGroup.get("EN_POSTE").value == "FALSE") {
            if (this.dataUpdateDossFormGroup.get("DT_S").value) {
                return true;
            }
        }
        return false;
    }

    checkBreachDate() {
        if (this.dataUpdateDossFormGroup.get("BOOL_CONT_ROMPU").value == "TRUE") {
            if (this.dataUpdateDossFormGroup.get("DATE_RUPT").value) {
                return true;
            }
        }
        return false;
    }

    checkSicknessDate() {
        if (this.dataUpdateDossFormGroup.get("BOOL_MALADIE_LIC").value == "TRUE") {
            if (this.dataUpdateDossFormGroup.get("DT_ARRET_TRAV").value) {
                return true;
            }
        }
        return false;
    }

    updatePayslips(payslipCollection) {
        this.payslipCollection = payslipCollection;
        this.updateMissingBS(payslipCollection.startDatePeriod, payslipCollection.endDatePeriod);
        if (this.dataUpdateDossFormGroup.get("DT_S").value) {
            this.hasSoldeToutCompteInDate(new Date(this.dataUpdateDossFormGroup.get("DT_S").value));
        }
        this.cdf.markForCheck()
    }

    hasSoldeToutCompteInDate(date: Date) {

        let hasSoldeToutCompteDate;
        this.payslipCollection.consecutivePayslips.forEach(payslip => {
            let currentDate = new Date(payslip.data["datedebutbs"]);
            if (currentDate.getMonth() === date.getMonth() 
                && currentDate.getFullYear() === date.getFullYear()) 
            {
                hasSoldeToutCompteDate = currentDate;
            }
        });

        this.stringDateLeaving =
            date.toLocaleString("fr", {month : "long"}) 
            + " " + date.toLocaleString("fr", {year : "numeric"});
        
        if (hasSoldeToutCompteDate) {
            this.dateStringSoldeToutCompte = 
                hasSoldeToutCompteDate.toLocaleString("fr", {month : "long"}) 
                + " " + hasSoldeToutCompteDate.toLocaleString("fr", {year : "numeric"});
            // this.dataUpdateDossBlock["Mode"] = "DIAGNOSTIC STC";
        } else {
            this.dateStringSoldeToutCompte = "";
            // this.dataUpdateDossBlock["Mode"] = 
            //     (this.dataUpdateDossFormGroup.get("EN_POSTE").value == "TRUE") ? "SIMULATION" : "DIAGNOSTIC";
        }
    }

    /**
     * @param entete 
     * @param code 
     * @param parent Si plusieurs parents sont donnés dans le tableau, le deuxième parent sera recherché 
     * en fonction du premier et ainsi de suite.
     * 
     * @returns 
     */
    doesEnteteMatchCode(entete, code : string, parentCodes = []) {
        let enteteMatches = false;
        if (entete.parametre && entete.parametre.code == code) {
            if (parentCodes.length === 0) {
                enteteMatches = true;
            } else {
                let currentParent = null;
                for (let i = 0; i < parentCodes.length; i++) {
                    if (i > 0) {
                        currentParent = 
                            this.getParentFromParametreIfCodeMatches(currentParent, parentCodes[i]);
                    } else {
                        currentParent = 
                            this.getParentFromParametreIfCodeMatches(entete.parametre, parentCodes[i]);
                    }
                    if (!currentParent) {
                        break;
                    } else {
                        enteteMatches = parentCodes.length === i;
                    }
                }
            }
        }
        return enteteMatches;
    }

    getParentFromParametreIfCodeMatches(parametre, parentCode : string) {
        if (parametre.parent && parametre.parent.code
            && parametre.parent.code == parentCode) 
        {
            return parametre.parent;
        }
        return null;
    }

    // getResultMotifRupture() {
    //     let motifRupture = "";
    //     let listMotifs = this.motifRuptureEntete;
    //     if (listMotifs) {
    //         Object.keys(listMotifs).forEach(function(motif) {
    //             if (listMotifs[motif]) {
    //                 motifRupture = motif;
    //             }
    //         });
    //     }
    //     return motifRupture;
    // }

    getEnteteFromCode(code, entetes=[]) {
        let value = "";
        if (entetes.length === 0 && this.dossier.entete)
            entetes = this.dossier.entete

        entetes.find(entete => {
            if (entete.parametre.code == code) {
                value = entete.valueint ? entete.valueint : (entete.valuedate ? entete.valuedate : entete.value);
            }
        })

        return value;
    }
    
    getDataForm(arrayCode){
        let result = [];
        for (let i = 0; i < arrayCode.length; i++) {
            result[arrayCode[i]] = this.getEnteteFromCode(arrayCode[i]);
        }
        return result;
    }
    
    checkIfDossierHasDoublon() {
        let currentPage = "";
        switch(this.dataStep) {
            case 1 :
                currentPage = "employeur";
                break;
            case 2 :
                currentPage = "salarié";
                break;
            case 3 :
                currentPage = "contrat de travail";
                break;
            default :
                currentPage = this.currentCalculette && this.currentCalculette.hasOwnProperty('code') ? this.currentCalculette['code'] : "indefinie";
                break; 
        }
        this.appService.logIfDossierHasDoublon(this.dossier.id, currentPage).subscribe((res) => {
            if (res && res.result) {
                console.warn("doublon(s) détecté(s)");
            }
        })
    }

    consolidationBS() {
        this.appService.changeEtatValidationDossier(this.dossier.id, 4).subscribe((data) => {
            this.isPauseCobham = true;
            this.cdf.detectChanges();
        });
        this.appService.consolidationBS(this.dossier.id).subscribe((data) => {
            if(data.result && data.result.bulletinSalaire){
                this.appService.processPauseCobham(this.dossier.id).subscribe((data) => {
                    this.cdf.detectChanges();
                });
            }
        });
    }

    setButtonsToPauseCobham() {
        this.buttonsPauseCobham = true;
    }

    openDialogDocuments() {
        this.dialog.open(ReadDocumentsComponent, {
            width: '100%',
            maxWidth: "",
            panelClass: ["container", "read-documents-dialog"],
            data: {
                dossierId: this.dossier.id
            }
        });
    }
    

    addToComparateur(dossier)
    {
        this.eventDossierComparateur.next(dossier);
    }

    updateDossierComparateur(dossier)
    {
        this.eventUpdateDossierComparateur.next(dossier);
    }

    sortBy(liste: [], prop: string) {
        if (prop)
            return liste.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
        else
            return liste.sort((a, b) => a > b ? 1 : a === b ? 0 : -1);
    }

    displayRapport(rapport) {
        if (this.rapportSelected.length === 0 || this.rapportSelected[0] != rapport) {
            this.rapportPrecharge = rapport == 'synthese' ? this.syntheseGeneree : null;
            this.syntheseGeneree = null;
            this.rapportSelected[0] = rapport;
            this.cdf.detectChanges()
        }
    }
    
    startUnfolding() {
        this.helperOn = !this.helperOn;
        this.bggrey = false;
        window['tryga']('send', 'event', 'dossier', 'suivant_debut', '', '');
    }
    getUsersLocale(defaultValue: string): string {
        if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
            return defaultValue;
        }
        const wn = window.navigator as any;
        let lang = wn.languages ? wn.languages[0] : defaultValue;
        lang = lang || wn.language || wn.browserLanguage || wn.userLanguage;
        return lang;
    }
    dateDiffInDays(dateA, dateB) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        const utc1 = Date.UTC(dateA.getFullYear(), dateA.getMonth(), dateA.getDate());
        const utc2 = Date.UTC(dateB.getFullYear(), dateB.getMonth(), dateB.getDate());
    
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
    }
    stopDelegation() {
        let userLocale = this.getUsersLocale("fr");
        let daysDiff = this.dateDiffInDays(new Date(), this.delegationTokenExpirationDate);
        let expireString = "";
        
        if (daysDiff == 1 ) {
            expireString = "demain";
        } else {
            expireString = "dans " + daysDiff + " jours";
        }
        let title = "Quitter Rupture by Cobham ?"
        let body = [];

        body.push("Vous allez quitter Rupture by Cobham. Si vous avez besoin de compléter le dossier et "
            + "d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail.");

        body.push("Merci de noter que le lien expirera " + expireString + ", soit le " + 
            formatDate(this.delegationTokenExpirationDate, "longDate", userLocale)
            + ". Au-delà de ce délai, il faudra demander à " + this.clientName + " de " + this.company
            + " de vous renvoyer un nouveau lien pour compléter votre dossier.");

        let dialogRef = this.dialog.open(DialogQuestionMessage, {
            width: '50%',
            data: {
                title: title,
                body: body,
            }
        })

        dialogRef.afterClosed().subscribe(result => {
            if (result.positive) {
                this.router.navigateByUrl("/");
            }
        });
    }
    delegationSkipCreation() {
        this.helperOn = false;
        // this.uploadBulletin = false;
        this.consumeToken = true;
    }
    
    seeCreditsDetails(){
        const dialogRef = this.dialog.open(DialogCredits, {
            width: '100%',
            // panelClass: 'instruction-dialog',
            panelClass: 'dialog-credits',
            data: this.credits
        });
    }
    
    prevPaiement() {
        window['tryga']('send', 'event', 'dossier', 'precedent_cobham_paie_validation', '', '');
    }
    
    submitCreditAction(action : string, param) {
        switch(action) {
            case "coupon" :
                this.checkCoupon(param);
                break;
            case "buy-credits":
                this.router.navigate(["/tarifs"], {state: {directDevis: true}});
                break;
            default:
                break;
        }
    }
    
    checkCoupon(codeCoupon){
        this.required = [];
        if(this.subscribe && this.subscribe['checkCoupon']){
            this.subscribe['checkCoupon'].unsubscribe();
        }
        this.subscribe['checkCoupon'] = this.customerService.checkCoupon(codeCoupon).subscribe((res)=>{
        window['tryga']('send', 'event', 'dossier', 'consommer_un_coupon', '', '');
            if(res && res.result){
                this.couponId = res.result
                // this.uploadBulletin = false;
                if (this.toDelegate == true) {
                    this.fillDelegationForm = true;
                }
                this.required['codeCoupon'] = false;
                this.goToStep(this.myStepper);
            }else{
                this.required['codeCoupon'] =true
            }
        })
    }
    // checkCredit() {
    //     window['tryga']('send', 'event', 'dossier', 'consommer_un_credit', '', '');
    //     // this.uploadBulletin = false
    //     if (this.toDelegate == true) {
    //         this.fillDelegationForm = true;
    //     }
    // }
        
    
    
    async submitCreatDoss() {
        console.log('*** submitCreatDoss')
        let dossier = this.firstFormGroup.getRawValue();
        console.log("DOSSIER ENVOYE :", dossier)
        if (!this.dossier || !this.dossier.id){
        await new Promise(resolve => this.appService.addDossier(dossier.civiliteSala, (dossier.siret ? dossier.siret : ""), dossier.firstnameSala, dossier.nameSala, dossier.nameEntSala, dossier.postSala,
            dossier.dateContSala, '' /*this.dossier_add_datedebperiode*/, dossier.dateContSortieSala, dossier.typeSala,
            '', dossier.motifSala, dossier.maladieSala, dossier.dateMaladieSala, '' /*this.dossier_add_datefinperiode*/,
            dossier.contRompu, dossier.dateRupt, dossier.nomDateRupt, dossier.boolRupt, this.couponId,
            dossier.pseudoSalarie, dossier.pseudoEntreprise, dossier.isAnonyme
            ).subscribe((res) => {
            this.dossier = res.result.dossier;
            this.dossier.datedebut = dossier.dateContSala;
            this.dossier.datesortie = dossier.dateContSortieSala;
            this.dossier.poste = dossier.postSala;
            this.dossier.motifsortie = dossier.motifSala;
            this.stateService.updateDossier(this.dossier);
            this.titleService.setTitle("Rupture by Cobham - dossier "+this.dossier.displayID+ " - "+this.dossier.prenom+" "+this.dossier.nom);

            //ajoute le fichier de bs en base et le lie au dossier(plus le cas suite ticket 5484)
            /*if (this.dataFromUploadedFile && Object.keys(this.dataFromUploadedFile).length > 0) {
                this.appService.processRecoResponse(this.dossier.id, this.dataFromUploadedFile).subscribe(() => {
                  this.dataFromUploadedFile = null;
                });
            }*/

            //ajoute tous les entetes pour maj données de l'employeur
            const data = {...this.firstFormGroup.getRawValue(), ...this.getDataEnteteEntreprise()};
            this.appService.addDossierEntete(this.dossier.id, data).subscribe((res)=>{
                if(res.result && res.result.entete){
                    this.dossier.entete = res.result.entete;
                }
                this.setupDataBlock(false);
            })
                
            // // 1645 après la création du dossier, on initialise les services à activer ou non
            // this.dossier_add_subscribe['json1'] = this.httpClient.get('assets/content-dossierpost.json?v='+window['cobham_version']).subscribe((res)=>{
            //     let services = res['services']
            //     services.forEach((service) => {
            //         this.appService.updateService(this.dossier.id, service,dossier.boolRupt == "TRUE" ? 'Diag' : 'Simul', (service.actif && service.selected) ? 'ADD' : 'REMOVE').subscribe((res)=>{})
            //     })
            // })
            
            resolve(true);
        }));
        }
    // });
    return true;
    }

    quitDelegation() {
        let userLocale = this.getUsersLocale("fr");
        let daysDiff = this.dateDiffInDays(new Date(), this.delegationTokenExpirationDate);
        let expireString = "";
        
        if (daysDiff == 1 ) {
        expireString = "demain";
        } else {
        expireString = "dans " + daysDiff + " jours";
        }
        let title = "Quitter Rupture by Cobham ?"
        let body = [];

        body.push("Vous allez quitter Rupture by Cobham. Les données que vous avez saisies et les documents"
        + " que vous avez commencé à charger sont mémorisés. ")

        body.push("Si vous avez besoin de compléter le dossier et "
        + "d'ajouter de nouveaux documents, merci de cliquer de nouveau sur le lien que vous avez reçu par mail.");

        body.push("Merci de noter que le lien expirera " + expireString + ", soit le " + 
        formatDate(this.delegationTokenExpirationDate, "longDate", userLocale)
        + ". Au-delà de ce délai, il faudra demander à " + this.clientName + " de " + this.company
        + " de vous renvoyer un nouveau lien pour compléter votre dossier.");

        let dialogRef = this.dialog.open(DialogQuestionMessage, {
        width: '50%',
        data: {
            title: title,
            body: body,
        }
        })

        dialogRef.afterClosed().subscribe(result => {
        if (result.positive) {
            this.router.navigateByUrl("/");
        }
        });
    }
    
    displayIDCC(option) {
        return option ? option.Libelle : undefined;
    }
    
    private _filterIDCC(Libelle: string): [] {
        const filterValue = Libelle.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');// remove accents
        return this.optionsIDCC.filter(option => option.Libelle.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').indexOf(filterValue) > -1 || option.Value.toString().indexOf(filterValue) > -1);
    }

    changeIdcc(new_value) {
        this.errorSelectCC = false;
        this.dataEmpFormGroup.get('IDCC_CC').setValue(new_value); 
        this.dataEmpFormGroup.get('CC_SECTEUR').setValue(""); 
        this.dataEmpFormGroup.get('LIB_CC').setValue(""); 
        this.dataEmpFormGroup.get('CC_TERRITOIRE').setValue(""); 
        this.dataEmpFormGroup.get('BOOL_ADH_SYND_SIGNATAIRE').setValue("FALSE"); 
        this.cdf.detectChanges();
        this.updateCCparam();
    }

    updateDossierData() {
        let dossierForm = this.firstFormGroup.getRawValue();
        this.appService.updateDossier(
            this.dossier.id,
            dossierForm.civiliteSala || "",
            (dossierForm.siret ? dossierForm.siret : ""),
            dossierForm.firstnameSala || "",
            dossierForm.nameSala || "",
            dossierForm.nameEntSala || "",
            dossierForm.postSala || "",
            dossierForm.dateContSala || "",
            dossierForm.datedebperiodeSala || "",
            dossierForm.dateContSortieSala || "",
            dossierForm.typeSala || "",
            dossierForm.statutsalarieSala || "",
            dossierForm.motifSala || "",
            dossierForm.pseudoSalarie || "",
            dossierForm.pseudoEntreprise || "",
            dossierForm.isAnonyme || "",
            {}
        ).subscribe((res) => {
            if(res.result && res.result.dossier){
                this.dossier = res.result.dossier;
                this.updateDossierComparateur(this.dossier);
                this.setupDataBlock();
                this.cdf.detectChanges();
            }
        });
    }

    setMailLinkCC(): void {
        const subject = 'Demande de convention collective';
        let body = '';
        body += 'Bonjour,\n\n';
        body += `Dans le cadre d’un dossier de calcul d’indemnité de rupture, j’aurais besoin de la convention collective NOM_CONVENTION.\n\n`;
        body += "J’ai bien noté qu’un délai de 48 heures est nécessaire pour sa mise à disposition.\n\n";
        body += 'Cordialement,\n\n';

        const civilite = this.user.civilite ? this.user.civilite.charAt(0).toUpperCase() + this.user.civilite.slice(1) + ' ' : '';
        const firstname = this.user.firstname ? this.user.firstname + ' ' : '';
        const name = this.user.name ? this.user.name : '';
        body += `${civilite}${firstname}${name}`.trim();

        if (this.user.firm && this.user.firm.trim() !== '') {
            body += `\n\n${this.user.firm.trim()}`;
        }

        if (this.user.email && this.user.email.trim() !== '') {
            body += `\n\n\n\n${this.user.email.trim()}`;
        }

        this.mailLinkCC = `mailto:support@cobham-solutions.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    }

    checkCpEmp() {
        const value = this.dataEmpFormGroup.get('CP_EMP').value;
        const regex = /^[0-9]{5}$/;
        this.required['CP_EMP'] = null;
        this.errorCpEmp = !regex.test(value);
        if(this.dataEmpFormGroup.get('IDCC_CC_autocomplete').value && !this.errorCpEmp){
            this.updateCCparam();
        }
        this.cdf.detectChanges();
    }

    filterIDCCByDates() {
        if (!this.allOptionsIDCC.length) return;
        if (this.simulation) {
            this.optionsIDCC = this.allOptionsIDCC.filter(idcc => {
                return idcc.Dates.some(date => !date.DateFin);
            });
        }
        else if (this.diagnostic) {
            const dateContSortieSala = this.firstFormGroup.get('dateContSortieSala').value;
            if (!dateContSortieSala) {
                this.optionsIDCC = this.allOptionsIDCC;
            } else {
                const dateDesFaits = new Date(dateContSortieSala);
                this.optionsIDCC = this.allOptionsIDCC.filter(idcc => {
                    if (!idcc.Dates || !idcc.Dates.length) return true;
                    return idcc.Dates.some(date => {
                        const dateEnt = new Date(date.DateEnt);
                        const dateFin = date.DateFin ? new Date(date.DateFin) : null;
                        return dateDesFaits >= dateEnt && (!dateFin || dateDesFaits <= dateFin);
                    });
                });
            }
        }
        else {
            this.optionsIDCC = this.allOptionsIDCC;
        }
        if (this.dataEmpFormGroup) {
            const currentValue = this.dataEmpFormGroup.get('IDCC_CC_autocomplete').value;
            if (currentValue) {
                const currentIDCC = currentValue.Value;
                if (currentIDCC) {
                    const stillExists = this.optionsIDCC.some(idcc => idcc.Value == currentIDCC);
                    if (!stillExists) {
                        this.dataEmpFormGroup.get('IDCC_CC_autocomplete').setValue(null);
                        this.changeIdcc('');
                    }
                }
            }
        }

        this.cdf.detectChanges();
    }

    // Vérifie si l'employé à +16ans au moment des faits
    checkBirthDateValidity(date: string): boolean {
        if (!date) return false;

        const birthDate = new Date(date);
        const today = new Date();
        const minAllowedDate = new Date(
            today.getFullYear() - 16,
            today.getMonth(),
            today.getDate()
        );
        if (birthDate < minAllowedDate) {
            return false;
        }
        return true;
    }

    processLastBsEntete(){
        this.appService.getLastBsEntete(this.dossier.id).subscribe((res)=>{
            if(res.result){
                if(res.result['IDCC_CC'] && res.result['IDCC_CC'].value){
                    this.lastBsIDCC = {numCC: res.result['IDCC_CC'].value}
                    this.findBsIDCCLibelle();
                    this.cdf.detectChanges();
                }
            }
        })
    }

    findBsIDCCLibelle(){
        if(this.allOptionsIDCC && this.lastBsIDCC && this.lastBsIDCC.numCC){
            const matchingCC = this.allOptionsIDCC.find((cc)=>cc.Value == this.lastBsIDCC.numCC);
            if(matchingCC){
                this.lastBsIDCC['libelle'] = matchingCC['Libelle'];
                this.cdf.detectChanges();
            }
        }
    }

    handleSetDataEmitter(event){
        if (event.var === 'entrepriseInfo') {
            this.entrepriseInfo = event.value;
        }
        if (event.var === 'dateErr') {
            this.dateErr = event.value;
        }
    }

    handleActionEmitter(event){
        const action = event.action;
        const data = event.data;
        if(action == "step"){
            this.goToStep(this.myStepper);
        }
        else if(action =="doc"){
            this.openDialogDocuments();
        }
        else if(action =="rapport" && data){
            this.seeRapport(data);
        }
        else{
            console.log("event non reconnue",event)
        }
    }




}
